






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ParamsList from '@/components/ParamsList.vue';
import { getEnv } from '@/runtime-config';
import ResultView from '@/components/ResultView.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import AutoApprovalTab from '@/components/UI/AutoApprovalTab.vue';
import {ITableHeaders, TableHeaders} from '@/interfaces/components-data';
import DatePicker from 'vue2-datepicker';
import DatePickerRange from '@/components/UI/DatePicker.vue';
import {ISupersetFields} from '@/interfaces/common'
import {
  CalcIndividualConfig,
  CodeOKRB,
  Coefficents,
  ConfigMap,
  FindFiltersParams,
  IndividualConfig,
  RoundingRulesFilterType,
  roundingRulesFilterTypeLabels,
  SelectBox,
  SelectMarket,
  StrategyOfPriceOpt,
  TaskInfoCalc,
} from '@/interfaces/global-data';
import {
    BaseFilter,
    BaseFilterRoundingRules,
    CalcFilters,
    CalcIndividualConfigMap,
    CategoryStrategies,
    CompetitorNameAndFilter,
    CompetitorsPriceFilter,
    competitorsPriceMethodsSb,
    CompetitorsPriceStrategies,
    competitorsPriceStrategiesSb,
    FileType,
    GetTaskInfo,
    ICompetitorPricesFilterOptions,
    IndividualConfigCmd,
    InternalCodeAndProductRange,
    KviStrategies,
    kviStrategiesSet,
    NewProductPriceStrategy,
    PercentileTypes,
    ProductSegmentIdAndName,
    RegularCompetitorsPricesView,
    RoundingRulesFilter,
    Segment,
    Sku,
    SkuFilter,
    SmallEventFilterTree,
    SortingField,
    TaskAndFile,
    TaskData,
    TaskInfoFilterType,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {parseRisonForSP} from '@/utils/parseRisonForSP'
import {BFormFile, BTabs, BvModalEvent} from 'bootstrap-vue';
import _ from 'lodash';
import moment from 'moment';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import {CompetitorsPriceRow, ICompetitorsTableFilterValues} from "@/interfaces/competitors-price-row";
import CollapseCard from "@/components/UI/CollapseCard.vue"
import {BTable} from "bootstrap-vue/src/components/table";
import Card from '@/components/UI/Card.vue';
import Modal from '@/components/UI/Modal.vue';
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';
@Component({
    components: {
        ParamsList,
        ResultView,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        AutoApprovalTab,
        LocalData,
        HintsContainer,
        DatePicker,
        DatePickerRange,
        CollapseCard,
        Card,
        Modal,
        CSelect,
        ColumnTitleContent,
        SwitchWithLabel
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD.MM.YYYY');
            }
        },
        formatRulesDate: (v: any) => {
            if (v) {
                return moment(moment.utc(v)).local().format('DD/MM/YYYY HH:mm:ss');
            }
        },
        formatCompetitorsDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('YYYY-MM-DD');
            }
        },
    },
    methods: {
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') {
                    return 'table-primary';
                }
                if (item.resultType === 'COMPETITOR') {
                    return 'table-danger';
                }
            }
        },
        formatNumber(number) {
            if (String(number)[0] === '-') {
                return String(number).substring(0, 4);
            } else {
                return String(number).substring(0, 3);
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
        replaceTxtToNumberForRoundingRules(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
    },
})
export default class Calc extends Mixins(LocalData, Toast, Http) {

    /*get saveStateForRoundingRules(): boolean {
        return !((this.$roundingRules.groupOfProduct != null && this.$roundingRules.groupOfProduct > 0)
                || (this.$roundingRules.categoryOfProduct != null && this.$roundingRules.categoryOfProduct > 0))
    }*/

    panelSkuModal: boolean = false;

    get saveStateForRoundingRules(): boolean {
        return (this.$roundingRules.selectMarket.id == null)
    }

    get paramsSum(): boolean {
        const u = this.$calc.uvwParams.u;
        const v = this.$calc.uvwParams.v;
        const w = this.$calc.uvwParams.w;
        if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
            return false;
        }
        const sum = (+v + +u + +w);
        return sum === 100;
    }

    get paramsSumXYZ(): boolean {
        const x = this.$calc.xyzParams.x;
        const y = this.$calc.xyzParams.y;
        const z = this.$calc.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get paramsSumXYZForSetupMaster(): boolean {
        const x = this.$setupMasterCalc.xyzParams.x;
        const y = this.$setupMasterCalc.xyzParams.y;
        const z = this.$setupMasterCalc.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get calculationDepthValidate(): boolean {
        return this.$calc.calculationDepth * 7 >= this.$calc.calculationDay;
    }

    get setupMasterCalculationDepthValidate(): boolean {
        return this.$setupMasterCalc.calculationDepth * 7 >= this.$setupMasterCalc.calculationDay;
    }

    get calculationDayValidate(): boolean {
        return this.$calc.calculationDay > 0;
    }

    get setupMasterCalculationDayValidate(): boolean {
        return this.$setupMasterCalc.calculationDay > 0;
    }

    get priceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.$calc.priceIncreaseLimit;
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;
    }

    get setupMasterPriceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.$setupMasterCalc.priceIncreaseLimit;
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;
    }

    get priceDecreaseLimitValidate(): boolean {
        const priceDecreaseLimit = this.$calc.priceDecreaseLimit;
        return priceDecreaseLimit != null && priceDecreaseLimit.toString() !== '' && priceDecreaseLimit >= 0;
    }

    get setupMasterPriceDecreaseLimitValidate(): boolean {
        const priceDecreaseLimit = this.$setupMasterCalc.priceDecreaseLimit;
        return priceDecreaseLimit != null && priceDecreaseLimit.toString() !== '' && priceDecreaseLimit >= 0;
    }

    get kviPriceDecreaseLimitValidate(): boolean {
        const kviPriceDecreaseLimit = this.$calc.kviPriceDecreaseLimit;
        return kviPriceDecreaseLimit != null && kviPriceDecreaseLimit.toString() !== '' && kviPriceDecreaseLimit >= 0;
    }

    // Геттер для параметров автосогласования
    get autoApprovalParams() {
        if (!this.$calc.autoApprovalParams) {
            this.$calc.autoApprovalParams = this.getDefaultAutoApprovalParams();
        }
        return this.$calc.autoApprovalParams;
    }

    set autoApprovalParams(params) {
        this.$calc.autoApprovalParams = { ...params };
    }

    getDefaultAutoApprovalParams() {
        return {
            useAutoApproval: false,
            priceChangePercentage: undefined,
            piPercentage: undefined,
            minimumSkuProfitability: undefined,
            marginChangePercentagePoints: undefined,
            revaluationEfficiencyCheck: false
        };
    }

    get setupMasterKviPriceDecreaseLimitValidate(): boolean {
        const kviPriceDecreaseLimit = this.$setupMasterCalc.kviPriceDecreaseLimit;
        return kviPriceDecreaseLimit != null && kviPriceDecreaseLimit.toString() !== '' && kviPriceDecreaseLimit >= 0;
    }

    get compPriceDecreaseLimitValidate(): boolean {
        const compPriceDecreaseLimit = this.$calc.compPriceDecreaseLimit;
        return compPriceDecreaseLimit != null && compPriceDecreaseLimit.toString() !== '' && compPriceDecreaseLimit >= 0;
    }

    get setupMasterCompPriceDecreaseLimitValidate(): boolean {
        const compPriceDecreaseLimit = this.$setupMasterCalc.compPriceDecreaseLimit;
        return compPriceDecreaseLimit != null && compPriceDecreaseLimit.toString() !== '' && compPriceDecreaseLimit >= 0;
    }

    get competitorsPricesValidate(): boolean {
        const competitorsP = this.$calc.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get setupMasterCompetitorsPricesValidate(): boolean {
        const competitorsP = this.$setupMasterCalc.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get percentageOfRecommendsKviValidate(): boolean {
        const kviRecommends = this.$calc.percentageOfRecommendsKviCount.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);
        return numberPattern.test(kviRecommends);
    }

    get marginalPriceDifferenceValidate(): boolean {
        if (this.$calc.marginalPriceDifference != null) {
            return this.$calc.marginalPriceDifference >= 0 && this.$calc.marginalPriceDifference <= 100;
        }
        return false;
    }

    get newProductLifespanInDaysValidate(): boolean {
        if (this.$calc.newProductLifespanInDays != null) {
            return this.$calc.newProductLifespanInDays >= 0 && this.$calc.newProductLifespanInDays <= 100;
        }
        return false;
    }

    get marginalProfitabilityValidate(): boolean {
        const marginalProfitability = this.$calc.marginalProfitability;
        if (marginalProfitability < 0) {
            this.marginalSkuErrorText = this.$t('regular.validation.negativeProfit') as string
        } else {
            this.marginalSkuErrorText = ''
        }
        return marginalProfitability < 100;
    }

    get competitorsMinProfitValidate(): boolean {
        const competitorsMinimumProfit = this.$calc.competitorsMinimumProfit;
        return competitorsMinimumProfit.toString() !== '';
    }

    get competitorsMaximumProfitValidate(): boolean {
        const competitorsMaximumProfit = this.$calc.competitorsMaximumProfit != null ? this.$calc.competitorsMaximumProfit : 100;
        const competitorsMinimumProfit = this.$calc.competitorsMinimumProfit != null ? this.$calc.competitorsMinimumProfit : 0;
        return competitorsMaximumProfit >= competitorsMinimumProfit && competitorsMaximumProfit <= 100;
    }

    get setupMasterCompetitorsMinProfitValidate(): boolean {
        const competitorsMinimumProfit = this.$setupMasterCalc.competitorsMinimumProfit;
        return competitorsMinimumProfit.toString() !== '';
    }

    get isCategoryStrategySelected(): boolean {
        return this.$calc.categoryStrategy && this.$calc.categoryStrategy.value !== CategoryStrategies.EMPTY;
    }

    get priceGapValidate(): boolean {
        const priceGap = this.$calc.priceGap;
        return priceGap.toString() !== '' && priceGap >= 0;
    }

    get priceGapCtmPcValidate(): boolean {
        const priceGapCtm = this.$calc.priceGapCtmPc;
        return priceGapCtm !== null && priceGapCtm.toString() !== '' && priceGapCtm >= 0 && priceGapCtm <= 100;
    }

    get minProfitKVIValidate(): boolean {
        const minProfitKvi = this.$calc.minProfitKVI;
        return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get maxProfitKVIValidate(): boolean {
        const maxProfitKVI = this.$calc.maxProfitKVI != null ? this.$calc.maxProfitKVI : 100;
        const minProfitKVI = this.$calc.minProfitKVI != null ? this.$calc.minProfitKVI : 0;
        return maxProfitKVI >= minProfitKVI && maxProfitKVI <= 100;
    }

    get setupMasterMinProfitKVIValidate(): boolean {
        const minProfitKvi = this.$setupMasterCalc.minProfitKVI;
        return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get marginalProfitValidate(): boolean {
        const marginalProfit = this.$calc.marginalProfit;
        if (marginalProfit < 0) {
            this.marginalErrorText = this.$t('regular.validation.negativeProfit') as string
        } else {
            this.marginalErrorText = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    get maxMarginalProfitValidate(): boolean {
        const maxMarginalProfit = this.$calc.maxMarginalProfit != null ? this.$calc.maxMarginalProfit : 100;
        const marginalProfit = this.$calc.marginalProfit != null ? this.$calc.marginalProfit : 0;
        if (maxMarginalProfit < marginalProfit) {
            this.maxMarginalErrorText = this.$t('regular.validation.maxProfitGteMin') as string
        } else if (maxMarginalProfit > 100) {
            this.maxMarginalErrorText = this.$t('regular.validation.maxProfitLte100') as string
        } else {
            this.maxMarginalErrorText = ''
        }
        return maxMarginalProfit >= marginalProfit && maxMarginalProfit <= 100;
    }

    get setupMasterMarginalProfitValidate(): boolean {
        const marginalProfit = this.$setupMasterCalc.marginalProfit;
        if (marginalProfit < 0) {
            this.marginalErrorTextForSetupMaster = this.$t('regular.validation.negativeProfit') as string
        } else {
            this.marginalErrorTextForSetupMaster = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    get marginalProfitDeclinePcValidate(): boolean {
        const declineProfitabilityPc = this.$calc.declineProfitabilityPc;
        return declineProfitabilityPc != null && declineProfitabilityPc < 100;
    }

    get globalIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalIndividualMarginalErrorText = this.$t('regular.validation.negativeProfit') as string
            } else {
                this.globalIndividualMarginalErrorText = ''
            }
            this.globalIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalNewProductIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualNewProductMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalNewProductIndividualMarginalErrorText = this.$t('regular.validation.negativeProfit') as string
            } else {
                this.globalNewProductIndividualMarginalErrorText = ''
            }
            this.globalNewProductIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalIndividualPeriodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.globalIndividualPeriodPriceIncreaseLimit;
        if (periodPriceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPeriodPriceIncreaseLimitBlockButton = periodPriceIncreaseLimit < 0;
            return periodPriceIncreaseLimit >= 0;
        }
    }

    get globalIndividualPriceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.globalIndividualPriceIncreaseLimit;
        if (priceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPriceIncreaseLimitBlockButton = priceIncreaseLimit < 0 || priceIncreaseLimit > 100;
            return priceIncreaseLimit >= 0 && priceIncreaseLimit < 100;
        }
    }

    get decreaseSalesCountValidate(): boolean {
        const decreaseSalesCount = this.$calc.decreaseSalesCount;
        return decreaseSalesCount != null && decreaseSalesCount >= 0 && decreaseSalesCount < 100;
    }

    get setupMasterDecreaseSalesCountValidate(): boolean {
        const decreaseSalesCount = this.$setupMasterCalc.decreaseSalesCount;
        return decreaseSalesCount != null && decreaseSalesCount >= 0 && decreaseSalesCount < 100;
    }

    get priceChangeLimitValidate(): boolean {
        const priceChangeLimit = this.$calc.priceChangeLimit;
        return priceChangeLimit.toString() !== '' && priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    get setupMasterPriceChangeLimitValidate(): boolean {
        const priceChangeLimit = this.$setupMasterCalc.priceChangeLimit;
        return priceChangeLimit.toString() !== '' && priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    get priceChangeLimitKviValidate(): boolean {
      const priceChangeLimitKvi = this.$calc.priceChangeLimitKvi;
      return priceChangeLimitKvi != null
          && priceChangeLimitKvi.toString() !== ''
          && priceChangeLimitKvi >= 0
          && priceChangeLimitKvi < 100
    }

    // TODO: удостовериться нужен ли он
    get setupMasterPriceChangeLimitKviValidate(): boolean {
        const priceChangeLimitKvi = this.$setupMasterCalc.priceChangeLimitKvi;
        return priceChangeLimitKvi.toString() !== '' && priceChangeLimitKvi >= 0 && priceChangeLimitKvi < 100;
    }

    get priceChangeLimitCompValidate(): boolean {
      const priceChangeLimitComp = this.$calc.priceChangeLimitComp;
      return priceChangeLimitComp != null
          && priceChangeLimitComp.toString() !== ''
          && priceChangeLimitComp >= 0
          && priceChangeLimitComp < 100
    }

    // TODO: удостовериться нужен ли он
    get setupMasterPriceChangeLimitCompValidate(): boolean {
        const priceChangeLimitComp = this.$setupMasterCalc.priceChangeLimitComp;
        return priceChangeLimitComp.toString() !== '' && priceChangeLimitComp >= 0 && priceChangeLimitComp < 100;
    }

    get countPriceSegmentsValidate(): boolean {
        const countSegments = this.countPriceSegments;
        return countSegments.toString() !== '' && countSegments > 0;
    }

    get setupMasterCountPriceSegmentsValidate(): boolean {
        const countSegments = this.countPriceSegmentsForSetupMaster;
        return countSegments.toString() !== '' && countSegments > 0;
    }

    get periodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.$calc.periodPriceIncreaseLimit;
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    get setupMasterPeriodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.$setupMasterCalc.periodPriceIncreaseLimit;
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    get inputInterval(): boolean {
        const lowerI = this.$calc.intervalOfUltimateElasticity.lower.toString();
        const upperI = this.$calc.intervalOfUltimateElasticity.upper.toString();
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get inputIntervalP(): boolean {
        if (this.isDisabledPriceBorder) {
            return true;
        }
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return false;
        }
        const lowerI = this.$calc.priceCorridor.min.toString();
        const upperI = this.$calc.priceCorridor.max.toString();
        if (this.$calc.priceCorridor.min >= this.$calc.priceCorridor.max || this.$calc.priceCorridor.min >= this.$calc.priceCorridor.max) {
            return false;
        }
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get setupMasterInputIntervalP(): boolean {
        if (this.isDisabledPriceBorderForSetupMaster) {
            return true;
        }
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null) {
            return false;
        }
        const lowerI = this.$setupMasterCalc.priceCorridor.min.toString();
        const upperI = this.$setupMasterCalc.priceCorridor.max.toString();
        if (this.$setupMasterCalc.priceCorridor.min >= this.$setupMasterCalc.priceCorridor.max || this.$setupMasterCalc.priceCorridor.min >= this.$setupMasterCalc.priceCorridor.max) {
            return false;
        }
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get correlationCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const correlation = this.$calc.correlation.toString();
        if (correlation.length === 0 || !numberPattern.test(correlation)) {
            if (this.$calc.selectMarket != null) {
            }
            return false;
        }
        const cor = parseFloat(correlation);
        return 1 >= cor && cor >= -1;

    }

    get highElasticityCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const highElasticity = this.$calc.highElasticity.toString();
        this.$log.debug(highElasticity.length > 0, numberPattern.test(highElasticity));
        return numberPattern.test(highElasticity);
    }

    get calcButt(): boolean {
        return this.calcButtonState();
    }

    get isDisabledPriceBorder(): boolean {
        return !this.$calc.changePriceCorridor;
    }

    get isDisabledPriceBorderForSetupMaster(): boolean {
        return !this.$setupMasterCalc.changePriceCorridor;
    }

    get isCategorySelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$calc.categoryOfProduct != null && this.$calc.categoryOfProduct!! > 0;
    }

    get isSubcategorySelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$calc.subcategories != null && this.$calc.subcategories.length!! > 0;
    }

    get isCategorySelectedForSetupMaster(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$setupMasterCalc.categoryOfProduct != null && this.$setupMasterCalc.categoryOfProduct!! > 0;
    }


    get isSubCategorySelectedForSetupMaster(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$setupMasterCalc.subcategories != null && this.$setupMasterCalc.subcategories.length!! > 0;
    }

    get isCategorySelectedForRoundingRules(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$roundingRules.categoryOfProduct != null && this.$roundingRules.categoryOfProduct!! > 0;
    }

    get isSubCategorySelectedForRoundingRules(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$roundingRules.subcategories != null && this.$roundingRules.subcategories.length!! > 0;
    }

    get isGroupSelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$calc.groupOfProduct != null && this.$calc.groupOfProduct!! > 0;
    }

    get isGroupSelectedForRoundingRules(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$roundingRules.groupOfProduct != null && this.$roundingRules.groupOfProduct!! > 0;
    }

    get isGroupSelectedForSetupMaster(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$setupMasterCalc.groupOfProduct != null && this.$setupMasterCalc.groupOfProduct!! > 0;
    }

    get competitorPriceControlParameterPcValidate(): boolean {
        return this.$calc.competitorPriceControlParameterPc.toString() !== ''
            && this.$calc.competitorPriceControlParameterPc > 0 && this.$calc.competitorPriceControlParameterPc <= 100;
    }

    get competitorPriceControlParameterPcValidateForSetupMaster(): boolean {
        return this.$setupMasterCalc.competitorPriceControlParameterPc.toString() !== ''
            && this.$setupMasterCalc.competitorPriceControlParameterPc > 0 && this.$setupMasterCalc.competitorPriceControlParameterPc <= 100;
    }

    get daysToPriceChangeStartValidate(): boolean | null {
        if (this.$calc.daysToPriceChangeStart == null || this.$calc.daysToPriceChangeStart === 0) {
            return null; // null означает, что поле не заполнено (опциональное)
        }
        return this.$calc.daysToPriceChangeStart > 0;
    }

    get daysToPriceChangeFinishValidate(): boolean | null {
        if (this.$calc.daysToPriceChangeFinish == null || this.$calc.daysToPriceChangeFinish === 0) {
            return null; // null означает, что поле не заполнено (опциональное)
        }
        if (this.$calc.daysToPriceChangeFinish <= 0) {
            return false;
        }
        // Проверяем, что finish >= start, если оба заполнены
        if (this.$calc.daysToPriceChangeStart != null && this.$calc.daysToPriceChangeStart > 0) {
            return this.$calc.daysToPriceChangeFinish >= this.$calc.daysToPriceChangeStart;
        }
        return true;
    }

    get daysToPriceChangeStartValidateForSetupMaster(): boolean | null {
        if (this.$setupMasterCalc.daysToPriceChangeStart == null || this.$setupMasterCalc.daysToPriceChangeStart === 0) {
            return null;
        }
        return this.$setupMasterCalc.daysToPriceChangeStart > 0;
    }

    get daysToPriceChangeFinishValidateForSetupMaster(): boolean | null {
        if (this.$setupMasterCalc.daysToPriceChangeFinish == null || this.$setupMasterCalc.daysToPriceChangeFinish === 0) {
            return null;
        }
        if (this.$setupMasterCalc.daysToPriceChangeFinish <= 0) {
            return false;
        }
        if (this.$setupMasterCalc.daysToPriceChangeStart != null && this.$setupMasterCalc.daysToPriceChangeStart > 0) {
            return this.$setupMasterCalc.daysToPriceChangeFinish >= this.$setupMasterCalc.daysToPriceChangeStart;
        }
        return true;
    }

    setNonNegativeInteger(input: string): string {
        const parsed = parseInt(input, 10);
        if (isNaN(parsed)) {
            return input;
        }
        if (parsed < 0) {
            return '0';
        }
        return parsed.toString();
    }

    get enableDepthToPurchasePrice(): boolean {
        return (this.$calc.countByAvgPurchasePrice && this.$calc.useArrivalDate)
            || (!this.$calc.countByAvgPurchasePrice && !this.$calc.countAtMaxPurchasePrice);
    }

    get enableDepthToPurchasePriceForSetupMaster(): boolean {
        return (this.$setupMasterCalc.countByAvgPurchasePrice && this.$setupMasterCalc.useArrivalDate) || (!this.$setupMasterCalc.countByAvgPurchasePrice && !this.$setupMasterCalc.countAtMaxPurchasePrice);
    }

    get backBasketPartValidate(): boolean {
        if (this.$calc.backBasketPart != null) {
            return this.$calc.backBasketPart >= 0 && this.$calc.backBasketPart <= 100;
        }
        return false;
    }

    get priceExperimentSampleSizeValidate(): boolean | null {
        if (!this.$calc.priceExperiment) {
            return null;
        }
        if (this.$calc.priceExperimentSampleSize == null) {
            return false;
        }
        return this.$calc.priceExperimentSampleSize >= 0 && this.$calc.priceExperimentSampleSize <= 100;
    }

    get priceExperimentDiscountRangeFromValidate(): boolean | null {
        if (!this.$calc.priceExperiment) {
            return null;
        }
        if (this.$calc.priceExperimentDiscountRangeFrom == null) {
            return null;
        }
        const from = this.$calc.priceExperimentDiscountRangeFrom;
        const to = this.$calc.priceExperimentDiscountRangeTo;
        if (from < -100 || from > 100) {
            return false;
        }
        if (to != null && from > to) {
            return false;
        }
        return true;
    }

    get priceExperimentDiscountRangeToValidate(): boolean | null {
        if (!this.$calc.priceExperiment) {
            return null;
        }
        if (this.$calc.priceExperimentDiscountRangeTo == null) {
            return null;
        }
        const from = this.$calc.priceExperimentDiscountRangeFrom;
        const to = this.$calc.priceExperimentDiscountRangeTo;
        if (to < -100 || to > 100) {
            return false;
        }
        if (from != null && to < from) {
            return false;
        }
        return true;
    }

    get priceExperimentStepValidate(): boolean | null {
        if (!this.$calc.priceExperiment) {
            return null;
        }
        if (this.$calc.priceExperimentStep == null) {
            return null;
        }
        return this.$calc.priceExperimentStep >= 1 && this.$calc.priceExperimentStep <= 100;
    }

    get priceExperimentDateRange(): string[] {
        const startDate = this.$calc.priceExperimentStartDate;
        const endDate = this.$calc.priceExperimentEndDate;
        if (startDate && endDate) {
            return [startDate, endDate];
        }
        // Возвращаем дефолтные даты: сегодня и +7 дней
        const today = moment().format('YYYY-MM-DD');
        const endDateDefault = moment().add(7, 'days').format('YYYY-MM-DD');
        // Устанавливаем дефолтные значения в $calc, если они не заданы и ценовой эксперимент включен
        if (this.$calc.priceExperiment && (!startDate || !endDate)) {
            this.$calc.priceExperimentStartDate = today;
            this.$calc.priceExperimentEndDate = endDateDefault;
            this.saveCalc();
        }
        return [today, endDateDefault];
    }

    changePriceExperimentDateRange(dateRange: string[]) {
        if (dateRange && dateRange.length === 2) {
            this.$calc.priceExperimentStartDate = dateRange[0];
            this.$calc.priceExperimentEndDate = dateRange[1];
            this.saveCalc();
        } else {
            this.$calc.priceExperimentStartDate = null;
            this.$calc.priceExperimentEndDate = null;
            this.saveCalc();
        }
    }

    handleStrategyValidityBeginDateChange(date: string) {
        this.$calc.strategyValidityBeginDate = date;
        this.saveCalc();
    }

    handleStrategyValidityEndDateChange(date: string) {
        this.$calc.strategyValidityEndDate = date;
        this.saveCalc();
    }

    disabledStrategyValidityBeginDate(date: Date): boolean {
        const endDate = this.$calc.strategyValidityEndDate;

        if (!endDate) {
            return false;
        }

        return moment(date).isAfter(moment(endDate, 'YYYY-MM-DD'), 'day');
    }

    disabledStrategyValidityEndDate(date: Date): boolean {
        const beginDate = this.$calc.strategyValidityBeginDate;

        if (!beginDate) {
            return false;
        }

        return moment(date).isBefore(moment(beginDate, 'YYYY-MM-DD'), 'day');
    }

    get setupMasterGroupOrCategoryIsEmpty(): boolean {
        return !((this.$setupMasterCalc.groupOfProduct != null && this.$setupMasterCalc.groupOfProduct > 0)
            && (this.$setupMasterCalc.categoryOfProduct != null && this.$setupMasterCalc.categoryOfProduct > 0))
    }

    get setupMasterBaseAndStrategiesParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate
        return !state;
    }

    get setupMasterPriceSegmentsParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate
        return !state;
    }

    get setupMasterPriceKviParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate && this.setupMasterCompetitorsPricesValidate
            && this.setupMasterMinProfitKVIValidate && this.setupMasterKviPriceDecreaseLimitValidate
        return !state;
    }

    get setupMasterPriceCompetitorsParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate && this.setupMasterCompetitorsPricesValidate
            && this.setupMasterMinProfitKVIValidate && this.setupMasterKviPriceDecreaseLimitValidate
            && this.competitorPriceControlParameterPcValidateForSetupMaster && this.setupMasterCompetitorsMinProfitValidate && this.setupMasterCompPriceDecreaseLimitValidate
        return !state;
    }

    get setupMasterDepthParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate && this.setupMasterCompetitorsPricesValidate
            && this.setupMasterMinProfitKVIValidate && this.setupMasterKviPriceDecreaseLimitValidate
            && this.competitorPriceControlParameterPcValidateForSetupMaster && this.setupMasterCompetitorsMinProfitValidate
            && this.setupMasterCompPriceDecreaseLimitValidate && this.setupMasterCalculationDepthValidate
            && this.setupMasterCalculationDayValidate
        return !state;
    }

    get setupMasterSystemParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate && this.setupMasterCompetitorsPricesValidate
            && this.setupMasterMinProfitKVIValidate && this.setupMasterKviPriceDecreaseLimitValidate
            && this.competitorPriceControlParameterPcValidateForSetupMaster && this.setupMasterCompetitorsMinProfitValidate
            && this.setupMasterCompPriceDecreaseLimitValidate && this.setupMasterCalculationDepthValidate
            && this.setupMasterCalculationDayValidate && this.setupMasterInputIntervalP
        return !state;
    }

    get isKviStrategyEquals(): boolean {
        return this.$calc.kviStrategy && this.$calc.kviStrategy.value === 'EQUALS';
    }

    competitorNames: string[] = [this.$t('regular.common.all') as string];
    competitorsNameOptions: CompetitorNameAndFilter[] = [];
    currentMainTab: string = "mainParameters"
    setupMasterStep: number = 0;
    file: File | null = null;
    setupMasterGroupName: string = this.$t('regular.common.all') as string;
    setupMasterCategoryName: string = this.$t('regular.common.all') as string;
    setupMasterSubcategoryNames: string = this.$t('regular.common.all') as string;
    setupMasterFormatName: string = this.$t('regular.common.all') as string;
    setupMasterRegionNames: string = this.$t('regular.common.all') as string;
    setupMasterClusterName: string = this.$t('regular.common.all') as string;
    hasKvi: boolean = false;
    hasCompetitors: boolean = false;
    productLineOptions: Array<SelectBox<string>> = [];
    productLineOptionsForFilter: Array<SelectBox<string>> = [];
    defaultSelectProductLine = {value: 'all', label: this.$t('regular.common.all') as string};
    selectProductLine: string = this.defaultSelectProductLine.value;
    internalCodeFilterText: string = '';

    productRangesArray: InternalCodeAndProductRange[] = [];

    defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};
    selectedKviFilter = this.defaultFilterValue.value;
    selectKVI: number = this.defaultFilterValue.value;
    selectKVIForNewProducts: number = this.defaultFilterValue.value;
    selectKVIRecommends: number = this.defaultFilterValue.value;
    kviOptions: Array<SelectBox<number>> = [
        this.defaultFilterValue,
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('regular.columns.notKvi') as string},
    ];

    kviRecommendsOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('regular.common.all') as string},
        {value: 0, label: this.$t('regular.columns.gk') as string},
        {value: 1, label: this.$t('regular.columns.cvk') as string},
    ];

    defaultCtmFilterValue = {value: 'all', label: this.$t('regular.common.all') as string};
    selectedCtmFilter = this.defaultCtmFilterValue.value;
    selectCTM: string = this.defaultCtmFilterValue.value;
    selectCTMForNewProducts: string = this.defaultCtmFilterValue.value
    ctmOptions: Array<SelectBox<string>> = [
        this.defaultCtmFilterValue,
        {value: '1', label: 'CTM'},
        {value: '0', label: this.$t('regular.columns.notCtm') as string},
    ];

    selectSegmentPrice: Segment[] = [];
    selectSegmentPriceForNewProducts: Segment[] = [];
    segmentPriceOptions: Array<SelectBox<Segment>> = [];
    selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    selectNewProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    productSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    newProductSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    segmentPriceOptionsForNewProducts: Array<SelectBox<Segment>> = [];

    selectKeyCharacteristicOne: string[] = [];
    selectKeyCharacteristicTwo: string[] = [];
    selectKeyCharacteristicThree: string[] = [];
    selectKeyCharacteristicFour: string[] = [];
    selectKeyCharacteristicFive: string[] = [];
    selectRecipeAttributes: string[] = [];
    selectTreatmentAttributes: number[] = [];

    selectKeyCharacteristicOneForNewProduct: string[] = [];
    selectKeyCharacteristicTwoForNewProduct: string[] = [];
    selectKeyCharacteristicThreeForNewProduct: string[] = [];
    selectKeyCharacteristicFourForNewProduct: string[] = [];
    selectKeyCharacteristicFiveForNewProduct: string[] = [];
    selectRecipeAttributesForNewProduct: string[] = [];
    selectTreatmentAttributesForNewProduct: number[] = [];

    keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
    keyCharacteristicThreeOptions: Array<SelectBox<string>> = [];
    keyCharacteristicFourOptions: Array<SelectBox<string>> = [];
    keyCharacteristicFiveOptions: Array<SelectBox<string>> = [];
    recipeAttributesOptions: Array<SelectBox<string>> = [];
    treatmentAttributesOptions: Array<SelectBox<number>> = [];

    keyCharacteristicOneForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicThreeForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicFourForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicFiveForNewProductOptions: Array<SelectBox<string>> = [];
    recipeAttributesForNewProductOptions: Array<SelectBox<string>> = [];
    treatmentAttributesForNewProductOptions: Array<SelectBox<number>> = [];

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('regular.common.all') as string}],
        storeRegionOptions: [{value: 0, label: this.$t('regular.common.all') as string}],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('regular.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('regular.common.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('regular.common.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('regular.common.all') as string}],
        psegemnts: [],
    };
    taskInfoForSetupMaster: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('regular.common.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('regular.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('regular.common.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('regular.common.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('regular.common.all') as string}],
        psegemnts: [],
    };
    taskInfoForRoundingRules: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('regular.common.all') as string}],
        storeRegionOptions: [{value: 0, label: this.$t('regular.common.all') as string}],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('regular.common.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('regular.common.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('regular.common.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('regular.common.all') as string}],
        psegemnts: [],
    };
    isSaveStateAvailable: boolean = false
    codeOKRBPageSize: number = 50;
    codeOKRBPageNumber: number = 1;
    OKRBCodes: any = [];
    modalTitle = this.$t('regular.calc.addOkrbCode') as string;
    showDeleteCodeOKRBModal: boolean = false;
    codeOKRBForDelete: string = '000.000';
    refreshCodeOKRBTableId = -1;
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('regular.common.all') as string}];
    defaultStringSelectBox: Array<SelectBox<string>> = [{value: 'Все', label: this.$t('regular.common.all') as string}];
    errors = [];
    tableKey = 1;
    ctmProductsTablePagination: any = {
        current: 1,
        pageSize: 10,
        total: 0,
    };
    isCtmProductsTableLoading: boolean = false;
    rulesTableKey = 1;
    rulesPerPage = 20;
    rulesCurrentPage = 1;
    rulesListId = -1;
    rulesTotalRows = 0;
    competitorTableKey = 1;
    skuList: Sku[] = [];
    skuListWithAllProducts: Sku[] = [];
    newProductsList: Sku[] = [];
    newProductsListWithAllProducts: Sku[] = [];
    fileResult: string = '';
    taskId: number = 0;
    searchable: boolean = true;
    productsPageActiveTabKey: string = 'productsTabKey';
    tableDataSkuList: any = []
    tableDataNewProductsList: any = []
    tableDataCtmList: any = []

    codeOKRBToSave: CodeOKRB = {
        codeOKRB: '000.000',
        name: this.$t('regular.calc.codeName') as string,
        scenario: this.$t('regular.strategies.byWeightedAvg') as string,
        tradingId: 1,
    };

    rulesTableFields: TableHeaders[] | ITableHeaders[] = [
        {dataIndex: 'fileDownload', title: this.$t('regular.columns.actions') as string, scopedSlots: {customRender: 'fileDownload'}},
        {dataIndex: 'errors', title: this.$t('regular.columns.errors') as string, scopedSlots: {customRender: 'errors'}},
        {
            dataIndex: 'uploadDate',
            title: this.$t('regular.columns.changeDate') as string,
            scopedSlots: {filterDropdown: 'uploadDateFilter', filterIcon: 'uploadDateFilterIcon'},
            customRender: (v: number) => moment(moment.utc(v)).local().format('DD/MM/YYYY HH:mm:ss'),
            ellipsis: true
        },
        {
            dataIndex: 'user',
            title: this.$t('regular.columns.user') as string,
            scopedSlots: {filterDropdown: 'userFilter', filterIcon: 'userFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'filterType',
            title: this.$t('regular.columns.type') as string,
            scopedSlots: {filterDropdown: 'filterTypeFilter', filterIcon: 'filterTypeFilterIcon'},
            ellipsis: true,
            customRender: (data: RoundingRulesFilterType) => roundingRulesFilterTypeLabels[data],
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('regular.columns.formatChannel') as string,
            scopedSlots: {filterDropdown: 'storeFormatFilter', filterIcon: 'storeFormatFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'storeRegions',
            title: this.$t('regular.columns.storeRegion') as string,
            scopedSlots: {filterDropdown: 'storeRegionsFilter', filterIcon: 'storeRegionsFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'storeCluster',
            title: this.$t('regular.columns.storeCluster') as string,
            scopedSlots: {filterDropdown: 'storeClusterFilter', filterIcon: 'storeClusterFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'groupsOfProduct',
            title: this.$t('regular.columns.productGroup') as string,
            scopedSlots: {filterDropdown: 'groupsOfProductFilter', filterIcon: 'groupsOfProductFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'categories',
            title: this.$t('regular.columns.productCategory') as string,
            scopedSlots: {filterDropdown: 'categoriesFilter', filterIcon: 'categoriesFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'subcategories',
            title: this.$t('regular.columns.subcategory') as string,
            scopedSlots: {filterDropdown: 'subcategoriesFilter', filterIcon: 'subcategoriesFilterIcon'},
            ellipsis: true
        },
    ];

    rulesTableItems: any[] = [];
    pagination: any = {
        pageSize: 50,
    };

    codeOKRB() {
        const tableFields: ITableHeaders[] = [
            {dataIndex: 'actions', title: this.$t('regular.columns.actions') as string, width: 100, scopedSlots: {customRender: 'actions'}},
            {dataIndex: 'codeOKRB', title: this.$t('regular.columns.okrbCode') as string, width: 100, scopedSlots: {customRender: 'codeOKRB'}},
            {dataIndex: 'name', title: this.$t('regular.columns.okrbCodeName') as string, width: 100, scopedSlots: {customRender: 'codeOKRB'}},
            {
                dataIndex: 'scenario',
                title: this.$t('regular.columns.priceCalcScenario') as string,
                width: 100,
                scopedSlots: {customRender: 'codeOKRB'}
            },
        ]

        return tableFields
    }

    getTableFields() {
        const tableFields: ITableHeaders[] = [
            {
                dataIndex: 'internalCode',
                title: this.$t('regular.columns.internalCode') as string,
                width: 100,
                scopedSlots: {
                    customRender: 'internalCode',
                    filterDropdown: 'internalCodeFilter',
                    filterIcon: "internalCodeFilterIcon"
                },
                // fixed: 'left' // временно закомментировал - здесь баг таблицы Ant - при выборе множества конкурентов фиксированная колонка имеет другую высоту
            },
            {
                dataIndex: 'skuName',
                scopedSlots: {title: "skuNameHeader"},
                ellipsis: true,
                width: 180,
            },
            {
                dataIndex: 'cartName',
                title: this.$t('regular.columns.cartName') as string,
                ellipsis: true,
                width: 100,
                customRender: (val: string | null | undefined) => (val != null ? val : '-'),
            },
            {
                dataIndex: 'priceExperiment',
                width: 70,
                scopedSlots: {
                    title: 'priceExperimentHeader',
                    customRender: 'priceExperiment',
                    filterDropdown: 'priceExperimentFilter',
                    filterIcon: 'priceExperimentFilterIcon',
                },
            },
            {
                dataIndex: 'productSegmentName',
                slots: { title: 'productSegmentNameColumnTitle' }, // dataIndex + 'ColumnTitle'
                slotColumnTitleData: {
                    text: this.$t('regular.columns.productSegments') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {
                    filterDropdown: 'productSegmentNameFilter',
                    filterIcon: "productSegmentNameFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsOne',
                title: this.$t('regular.columns.kht1') as string,
                scopedSlots: {
                    filterDropdown: 'keyCharacteristicOfTheProductIsOneFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsOneFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'priceSegment',
                title: this.$t('regular.columns.priceSegment') as string,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'priceSegmentFilter',
                    filterIcon: "priceSegmentFilterIcon"
                },
                customRender: (value: any, data: any) =>
                    `${(data.priceSegmentMin) ? this.numberFormatter(data.priceSegmentMin) : ''} - ${(data.priceSegmentMax) ? this.numberFormatter(data.priceSegmentMax) : ''}`,
                ellipsis: true,
            },
            {
                dataIndex: 'competitorNames',
                title: this.$t('regular.columns.competitor') as string,
                width: 80,
                scopedSlots: {customRender: 'competitorNames'},
            },
            {
                dataIndex: 'byPromoPrices',
                title: this.$t('regular.columns.individualByPromoPrices') as string,
                width: 90,
                scopedSlots: {customRender: 'byPromoPrices'},
            },
            {
                dataIndex: 'coefficentList',
                title: this.$t('regular.columns.priceOptStrategy') as string,
                width: 80,
                scopedSlots: {customRender: 'coefficentList'},
            },
            {
                dataIndex: 'priceIncreaseLimit',
                slots: { title: 'priceIncreaseLimitColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.increaseLimit') as string,
                    useWidthCoefficient: true,
                },
                width: 80,
                scopedSlots: {customRender: 'priceIncreaseLimit'},
                ellipsis: true
            },
            {
                dataIndex: 'periodPriceIncreaseLimit',
                slots: { title: 'periodPriceIncreaseLimitColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.periodIncreaseLimitPercent') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {customRender: 'periodPriceIncreaseLimit'},
                ellipsis: true,
                width: 80,
            },
            {dataIndex: 'period', title: this.$t('regular.columns.period') as string, scopedSlots: {customRender: 'period'}, width: 80},
            {
                dataIndex: 'marginalProfit',
                title: this.$t('regular.columns.minSkuProfit') as string,
                width: 80,
                scopedSlots: {customRender: 'marginalProfit'},
            },
            {
                dataIndex: 'marginalProfitKvi',
                title: this.$t('regular.columns.minProfitKvi') as string,
                width: 80,
                scopedSlots: {customRender: 'marginalProfitKvi'},
            },
            {
                dataIndex: 'marginalProfitCompetitors',
                title: this.$t('regular.columns.minProfitCompetitors') as string,
                width: 100,
                scopedSlots: {customRender: 'marginalProfitCompetitors'},
            },
            {
                dataIndex: 'maxMarginalProfit',
                title: this.$t('regular.columns.maxSkuProfit') as string,
                width: 80,
                scopedSlots: {customRender: 'maxMarginalProfit'},
            },
            {
                dataIndex: 'recipeAttribute',
                title: this.$t('regular.columns.prc') as string,
                scopedSlots: {
                    customRender: 'recipeAttribute',
                    filterDropdown: 'recipeAttributeFilter',
                    filterIcon: "recipeAttributeFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'treatmentAttribute',
                title: this.$t('regular.columns.pkl') as string,
                scopedSlots: {
                    customRender: 'treatmentAttribute',
                    filterDropdown: 'treatmentAttributeFilter',
                    filterIcon: "treatmentAttributeFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'kvi',
                title: 'KVI',
                scopedSlots: {
                    customRender: 'kvi',
                    filterDropdown: 'kviFilter',
                    filterIcon: "kviFilterIcon"
                },
                filterMultiple: false,
                ellipsis: true,
                width: 70,
            },
            {
                dataIndex: 'tagsKvi',
                title: '',
                scopedSlots: {
                    customRender: 'tagsKvi',
                    filterDropdown: 'tagsKviFilter',
                    filterIcon: "tagsKviFilterIcon"
                },
                filterMultiple: false,
                ellipsis: true,
                width: 50
            },
            {
                dataIndex: 'ctm',
                title: 'CTM',
                width: 50,
                scopedSlots: {
                    customRender: 'ctm',
                    filterDropdown: 'ctmFilter',
                    filterIcon: "ctmFilterIcon"
                },
                filterMultiple: false,
                ellipsis: true,
            },
            {
                dataIndex: 'minMaxRetailPrice',
                title: this.$t('regular.columns.minMaxRp') as string,
                customRender: (value: any, data: any) => `${(data.minRetailPrice) ? this.numberFormatter(data.minRetailPrice) : '-'}/${(data.maxRetailPrice) ? this.numberFormatter(data.maxRetailPrice) : '-'}`,
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'productRange',
                title: this.$t('regular.columns.priceLine') as string,
                scopedSlots: {
                    customRender: 'productRange',
                    filterDropdown: 'productRangeFilter',
                    filterIcon: "productRangeFilterIcon"
                },
                width: 100,
                filterMultiple: false,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsTwo',
                title: this.$t('regular.columns.kht2') as string,
                scopedSlots: {
                    filterDropdown: 'keyCharacteristicOfTheProductIsTwoFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsTwoFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsThree',
                title: this.$t('regular.columns.kht3') as string,
                scopedSlots: {
                    customRender: 'keyCharacteristicOfTheProductIsThree',
                    filterDropdown: 'keyCharacteristicOfTheProductIsThreeFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsThreeFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsFour',
                title: this.$t('regular.columns.kht4') as string,
                scopedSlots: {
                    customRender: 'keyCharacteristicOfTheProductIsFour',
                    filterDropdown: 'keyCharacteristicOfTheProductIsFourFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsFourFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsFive',
                title: this.$t('regular.columns.kht5') as string,
                scopedSlots: {
                    customRender: 'keyCharacteristicOfTheProductIsFive',
                    filterDropdown: 'keyCharacteristicOfTheProductIsFiveFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsFiveFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'batchNumber',
                title: this.$t('regular.columns.batchNumber') as string,
                width: 80,
                scopedSlots: {
                    customRender: 'batchNumber'
                }
            },
            {
                dataIndex: 'lastPrice',
                scopedSlots: {title: "lastPriceHeader"},
                customRender: (value: any) => value ? this.numberFormatter(value) : '-',
                ellipsis: true,
                width: 130
            },
            {
                dataIndex: 'lastPriceMarginPc',
                slots: { title: 'lastPriceMarginPcColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.lastPriceMargin') as string,
                    useWidthCoefficient: true,
                },
                width: 80,
                scopedSlots: {customRender: 'lastPriceMarginPc'},
                ellipsis: true,
            },
            {
                dataIndex: 'actualProfitability',
                scopedSlots: {title: "actualProfitabilityHeader"},
                width: 120,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
            },
            {
                dataIndex: 'purchasePriceAvgM',
                title: this.$t('regular.columns.avgPurchasePrice') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80
            },
            {
                dataIndex: 'kviStrategy',
                title: this.$t('regular.columns.kviStrategy') as string,
                width: 120,
                scopedSlots: {customRender: 'kviStrategy'},
                ellipsis: true,
            },
            {
                dataIndex: 'percentageOfCompetitorsPrice',
                title: this.$t('regular.columns.adjustment') as string,
                scopedSlots: {customRender: 'percentageOfCompetitorsPrice'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'basePrice',
                slots: { title: 'basePriceColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.producerPriceNoVat') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'vatPercentage',
                title: this.$t('regular.columns.vatPercent') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'markupPercentage',
                slots: { title: 'markupPercentageColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.maxMarkup') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'limitRetailPrice',
                slots: { title: 'limitRetailPriceColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.maxRetailPriceRub') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'marketingPaymentsPercentage',
                slots: { title: 'marketingPaymentsPercentageColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.marketingPayments') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'logisticCostsAmount',
                slots: { title: 'logisticCostsAmountColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.logisticsCostNoVat') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'logisticCostsPercentage',
                slots: { title: 'logisticCostsPercentageColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.logisticsCostPercent') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'productVolume',
                title: this.$t('regular.columns.vgh') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: false,
                width: 40,
            },
            {
                dataIndex: 'measurementUnit',
                title: this.$t('regular.columns.unit') as string,
                ellipsis: false,
                width: 30,
            },
            {
                dataIndex: 'productVerticalLine',
                title: this.$t('regular.columns.vlName') as string,
                ellipsis: true,
                width: 70,
            },
            {
                dataIndex: 'isVerticalLineBase',
                title: this.$t('regular.columns.base') as string,
                customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
                ellipsis: false,
                width: 50,
            },
            {
                dataIndex: 'vlStrategyStr',
                title: this.$t('regular.columns.vlStrategy') as string,
                ellipsis: false,
                width: 70,
            },
            {
                dataIndex: 'vlGapPc',
                title: this.$t('regular.columns.verticalLineGap') as string,
                customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
                ellipsis: false,
                width: 70,
            },
        ];

        return tableFields;
    }

    getNewProductsTableFields() {
        const newProductsTableFields: TableHeaders[] | ITableHeaders[] = [
            {
                dataIndex: 'internalCode',
                title: this.$t('regular.columns.internalCode') as string,
                width: 100,
                scopedSlots: {
                    customRender: 'internalCode',
                },
                // fixed: 'left' // временно закомментировал - здесь баг таблицы Ant - при выборе множества конкурентов фиксированная колонка имеет другую высоту
            },
            {
                dataIndex: 'skuName',
                scopedSlots: {
                    title: "skuNameHeader",
                },
                ellipsis: true,
                width: 150,
            },
            {
                dataIndex: 'cartName',
                title: this.$t('regular.columns.cartName') as string,
                ellipsis: true,
                width: 100,
                customRender: (val: string | null | undefined) => (val != null ? val : '-'),
            },
            {
                dataIndex: 'productSegmentName',
                title: this.$t('regular.columns.productSegments') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'productSegmentNameFilter',
                    filterIcon: "productSegmentNameFilterIcon",
                },
                // newProductSegmentIdAndNameOptions
                // selectNewProductSegmentIdAndName
            },
            {
                dataIndex: 'newProductPriceStrategy',
                title: this.$t('regular.columns.newProductPricingStrategy') as string,
                scopedSlots: {customRender: 'newProductPriceStrategy'},
                width: 110,
            },
            {
                dataIndex: 'newProductLifespanInDays',
                title: this.$t('regular.columns.newProductLifeDays') as string,
                scopedSlots: {customRender: 'newProductLifespanInDays'},
                width: 80,
            },
            {
                dataIndex: 'priceGap',
                title: this.$t('regular.columns.priceGapPercent') as string,
                scopedSlots: {customRender: 'priceGap'},
                width: 80,
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsOne',
                title: this.$t('regular.columns.kht1') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsOneFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsOneFilterIcon"
                },
                // keyCharacteristicOneForNewProductOptions
                // selectKeyCharacteristicOneForNewProduct
            },
            {
                dataIndex: 'priceSegment',
                title: this.$t('regular.columns.priceSegment') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'priceSegmentFilter',
                    filterIcon: "priceSegmentFilterIcon"
                },
                customRender: (value: any, data: any) =>
                    `${(data.priceSegmentMin) ? this.numberFormatter(data.priceSegmentMin) : ''} - ${(data.priceSegmentMax) ? this.numberFormatter(data.priceSegmentMax) : ''}`,

            },
            {
                dataIndex: 'competitorNames',
                title: this.$t('regular.columns.competitor') as string,
                width: 80,
                scopedSlots: {customRender: 'competitorNames'},
            },
            {
                dataIndex: 'byPromoPrices',
                title: this.$t('regular.columns.individualByPromoPrices') as string,
                width: 90,
                scopedSlots: {customRender: 'byPromoPrices'},
            },
            {
                dataIndex: 'coefficentList',
                title: this.$t('regular.columns.priceOptStrategy') as string,
                scopedSlots: {customRender: 'coefficentList'},
                width: 80,
            },
            {
                dataIndex: 'marginalProfit',
                title: this.$t('regular.columns.minSkuProfit') as string,
                scopedSlots: {customRender: 'marginalProfit'},
                width: 80,
            },
            {
                dataIndex: 'marginalProfitKvi',
                title: this.$t('regular.columns.minProfitKvi') as string,
                scopedSlots: {customRender: 'marginalProfitKvi'},
                width: 80,
            },
            {
                dataIndex: 'marginalProfitCompetitors',
                title: this.$t('regular.columns.minProfitCompetitors') as string,
                scopedSlots: {customRender: 'marginalProfitCompetitors'},
                width: 100,
            },
            {
                dataIndex: 'maxMarginalProfit',
                title: this.$t('regular.columns.maxSkuProfit') as string,
                scopedSlots: {customRender: 'maxMarginalProfit'},
                width: 80,
            },
            {
                dataIndex: 'recipeAttribute',
                title: this.$t('regular.columns.prc') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'recipeAttributeFilter',
                    filterIcon: "recipeAttributeFilterIcon"
                },
                // recipeAttributesForNewProductOptions

            },
            {
                dataIndex: 'treatmentAttribute',
                title: this.$t('regular.columns.pkl') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'treatmentAttributeFilter',
                    filterIcon: "treatmentAttributeFilterIcon"
                },

            },
            {
                dataIndex: 'kvi',
                title: 'KVI',
                width: 70,
                filterMultiple: false,
                scopedSlots: {
                    customRender: 'kvi',
                    filterDropdown: 'kviFilter',
                    filterIcon: "kviFilterIcon"
                },

            },
            {
                dataIndex: 'ctm',
                title: 'CTM',
                ellipsis: true,
                filterMultiple: false,
                width: 50,
                scopedSlots: {
                    filterDropdown: 'ctmFilter',
                    filterIcon: "ctmFilterIcon"
                },
                // selectCTMForNewProducts
            },
            {
                dataIndex: 'minMaxRetailPrice',
                title: this.$t('regular.columns.minMaxRp') as string,
                ellipsis: true,
                width: 80,
                customRender: (value: any, data: any) => `${(data.minRetailPrice) ? this.numberFormatter(data.minRetailPrice) : '-'}/${(data.maxRetailPrice) ? this.numberFormatter(data.maxRetailPrice) : '-'}`,
            },
            {
                dataIndex: 'productRange',
                title: this.$t('regular.columns.priceLine') as string,
                width: 100,
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsTwo',
                title: this.$t('regular.columns.kht2') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsTwoFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsTwoFilterIcon"
                },
                // keyCharacteristicTwoForNewProductOptions
                // selectKeyCharacteristicTwoForNewProduct
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsThree',
                title: this.$t('regular.columns.kht3') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsThreeFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsThreeFilterIcon"
                },
                // keyCharacteristicThreeForNewProductOptions
                // selectKeyCharacteristicThreeForNewProduct

            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsFour',
                title: this.$t('regular.columns.kht4') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsFourFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsFourFilterIcon"
                },
                // keyCharacteristicFourForNewProductOptions
                // selectKeyCharacteristicFourForNewProduct
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsFive',
                title: this.$t('regular.columns.kht5') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsFiveFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsFiveFilterIcon"
                },
                // keyCharacteristicFiveForNewProductOptions
                //selectKeyCharacteristicFiveForNewProduct

            },
            {
                dataIndex: 'batchNumber',
                title: this.$t('regular.columns.batchNumber') as string,
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'lastPrice',
                ellipsis: true,
                width: 130,
                scopedSlots: {
                    title: "lastPriceHeader"
                },
                customRender: (value: any) => value ? this.numberFormatter(value) : '-',
            },

            {
                dataIndex: 'actualProfitability',
                scopedSlots: {title: "actualProfitabilityHeader"},
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'purchasePriceAvgM',
                title: this.$t('regular.columns.avgPurchasePrice') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },

            {dataIndex: 'kviStrategy', title: this.$t('regular.columns.kviStrategy') as string, scopedSlots: {customRender: 'kviStrategy'}, width: 80,},
            {
                dataIndex: 'percentageOfCompetitorsPrice',
                title: this.$t('regular.columns.adjustment') as string,
                scopedSlots: {customRender: 'percentageOfCompetitorsPrice'},
                width: 80,
            },
            {
                dataIndex: 'productVolume',
                title: this.$t('regular.columns.vgh') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: false,
                width: 40,
            },
            {
                dataIndex: 'measurementUnit',
                title: this.$t('regular.columns.unit') as string,
                ellipsis: false,
                width: 30,
            },
            {
                dataIndex: 'productVerticalLine',
                title: this.$t('regular.columns.vlName') as string,
                ellipsis: true,
                width: 70,
            },
            {
                dataIndex: 'isVerticalLineBase',
                title: this.$t('regular.columns.base') as string,
                customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
                ellipsis: false,
                width: 50,
            },
            {
                dataIndex: 'vlStrategyStr',
                title: this.$t('regular.columns.vlStrategy') as string,
                ellipsis: false,
                width: 70,
            },
            {
                dataIndex: 'vlGapPc',
                title: this.$t('regular.columns.verticalLineGap') as string,
                customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
                ellipsis: false,
                width: 70,
            },
        ];

        return newProductsTableFields
    }

    getTableSkuFields() {
        const tableSkuFields: TableHeaders[] | ITableHeaders[] = [
            {
                dataIndex: 'internalCode',
                title: this.$t('regular.columns.internalCode') as string,
                scopedSlots: {
                    customRender: 'internalCode',
                    filterDropdown: 'internalCodeFilter',
                    filterIcon: "internalCodeFilterIcon"
                },
                // fixed: 'left' // временно закомментировал - здесь баг таблицы Ant - при выборе множества конкурентов фиксированная колонка имеет другую высоту
                width: 100,
            },
            {
                dataIndex: 'skuName',
                ellipsis: true,
                width: 180,
                scopedSlots: {
                    title: "skuNameHeader",
                },
            },
            {
                dataIndex: 'productSegmentName',
                slots: { title: 'productSegmentNameColumnTitle' }, // dataIndex + 'ColumnTitle'
                slotColumnTitleData: {
                    text: this.$t('regular.columns.productSegments') as string,
                    useWidthCoefficient: true,
                },
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'productSegmentNameFilter',
                    filterIcon: "productSegmentNameFilterIcon",
                },
                // selectProductSegmentIdAndName
                // updateProductSegmentIdAndName
                // productSegmentIdAndNameOptions
            },

            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsOne',
                title: this.$t('regular.columns.kht1') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsOne',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsOneFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsOneFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicOne
                // updateKeyCharacteristicOne
                // keyCharacteristicOneOptions
            },
            {
                dataIndex: 'priceSegment',
                title: this.$t('regular.columns.priceSegment') as string,
                width: 80,
                scopedSlots: {
                    title: "lastPriceHeader",
                    filterDropdown: 'priceSegmentFilter',
                    filterIcon: "priceSegmentFilterIcon"
                },
                customRender: (value: any, data: any) =>
                    `${(data.priceSegmentMin) ? this.numberFormatter(data.priceSegmentMin) : ''} - ${(data.priceSegmentMax) ? this.numberFormatter(data.priceSegmentMax) : ''}`,
                ellipsis: true,
                // segmentPriceOptions
            },
            {
                dataIndex: 'competitorNames',
                title: this.$t('regular.columns.competitor') as string,
                width: 80,
                scopedSlots: {customRender: 'competitorNames'},
            },
            {
                dataIndex: 'byPromoPrices',
                title: this.$t('regular.columns.individualByPromoPrices') as string,
                width: 90,
                scopedSlots: {customRender: 'byPromoPrices'},
            },
            {
                dataIndex: 'coefficentList',
                slots: { title: 'coefficentListColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.priceOptStrategy') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {customRender: 'coefficentList'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'priceIncreaseLimit',
                slots: { title: 'priceIncreaseLimitColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.increaseLimit') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {customRender: 'priceIncreaseLimit'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'periodPriceIncreaseLimit',
                slots: { title: 'periodPriceIncreaseLimitColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.periodIncreaseLimitPercent') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {customRender: 'periodPriceIncreaseLimit'},
                ellipsis: true,
                width: 80,
            },
            {dataIndex: 'period', title: this.$t('regular.columns.period') as string, scopedSlots: {customRender: 'period'},
                width: 80,},
            {
                dataIndex: 'marginalProfit',
                slots: { title: 'marginalProfitColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.minSkuProfit') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {customRender: 'marginalProfit'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'marginalProfitKvi',
                title: this.$t('regular.columns.minProfitKvi') as string,
                scopedSlots: {customRender: 'marginalProfitKvi'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'marginalProfitCompetitors',
                title: this.$t('regular.columns.minProfitCompetitors') as string,
                scopedSlots: {customRender: 'marginalProfitCompetitors'},
                ellipsis: true,
                width: 100,
            },
            {
                dataIndex: 'maxMarginalProfit',
                slots: { title: 'maxMarginalProfitColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.maxSkuProfit') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {customRender: 'maxMarginalProfit'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'recipeAttribute',
                title: this.$t('regular.columns.prc') as string,
                scopedSlots: {
                    customRender: 'recipeAttribute',
                    filterDropdown: 'recipeAttributeFilter',
                    filterIcon: "recipeAttributeFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectRecipeAttributes
                // updateRecipeAttributes
                // recipeAttributesOptions
            },
            {
                dataIndex: 'treatmentAttribute',
                title: this.$t('regular.columns.pkl') as string,
                scopedSlots: {
                    customRender: 'treatmentAttribute',
                    filterDropdown: 'treatmentAttributeFilter',
                    filterIcon: "treatmentAttributeFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectTreatmentAttributes
                // updateTreatmentAttributes
                // treatmentAttributesOptions
            },
            {
                dataIndex: 'kvi',
                title: 'KVI',
                filterMultiple: false,
                scopedSlots: {
                    customRender: 'kvi',
                    filterDropdown: 'kviFilter',
                    filterIcon: "kviFilterIcon",
                },
                ellipsis: true,
                width: 70,
                // selectKVI
                // kviOptions
            },
            {
                dataIndex: 'tagsKvi',
                title: '',
                filterMultiple: false,
                scopedSlots: {
                    customRender: 'tagsKvi',
                    filterDropdown: 'tagsKviFilter',
                    filterIcon: "tagsKviFilterIcon"
                },
                ellipsis: true,
                width: 50,

                // selectKVIRecommends
                // kviRecommendsOptions
            },
            {
                dataIndex: 'minMaxRetailPrice',
                title: this.$t('regular.columns.minMaxRp') as string,
                width: 80,
                customRender: (value: any, data: any) => `${(data.minRetailPrice) ? this.numberFormatter(data.minRetailPrice) : '-'}/${(data.maxRetailPrice) ? this.numberFormatter(data.maxRetailPrice) : '-'}`,
                ellipsis: true,
            },
            {
                dataIndex: 'productRange',
                title: this.$t('regular.columns.priceLine') as string,
                filterMultiple: false,
                scopedSlots: {
                    customRender: 'productRange',
                    filterDropdown: 'productRangeFilter',
                    filterIcon: "productRangeFilterIcon"
                },
                width: 100,

                // selectProductLine
                // productLineOptionsForFilter
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsTwo',
                title: this.$t('regular.columns.kht2') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsTwo',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsTwoFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsTwoFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicTwo
                // updateKeyCharacteristicTwo
                // keyCharacteristicTwoOptions
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsThree',
                title: this.$t('regular.columns.kht3') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsThree',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsThreeFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsThreeFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicThree
                // updateKeyCharacteristicThree
                // keyCharacteristicThreeOptions
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsFour',
                title: this.$t('regular.columns.kht4') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsFour',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsFourFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsFourFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicFour
                // updateKeyCharacteristicFour
                // keyCharacteristicFourOptions
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsFive',
                title: this.$t('regular.columns.kht5') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsFive',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsFiveFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsFiveFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicFive
                // updateKeyCharacteristicFive
                // keyCharacteristicFiveOptions
            },
            {
                dataIndex: 'batchNumber',
                title: this.$t('regular.columns.batchNumber') as string,
                scopedSlots: {
                    customRender: 'batchNumber',
                },
                width: 80,
                ellipsis: true,
            },
            {
                dataIndex: 'priceGapSTM',
                title: this.$t('regular.columns.ctmPriceGapPercent') as string,
                scopedSlots: {
                    customRender: 'ctmPriceGap',
                },
                ellipsis: true,
                width: 100,
            },
            {
                dataIndex: 'ctmBrandPurposeValue',
                title: this.$t('regular.columns.brandTarget') as string,
                scopedSlots: {
                    customRender: 'ctmBrandPurposeValue',
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'ctmBrandPurpose',
                slots: { title: 'ctmBrandPurposeColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.advancedPricing.autoCtmBrandTarget') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {
                    customRender: 'ctmBrandPurpose',
                },
                ellipsis: true,
                width: 100,
            },
            {
                dataIndex: 'lastPrice',
                scopedSlots: {
                    title: "lastPriceHeader",
                },
                ellipsis: true,
                width: 130,
                customRender: (value: any) => value ? this.numberFormatter(value) : '-'
            },
            {
                dataIndex: 'lastPriceMarginPc',
                slots: { title: 'lastPriceMarginPcColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.lastPriceMargin') as string,
                    useWidthCoefficient: true,
                },
                scopedSlots: {customRender: 'lastPriceMarginPc'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'actualProfitability',
                scopedSlots: {title: "actualProfitabilityHeader"},
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'purchasePriceAvgM',
                title: this.$t('regular.columns.avgPurchasePrice') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },

            {dataIndex: 'kviStrategy', title: this.$t('regular.columns.kviStrategy') as string, scopedSlots: {customRender: 'kviStrategy'}, ellipsis: true,
                width: 80,},
            {
                dataIndex: 'percentageOfCompetitorsPrice',
                title: this.$t('regular.columns.adjustment') as string,
                scopedSlots: {customRender: 'percentageOfCompetitorsPrice'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'basePrice',
                slots: { title: 'basePriceColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.producerPriceNoVat') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'vatPercentage',
                title: this.$t('regular.columns.vatPercent') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'markupPercentage',
                slots: { title: 'markupPercentageColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.maxMarkup') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'limitRetailPrice',
                slots: { title: 'limitRetailPriceColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.maxRetailPriceRub') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'marketingPaymentsPercentage',
                slots: { title: 'marketingPaymentsPercentageColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.marketingPayments') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'logisticCostsAmount',
                slots: { title: 'logisticCostsAmountColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.logisticsCostNoVat') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'logisticCostsPercentage',
                slots: { title: 'logisticCostsPercentageColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.logisticsCostPercent') as string,
                    useWidthCoefficient: true,
                },
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'productVolume',
                title: this.$t('regular.columns.vgh') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: false,
                width: 40,
            },
            {
                dataIndex: 'measurementUnit',
                title: this.$t('regular.columns.unit') as string,
                ellipsis: false,
                width: 30,
            },
            {
                dataIndex: 'productVerticalLine',
                title: this.$t('regular.columns.vlName') as string,
                ellipsis: true,
                width: 70,
            },
            {
                dataIndex: 'isVerticalLineBase',
                title: this.$t('regular.columns.base') as string,
                customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
                ellipsis: false,
                width: 50,
            },
            {
                dataIndex: 'vlStrategyStr',
                title: this.$t('regular.columns.vlStrategy') as string,
                ellipsis: false,
                width: 70,
            },
            {
                dataIndex: 'vlGapPc',
                title: this.$t('regular.columns.verticalLineGap') as string,
                customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
                ellipsis: false,
                width: 70,
            },
        ];

        return tableSkuFields
    }

    numberFormatter = (v: any): string => FormatNumber.format(v);

    competitorsTableFields: ITableHeaders[] = [
        {dataIndex: 'selected', title: '✓', scopedSlots: {customRender: 'selected'}, width: 50},
        {
            dataIndex: 'internalCode',
            title: this.$t('regular.columns.internalCode') as string,
            filterOptionsKey: 'optionInternalCodes',
            filterModelKey: 'internalCodes',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            sorter: true,
            ellipsis: true,
            width: 170
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('regular.columns.format') as string,
            filterOptionsKey: 'optionStoreFormats',
            filterModelKey: 'storeFormats',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            sorter: true,
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'storeRegion',
            sorter: true,
            title: this.$t('regular.columns.region') as string,
            filterOptionsKey: 'optionRegions',
            filterModelKey: 'storeRegionValues',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'skuName',
            sorter: true,
            title: this.$t('regular.columns.skuName') as string,
            filterOptionsKey: 'optionSkuNames',
            filterModelKey: 'skuNames',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 170
        },
        {
            dataIndex: 'competitorName',
            sorter: true,
            title: this.$t('regular.columns.competitor') as string,
            filterOptionsKey: 'optionCompetitorsNames',
            filterModelKey: 'competitors',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'competitorCode',
            sorter: true,
            title: this.$t('regular.columns.competitorCode') as string,
            filterOptionsKey: 'optionCompetitorsCodes',
            filterModelKey: 'competitorCodes',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 170
        },
        {
            dataIndex: 'competitorPriority',
            sorter: true,
            title: this.$t('regular.columns.competitorPriority') as string,
            filterOptionsKey: 'optionCompetitorPriorities',
            filterModelKey: 'competitorPriorities',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 230
        },
        {
            dataIndex: 'lastPrice',
            sorter: true,
            title: this.$t('regular.columns.ourPrice') as string,
            filterOptionsKey: 'optionLastPrices',
            filterModelKey: 'lastPrices',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'promoPrice',
            sorter: true,
            title: this.$t('regular.columns.promoCompetitorPrice') as string,
            filterOptionsKey: 'optionPromoPrices',
            filterModelKey: 'promoPrices',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 250
        },
        {
            dataIndex: 'competitorPrice',
            sorter: true,
            title: this.$t('regular.columns.competitorPrice') as string,
            customRender: this.numberFormatter,
            filterOptionsKey: 'optionCompetitorPrices',
            filterModelKey: 'competitorPrices',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 200
        },
        {
            dataIndex: 'delta',
            sorter: true,
            title: this.$t('regular.columns.deviation') as string,
            customRender: (value: number) => `${value.toFixed(2)}%`,
            filterOptionsKey: 'optionDeltas',
            filterModelKey: 'deltas',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'kvi',
            sorter: true,
            title: 'KVI',
            customRender: (value: number) => value ? this.$t('regular.common.yes') : this.$t('regular.common.no'),
            filterOptionsKey: 'kviOptions',
            filterModelKey: 'kviValue',
            scopedSlots: {filterDropdown: 'filterRadioButtons', filterIcon: "radioButtonsWithAllFilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'ctm',
            sorter: true,
            title: this.$t('regular.columns.ctm') as string,
            filterOptionsKey: 'ctmOptions',
            filterModelKey: 'ctmValue',
            scopedSlots: {filterDropdown: 'filterRadioButtons', filterIcon: "radioButtonsWithAllFilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'keyCharacteristicOfTheProductIsOne',
            sorter: true,
            title: this.$t('regular.columns.kht1') as string,
            filterOptionsKey: 'optionKeyCharacteristicsOfTheProductIsOne',
            filterModelKey: 'keyCharacteristicsOfTheProductIsOnes',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'keyCharacteristicOfTheProductIsTwo',
            sorter: true,
            title: this.$t('regular.columns.kht2') as string,
            filterOptionsKey: 'optionKeyCharacteristicsOfTheProductIsTwo',
            filterModelKey: 'keyCharacteristicsOfTheProductIsTwos',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'competitorDate',
            sorter: true,
            title: this.$t('regular.columns.monitoringDate') as string,
            customRender: (value: any) => moment(new Date(+value)).format('DD.MM.YYYY'),
            filterOptionsKey: 'optionPriceDates',
            filterModelKey: 'priceDates',
            scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
            ellipsis: true,
            width: 200
        },
    ];

    steps = [
        {title: this.$t('regular.wizard.stepProductCategories') as string},
        {title: this.$t('regular.wizard.stepFormatsAndClusters') as string},
        {title: this.$t('regular.wizard.stepCurrentParams') as string},
        {title: this.$t('regular.wizard.stepStrategyAndLimits') as string},
        {title: this.$t('regular.wizard.stepPriceSegments') as string},
        {title: this.$t('regular.wizard.stepKvi') as string},
        {title: this.$t('regular.wizard.stepCompetition') as string},
        {title: this.$t('regular.wizard.stepCostForecast') as string},
        {title: this.$t('regular.wizard.stepOtherParams') as string},
        {title: this.$t('regular.wizard.stepFinish') as string},
    ];

    settingsMasterIsOpen: Boolean = false;

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    tradingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: number = this.defaultFilterValue.value;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: number = this.defaultFilterValue.value;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: number = this.defaultFilterValue.value;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: number = this.defaultFilterValue.value;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: number = this.defaultFilterValue.value;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: number = this.defaultFilterValue.value;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    selectKeyCharacteristicOneForCompetitors: string[] = [];
    keyCharacteristicOneForCompetitorsOptions: Array<SelectBox<string>> = [];

    selectKeyCharacteristicTwoForCompetitors: string[] = [];
    keyCharacteristicTwoForCompetitorsOptions: Array<SelectBox<string>> = [];

    competitors: CompetitorsPriceRow[] = [];
    viewCompetitors: CompetitorsPriceRow[] = [];
    competitorsTablePagination: any = {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
    }
    competitorsTableFilterOptions: ICompetitorPricesFilterOptions  = {
        optionCompetitorPrices: [],
        optionCompetitorPriorities: [],
        optionCompetitorsCodes: [],
        optionCompetitorsNames: [],
        optionDeltas: [],
        optionInternalCodes: [],
        optionKeyCharacteristicsOfTheProductIsOne: [],
        optionKeyCharacteristicsOfTheProductIsTwo: [],
        optionLastPrices: [],
        optionPriceDates: [],
        optionPromoPrices: [],
        optionRegions: [],
        optionSkuNames: [],
        optionStoreFormats: [],
        kviOptions: [],
        ctmOptions: [],
    };
    competitorsTableFilterValues: ICompetitorsTableFilterValues = {
        kviValue: -1,
        ctmValue: 'all',
    };
    needFetchCompetitorCodes: boolean = false;
    skuListLimit: number = 50;
    newProductsListLimit: number = 20;
    skuFilter: string = '';
    newProductsFilter: string = '';
    ctmSkuFilter: string = '';
    debounceMinRetailPrice!: () => void;
    serverConfigTimeout: number | null = null;
    loadingConfigs = false;
    loadingConfigsForSetupMaster = false;
    marginalErrorText = '';
    marginalErrorTextForSetupMaster = '';
    maxMarginalErrorText = '';
    globalIndividualMarginalErrorText = '';
    globalNewProductIndividualMarginalErrorText = '';
    globalNewProductIndividualMarginalBlockButton = false;
    globalIndividualMarginalBlockButton = false;
    globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
    globalIndividualPriceIncreaseLimitBlockButton = false;
    marginalSkuErrorText = '';
    priceExperimentFilter: 'all' | 'checked' | 'unchecked' = 'all';

    taskData: TaskAndFile | null = null;
    skuListPerPage: number = 20;
    newProductListPerPage: number = 20;
    newProductsListCurrentPage: number = 1;
    skuListTotalRows: number = 0;
    newProductsListTotalRows: number = 0;
    calcSkuLastPricesButtonDisabled: boolean = false;
    calcSkuActualProfitButtonDisabled: boolean = false;
    firstDate: number = 0;
    setupMasterFirstDate: number = 0;
    lastDate: number = 0;
    setupMasterLastDate: number = 0;
    showBookmarks: boolean = true;
    showMainFilters: boolean = true;
    needLoadSkuList = false;
    needLoadNewProductList: boolean = false;
    needLoadCtmProductList: boolean = false;
    isActualProfitabilityCalculated: boolean = false;
    isActualProfitabilityCalculatedForSetupMaster: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculatedForSetupMaster: boolean = false;
    isDataRangeCalculated: boolean = false;
    isDataRangeCalculatedForSetupMaster: boolean = false;
    isPriceCorridorCalculated: boolean = false;
    isPriceCorridorCalculatedForSetupMaster: boolean = false;
    isFetchSkuListDownload: boolean = false;
    isFetchNewProductsListDownload: boolean = false;
    isFetchCtmProductsListDownload: boolean = false;
    isLoadCompetitorPrices: boolean = false;
    kviSaveProcess: boolean = false;
    useFindKviRecommendsParam: boolean = false;
    newProductsLastPage: number = 0;
    paramsRulesKey: number = 1;
    tabs: BTabs | null = null;
    loadProgress: boolean = false;
    progressCounter: number = 0;
    rulesDateRange: string[] = [];
    usersFioList: Array<SelectBox<string>> = [];
    selectUserFio: string = {value: 'All', label: this.$t('regular.common.all') as string}.value;
    showDeleteFileModal: boolean = false;
    fileIdForDelete: number = -1;

    sortingField: SortingField | null = null
    sortByInternalCode: number = -1;
    sortByStoreFormat: number = -1;
    sortByStoreRegion: number = -1;
    sortBySkuName: number = -1;
    sortByCompetitorName: number = -1;
    sortByCompetitorPriority: number = -1;
    sortByLastPrice: number = -1;
    sortByPromoPrice: number = -1;
    sortByCompetitorPrice: number = -1;
    sortByDelta: number = -1;
    sortByKvi: number = -1;
    sortByCtm: number = -1;
    sortByDataIndexCharacteristicOfTheProductIsOne: number = -1;
    sortByDataIndexCharacteristicOfTheProductIsTwo: number = -1;
    sortByCompetitorDate: number = -1;

    GROUP = 'GROUP';
    CATEGORY = 'CATEGORY';
    SUB_CATEGORY = 'SUB_CATEGORY';
    FORMAT = 'FORMAT';
    REGION = 'REGION';
    PRODUCT_SEGMENT = 'PRODUCT_SEGMENT';
    CLASTER = 'CLASTER';
    COMPANY = 'COMPANY';

    private globalIndividualPriceStrategy: SelectBox<Coefficents> | null = null;
    private globalIndividualPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriodPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriod: SelectBox<number> | null = null;
    private globalIndividualMarginalProfitability: number | null = null;
    private globalIndividualKviStrategy: SelectBox<KviStrategies> | null = null;

    private globalIndividualPercentageOfCompetitorsPrice: string | null = null;
    private globalIndividualNewProductStrategyOpt: SelectBox<Coefficents> | null = null;
    private globalIndividualNewProductMarginalProfitability: number | null = null;
    private globalIndividualNewProductKviStrategy: SelectBox<KviStrategies> | null = null;
    private globalIndividualNewProductPercentageOfCompetitorsPrice: string | null = null;
    private globalIndividualNewProductPriceStrategy: SelectBox<NewProductPriceStrategy> | null = null;
    private globalIndividualNewProductLifespanInDays: number | null = null;

    private globalIndividualNewProductPriceGap: number | null = null;
    private useBrutForcingParams: boolean = false;
    private saveAfterOptimize: boolean = false;
    private saveAfterOptimizeForSetupMaster: boolean = false;

    private optimizationDiff: number = 0.0;
    private optimizationDiffForSetupMaster: number = 0.0;
    private showDataRange: boolean = false;
    private showDataRangeForSetupMaster: boolean = false;
    private showSku: boolean = false;

    private skuListWithCalculating: boolean = false;
    private newProductsWithCalculating: boolean = true;
    private competitorsWithCalculating: boolean = true;
    private sortBySKU: number = -1;
    private sortingNewProductsBySKU: number = -1;
    private sortCompetitorsBySKU: number = -1;
    private dropDownOpen = false;
    private dropDownOpenForSetupMaster = false;
    private dropDownOpenForRoundingRules = false;
// tslint:disable-next-line: ban-types
    private onDropdownClosed: Function | null = null;
// tslint:disable-next-line: ban-types
    private onDropdownClosedForSetupMaster: Function | null = null;
    // tslint:disable-next-line: ban-types
    private onDropdownClosedForRoundingRules: Function | null = null;
    private actualProfitability: number | null = null;
    private setupMasterActualProfitability: number | null = null;
    private regularPricesProfitability: number | null = null;
    private regularPricesProfitabilityForSetupMaster: number | null = null;
    private isFiltersChanged = 1;
    private lastPage = 0;
    private loadMorePage: number = 1;
    private findAutomaticallyPriceSegments = false;
    private findAutomaticallyPriceSegmentsForSetupMaster = false;
    private spreadByPriceSegments = true;
    private countPriceSegments = 1;
    private countPriceSegmentsForSetupMaster = 1;
    private productCodesForAddKvi: string[] = []
    private productCodesForDeleteKvi: string[] = []
    private productCodesForAddCtmPurpose: string[] = []
    private productCodesForDeleteCtmPurpose: string[] = []
    private needCalculateSkuLastPricesOnly: boolean = false;
    private needCalculateSkuActualProfitabilityOnly: boolean = false;
    private needLoadFiltersForTable: boolean = true;
    private refreshRulesListId = -1;
    private httpExecutor: HttpExecutor = new HttpExecutor();
    private viz: any | null = null;
    private rulesLimit: number = 20;

    private filterTypeForSavingRules: string|null = null;
    private roundingRulesTableIsLoading: boolean = false;
    private uploadRoundingFileButtonLoader: boolean = false;

    private supersetFilterIds = {
        GROUP: getEnv('SUPERSET_FILTER_GROUP_ID'),
        CATEGORY: getEnv('SUPERSET_FILTER_CATEGORY_ID'),
        CLASTER: getEnv('SUPERSET_FILTER_CLASTER_ID'),
        COMPANY: getEnv('SUPERSET_FILTER_COMPANY_ID'),
        SUB_CATEGORY: getEnv('SUPERSET_FILTER_SUB_CATEGORY_ID'),
        FORMAT: getEnv('SUPERSET_FILTER_FORMAT_ID'),
        REGION: getEnv('SUPERSET_FILTER_REGION_ID'),
    }

    iconMode(array: any[]) {
        return (array.length === 1 && !array[0]) || !array.length
    }

    setItemsSuperset(event: number[] | number | string | null, key: string) {

        const supersetFileds: ISupersetFields = {
            GROUP: {
                label: this.$t('regular.columns.group') as string,
                id: this.supersetFilterIds.GROUP,
                targets: 'group_name',
            },
            CATEGORY: {
                label: this.$t('regular.columns.category') as string,
                id: this.supersetFilterIds.CATEGORY,
                targets: 'category',
            },
            SUB_CATEGORY: {
                label: this.$t('regular.columns.subcategory') as string,
                id: this.supersetFilterIds.SUB_CATEGORY,
                targets: 'subcategory',
            },
            FORMAT: {
                label: this.$t('regular.columns.format') as string,
                id: this.supersetFilterIds.FORMAT,
                targets: 'format',
            },
            REGION: {
                label: this.$t('regular.columns.region') as string,
                id: this.supersetFilterIds.REGION,
                targets: 'region',
            },
            CLASTER: {
                label: this.$t('regular.columns.cluster') as string,
                id: this.supersetFilterIds.CLASTER,
                targets: 'cluster',
            },
            COMPANY: {
                label: this.$t('regular.columns.company') as string,
                id: this.supersetFilterIds.COMPANY,
                targets: 'company',
            },
        };

        const getlabel = (event: number[] | number | string | null) => {
            if (typeof event !== 'string') {
                const commonArrayWithValues = Object.values(this.taskInfo).flat();
                if (Array.isArray(event)) {
                    const getLabelsArray = event.map((val) => {
                        const findCurrentObj = commonArrayWithValues.find((i) => i.value === val);
                        return findCurrentObj ? findCurrentObj.label : null;
                    })

                    if (getLabelsArray[0] === this.$t('regular.common.all')) {
                        const allLabels = this.taskInfo.subcategories.map((sub) => sub.label).slice(1);
                        return allLabels;
                    }

                    return getLabelsArray[0] ? getLabelsArray : null;
                }

                const getCurrentObj = commonArrayWithValues.find((i) => i.value === event);

                return getCurrentObj.label;
            }
            return event;
        };


        const selectedFiltersRison: string | null = localStorage.getItem('FILTERS_SUPERSET');
        const label = event !== null && getlabel(event);
        const parseToObject = selectedFiltersRison === null ? {} : JSON.parse(selectedFiltersRison);

        parseToObject[key] = label ? parseRisonForSP(supersetFileds[key], label) : '';

        localStorage.setItem('FILTERS_SUPERSET', JSON.stringify(parseToObject));

        const joinFiltersRison: string = `(${Object.values(parseToObject)
            .filter((i) => i)
            .join(',')})`;
        localStorage.setItem('FILTER_FOR_SUPERSET', joinFiltersRison);
    }

    handleScroll(): boolean {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const scrollBottom = documentHeight - (scrollTop + windowHeight);
        console.log('Достигнут ! ', scrollBottom);

        if (scrollBottom === 0) {
            console.log('Достигнут конец страницы!');
            // Выполняйте здесь нужные действия
        }
        return true
    }

    rulesButtonDisable(): boolean {
        return this.file == null
            || this.filterTypeForSavingRules == null;
    }

    refreshRoundingRulesListBySelectedFilters() {
        // this.rulesTableKey = Math.random()
        this.refreshRoundingRulesList()
    }

    refreshRoundingRulesList() {
        const pager = {...this.pagination};
        pager.current = 1;
        this.pagination = pager;
        this.fetchRulesList({currentPage: this.pagination.current}, () => {
        })
    }

    isOKRBCodesEnabled() {
        return localStorage.getItem('isOKRBCodesEnabled') === 'true'
    }

    showSaveModal(codeOKRB = null) {
        if (codeOKRB !== null && typeof codeOKRB !== 'object') {
            this.loadCodeOKRB(String(codeOKRB));
            (this.$refs.saveCodeOKRBModal as any).show();
        } else {
            (this.$refs.saveCodeOKRBModal as any).show();
        }
    }

    hideSaveModal() {
        (this.$refs.saveCodeOKRBModal as any).hide();
    }

    beforeDeleteFileDialogCodeOKRB(codeOKRB: string) {
        this.showDeleteCodeOKRBModal = true;
        this.codeOKRBForDelete = codeOKRB;
    }

    showDeleteCodeOKRBDialog(codeOKRB: string) {
        this.deleteCodeOKRB(codeOKRB);
    }

    deleteCodeOKRB(codeOKRB: string) {
        this.$http.delete('/api/code-okrb', {params: {codeOKRB}})
            .then(() => {
                this.refreshDetailTable()
            })
            .catch((err) => {
                this.showError(this.$t('regular.errors.deleteOkrbFailed') as string);
            });
    }

    loadCodesOKRB() {
        this.httpGetOKRBCodes(this.$calc.selectMarket.id)
            .then((r) => {
                    this.OKRBCodes = r.data;
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadOkrbCodesFailed') as string);
            });
    }

    loadCodeOKRB(codeOKRB: string) {
        this.httpGetOKRBCode(codeOKRB)
            .then((r) => {
                    this.codeOKRBToSave = r.data;
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadOkrbCodesFailed') as string);
            });
    }

    saveCodeOKRB(event: BvModalEvent) {
        event.preventDefault();
        this.codeOKRBToSave.tradingId = this.$calc.selectMarket.id
        this.httpUpsertOKRBCode(this.codeOKRBToSave)
            .then(() => {
                this.hideSaveModal();
                this.refreshDetailTable()
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadOkrbCodesFailed') as string);
            });
    }

    saveCodeOKRBScenario(event: any) {
        this.codeOKRBToSave.scenario = event.label
    }

    startSaveStateAvailableCheck() {
        // const isSaveStateAvailable = localStorage.getItem('isSaveStateAvailable') === 'true';
        // setInterval(() => {
        //     this.saveState();
        // }, 500);
        //
        // this.saveState();
    }

    saveState(): boolean {
        return !((this.$calc.groupOfProduct != null && this.$calc.groupOfProduct > 0)
                || (this.$calc.categoryOfProduct != null && this.$calc.categoryOfProduct > 0))
    }

    uploadFile(event: Event) {
        event.preventDefault();
        if (!this.file) {
            this.showInfo(this.$t('regular.common.selectFile') as string);
            return;
        }
        const uploadFile = new FormData();
        this.loadProgress = true;
        const size = this.file.size;
        uploadFile.append('file', new Blob([this.file]), this.file.name);
        const self = this;
        const onUploadProgress = (e: any) => {
            const s = e.loaded / size;
            self.progressCounter = (s * 100) > 100 ? 100 : Math.round(s * 100);
        };

        // tslint:disable-next-line: no-non-null-assertion
        this.httpUploadFile(this.$calc.selectMarket.id, FileType.OKRBCODES, uploadFile, onUploadProgress)
            .then(() => {
                (this.$refs.fileinput as BFormFile).reset();
                this.file = null;
                this.refreshDetailTable()
                this.$nextTick(() => {
                    this.loadProgress = false;
                    this.progressCounter = 0;
                });
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadFileFailedSpace') as string);
                this.loadProgress = false;
                this.progressCounter = 0;
                this.file = null;
                (this.$refs.fileinput as BFormFile).reset();
            });
    }

    beforeDeleteFileDialog(fileId: number) {
        this.fileIdForDelete = fileId;
        this.showDeleteFileModal = true;
    }

    showDeleteFileDialog(ruleId: number) {
      this.httpDeleteRoundingRulesFile(ruleId)
          .finally(() => {
              this.refreshRoundingRulesList();
          });
    }

    clearRoundingRulesFilters() {
        this.rulesDateRange = []
        this.selectUserFio = {value: 'All', label: this.$t('regular.common.all') as string}.value;
        this.usersFioList = []
        this.selectCategoryFilter = this.defaultFilterValue.value;
        this.categoryFilterOptions = []
        this.selectGroupFilter = this.defaultFilterValue.value;
        this.groupFilterOptions = []
        this.selectSubcategoryFilter = this.defaultFilterValue.value;
        this.subcategoryFilterOptions = []
        this.selectFormatFilter = this.defaultFilterValue.value;
        this.formatFilterOptions = []
        this.selectRegionFilter = this.defaultFilterValue.value;
        this.regionFilterOptions = []
        this.selectClusterFilter = this.defaultFilterValue.value;
        this.clusterFilterOptions = []
        this.needLoadFiltersForTable = true;
        this.refreshRoundingRulesList()
    }

    fetchRulesList(ctx: any, callback: (items: any[]) => void) {
        const offset = (ctx.currentPage - 1) * this.pagination.pageSize;
        const filter = this.getRoundingListFilter();
        const tradingId = this.$roundingRules.selectMarket.id;

        this.roundingRulesTableIsLoading = true
        this.httpLoadRoundingRules(filter, this.pagination.pageSize, offset)
            .then((res) => {
                    if (this.needLoadFiltersForTable) {
                        this.httpLoadRoundingRulesFilters(tradingId, 'BASE')
                            .then((r) => {
                                const result = r.data

                                const categories = result.categories.filter((i) => {
                                    return i.name !== '';
                                });
                                this.categoryFilterOptions = categories.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const groups = result.groupsOfProduct.filter((i) => {
                                    return i.name !== '';
                                });
                                this.groupFilterOptions = groups.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const subcategories = result.subcategories.filter((i) => {
                                    return i.name !== '';
                                });
                                this.subcategoryFilterOptions = subcategories.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const storeFormat = result.storeFormat.filter((i) => {
                                    return i.name !== '';
                                });
                                this.formatFilterOptions = storeFormat.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const regions = result.storeRegionValues.filter((i) => {
                                    return i.name !== '';
                                });
                                this.regionFilterOptions = regions.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const clusters = result.storeCluster.filter((i) => {
                                    return i.name !== '';
                                });
                                this.clusterFilterOptions = clusters.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                this.tradingsFilterOptions.unshift(this.defaultFilterValue);
                                this.categoryFilterOptions.unshift(this.defaultFilterValue);
                                this.groupFilterOptions.unshift(this.defaultFilterValue);
                                this.subcategoryFilterOptions.unshift(this.defaultFilterValue);
                                this.formatFilterOptions.unshift(this.defaultFilterValue);
                                this.regionFilterOptions.unshift(this.defaultFilterValue);
                                this.clusterFilterOptions.unshift(this.defaultFilterValue);

                                this.httpGetRoundingRulesUsersFio(tradingId)
                                    .then((response) => {
                                        this.usersFioList = response.data.map((i) => {
                                            return {value: i, label: i}
                                        });
                                        this.usersFioList.unshift({value: 'All', label: this.$t('regular.common.all') as string});
                                    })
                                    .catch((e) => {
                                        this.showError(this.$t('regular.errors.loadUserListFailed') as string);
                                    });

                                this.needLoadFiltersForTable = false;
                            })
                    }
                    const pagination = {...this.pagination};
                    pagination.total = res.data.totalElements;
                    this.pagination = pagination;
                    this.rulesTotalRows = res.data.totalElements;
                    this.rulesTableItems = res.data.content;
                    callback(res.data.content);
                },
            )
            .catch((e) => {
                callback([]);
            }).finally(() => {
                this.roundingRulesTableIsLoading = false
            });
    }

    downloadRoundingRulesFile(fileId: number) {
        this.$http.get('/api/file/download-rules-file', {
            method: 'GET',
            responseType: 'blob',
            params: {
                ruleId: fileId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.$t('regular.files.rulesXlsx') as string);
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.downloadRulesFileFailed') as string);
            });
    }

    downloadRoundingErrorFile(fileId: number) {
        this.$http.get('/api/file/download-rules-error-file', {
            method: 'GET',
            responseType: 'blob',
            params: {
                ruleId: fileId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.$t('regular.columns.errors') as string);
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.downloadErrorFileFailed') as string);
            });
    }

    uploadRoundingFile(event: Event) {
        if (!this.file) {
            this.showInfo(this.$t('regular.common.selectFile') as string);
            return;
        }
        if (!this.filterTypeForSavingRules) {
          this.showError(this.$t('regular.common.selectProductType') as string)
        }

        const uploadFile = new FormData();
        this.loadProgress = true;
        const size = this.file.size;
        uploadFile.append('file', new Blob([this.file]), this.file.name);
        const self = this;
        const onUploadProgress = (e: any) => {
            const s = e.loaded / size;
            self.progressCounter = (s * 100) > 100 ? 100 : Math.round(s * 100);
        };
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectDataForRoundingRulesSeasonsRegions();
        const filters: BaseFilterRoundingRules = {
            category: this.$roundingRules.categoryOfProduct,
            productSegments: LocalData.filterNumberArrays(this.$roundingRules.productSegments),
            storeCluster: this.$roundingRules.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            storeFormat: this.$roundingRules.formatSelected,
            tradingId: this.$roundingRules.selectMarket.id,
            groupOfProduct: this.$roundingRules.groupOfProduct,
            categoryStrategy: this.$roundingRules.categoryStrategy.value,
            filterType: this.filterTypeForSavingRules!!,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$roundingRules.subcategories)!!,
            allNewPricesWithoutPennies: this.$roundingRules.allNewPricesWithoutPennies,
            pennies: this.$roundingRules.pennies,
            randomPennies: this.$roundingRules.randomPennies,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            bigDigit: this.$roundingRules.bigDigit,
            manualPennies: this.$roundingRules.manualPennies,
        };

        uploadFile.append('filters', new Blob([JSON.stringify(filters)], {type: 'application/json'}));

        this.uploadRoundingFileButtonLoader = true
        this.httpUploadRoundingRule(uploadFile, onUploadProgress)
            .then((r) => {
                // this.showInfo(r.data);
                (this.$refs.fileinput as BFormFile).reset();
                this.file = null;
                // (this.$refs.rulesTable as any).refresh();
                this.$nextTick(() => {
                    this.loadProgress = false;
                    this.progressCounter = 0;
                });
            })
            .catch((e) => {
                (this.$refs.fileinput as BFormFile).reset();
                const dataWithoutStatus = e.response.data.replace(/[0-9]/g, '');
                this.showError(this.$t('regular.errors.loadFileFailedSpace') as string + dataWithoutStatus);
                this.loadProgress = false;
                this.progressCounter = 0;
                this.file = null;
            })
            .finally(() => {
                this.uploadRoundingFileButtonLoader = false
                this.refreshRoundingRulesList()
            });
    }

    mounted() {
        localStorage.setItem('isSaveStateAvailable', 'false')
        setInterval(() => {
            this.saveState()
        }, 1000);
        this.startSaveStateAvailableCheck()
        this.$setupMasterCalc = this.getCalcDefaultData();
        this.tabs = this.$refs.mainTabs as BTabs
        if (this.$calc.selectMarket.id !== -1) {
            this.$refs.groupSelectedRef && (this.$refs.groupSelectedRef as any).toggleLoading(true);
            this.$refs.updateRegionsRef && (this.$refs.updateRegionsRef as any).toggleLoading(true);
            this.$refs.updateSeasonsRef && (this.$refs.updateSeasonsRef as any).toggleLoading(true);
            this.$refs.updateBuyerSegmentsRef && (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
            this.$refs.formatSelectedRef && (this.$refs.formatSelectedRef as any).toggleLoading(true);
            this.$refs.clasterSelectedRef && (this.$refs.clasterSelectedRef as any).toggleLoading(true);
            this.$refs.groupOfProductRef && (this.$refs.groupOfProductRef as any).toggleLoading(true);
            this.$refs.subcategoriesRef && (this.$refs.subcategoriesRef as any).toggleLoading(true);
            this.$refs.productSegmentsRef && (this.$refs.productSegmentsRef as any).toggleLoading(true);
            this.$refs.categoryStrategyRef && (this.$refs.categoryStrategyRef as any).toggleLoading(true);

          const loadingTasks: Promise<any>[] = [
            this.getCategoryInfo(),
            this.getRegionInfo(),
            this.getFormatInfo(),
            this.getBuyerSegment(),
            this.getClusterInfo(),
            this.loadProductsGroup(),
            this.loadProductsSubcategories(),
            this.loadProductSegments()
          ];
          Promise.all(loadingTasks).then(() => {
            // Список товаров больше не загружается автоматически при открытии вкладки
          });
          setTimeout(() => { this.$refs.categoryStrategyRef && (this.$refs.categoryStrategyRef as any).toggleLoading(false); }, Math.floor(Math.random() * (800 - 300 + 1)) + 300);
        }
        this.initDefaultMarketForCalcAndRounding();
        this.getFilterInfoForRoundingRules();

        EventBus.$on('calc', this.onCalcEventReceived);
        EventBus.$on('tradingNetChanged', this.updateSelectMarket);
        this.$calc.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('regular.strategies.maxGrossMargin') as string}

        const pager = {...this.pagination};
        pager.current = 1;
        this.pagination = pager;

        this.fetchRulesList({currentPage: this.pagination.current}, () => {
        })
    }

    onRulesTableChange(pagination: any) {
        const pager = {...this.pagination};
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchRulesList({
            currentPage: pagination.current,
            perPage: pagination.pageSize,
        }, () => {
        });
    }

    onCompetitorsTableChange(pagination: any, filters: any, sorter: any) {
        this.competitorsTablePagination.current = pagination.current;
        this.competitorsTablePagination.pageSize = pagination.pageSize;

        if (sorter.field && sorter.order) {
            this.sortingField = {fieldName: sorter.field, sortValue: sorter.order === 'ascend' ? 0 : 1}
        } else if (this.sortingField) {
            this.sortingField = null;
        }

        this.listCompetitors();
    }

    onSearch(callback: any, mode: string = '') {
        this.isFiltersChanged = 1

        if (mode && mode === 'productsTab') {
            this.loadMorePage = 1;
        }

        callback(1)
    }

    handleFilter(callback: any, mode: string = '') {
        this.isFiltersChanged = 1;

        if (mode && mode === 'productsTab') {
            this.loadMorePage = 1;
        }

        callback()
    }

    handleTableChange(pagination: any, filters: any, sorter: any) {
        //   getTableFields
        this.isFiltersChanged = 1;
        this.fetchSkuList(pagination.current);
    }

    handleNewTableChange(pagination: any, filters: any, sorter: any) {
        // getNewProductsTableFields
        this.newProductsListCurrentPage = pagination.current;
        this.fetchNewProductsList(pagination.current);
    }

    handleCTMTableChange(pagination: any, filters: any, sorter: any) {
        // getTableSkuFields
        this.isFiltersChanged = 1;

        this.ctmProductsTablePagination.current = pagination.current;
        this.ctmProductsTablePagination.pageSize = pagination.pageSize;

        this.fetchCtmList(pagination.current);
    }

    get skuListForDisplay() {
        if (this.priceExperimentFilter === 'checked') {
            return this.tableDataSkuList.filter((row: any) => !!row.priceExperiment);
        }

        if (this.priceExperimentFilter === 'unchecked') {
            return this.tableDataSkuList.filter((row: any) => !row.priceExperiment);
        }

        return this.tableDataSkuList;
    }

    get areAllPriceExperimentChecked(): boolean {
        const list = this.skuListForDisplay;
        return list.length > 0 && list.every((row: any) => !!row.priceExperiment);
    }

    onPriceExperimentCheckboxChange(record: any, event: any) {
        const checked = event.target.checked;
        (this as any).$set(record, 'priceExperiment', checked);
        this.setCalcIndividConfig(this.$calc.individualCommonParams, record.internalCode, 'priceExperiment', checked);
        this.saveCalc();
    }

    onPriceExperimentHeaderCheckboxChange(event: any) {
        const checked = event.target.checked;
        const list = this.skuListForDisplay;

        list.forEach((row: any) => {
            (this as any).$set(row, 'priceExperiment', checked);
            this.setCalcIndividConfig(this.$calc.individualCommonParams, row.internalCode, 'priceExperiment', checked);
        });
        this.saveCalc();
    }

    onByPromoPricesChange(record: any, event: any) {
        const checked = event.target.checked;
        (this as any).$set(record, 'byPromoPrices', checked);
        this.setCalcIndividConfig(this.$calc.individualCommonParams, record.internalCode, 'byPromoPrices', checked);
        this.saveCalc();

    }

    getFilterInfoForRoundingRules() {
        if (this.$roundingRules.selectMarket.id !== -1) {
            const self = this;
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesGroupSelectedRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesUpdateRegionsRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesUpdateSeasonsRef as any).toggleLoading(true);
            // (this.$refs.roundingRulesUpdateBuyerSegmentsRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesFormatSelectedRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesClasterSelectedRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesGroupOfProductRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesSubcategoriesRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesProductSegmentsRef as any).toggleLoading(true);
            this.getCategoryInfoForRoundingRules();
            self.getRegionInfoForRoundingRules();
            self.getFormatInfoForRoundingRules();
            // self.getBuyerSegmentForRoundingRules();
            self.getClusterInfoForRoundingRules();
            self.loadProductsGroupForRoundingRules();
            self.loadProductsSubcategoriesForRoundingRules();
            self.loadProductSegmentsForRoundingRules();
        }
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }
    }

    disableCalcPurchasePriceByClustersCheckbox() {
        if (!this.$calc.countByAvgPurchasePrice) {
            this.$calc.calcPurchasePriceByClusters = false;
            this.$calc.useArrivalDate = false;
        }
        if (this.$calc.countByAvgPurchasePrice) {
            this.$calc.countAtFuturePurchasePrice = false;
        }
    }

    disableCalcPurchasePriceByClustersCheckboxForSetupMaster() {
        if (!this.$setupMasterCalc.countByAvgPurchasePrice) {
            this.$setupMasterCalc.calcPurchasePriceByClusters = false;
            this.$setupMasterCalc.useArrivalDate = false;
        }
        if (this.$setupMasterCalc.countByAvgPurchasePrice) {
            this.$setupMasterCalc.countAtFuturePurchasePrice = false;
        }
    }

    disableCountByAvgPurchasePriceAndCalcPurchasePriceByClustersCheckboxes(eventCheckBox: boolean) {
        if (eventCheckBox) {
            this.$calc.calcPurchasePriceByClusters = false;
        }
    }

    disableCalcPurchasePriceByClustersCheckboxesForSetupMaster(eventCheckBox: boolean) {
        if (eventCheckBox) {
            this.$calc.calcPurchasePriceByClusters = false;
        }
    }

    destroyed() {
        if (this.viz != null) {
            this.viz.dispose();
        }

    }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = []
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('tradingNetChanged', this.updateSelectMarket);
    }

    created() {
        this.httpLoadModuleHints('Calc').then((r) => {
            this.$calc.currentModuleHints = r.data
            this.$calc.hintsLoaded = true
        }).catch((e) => {
        });
        const self = this;
        this.debounceMinRetailPrice = _.debounce(() => {
            self.checkPriceCorridorMinVal()
        }, 500);
    }

    onTabsChanged(evt: number) {
        if (evt === 6) {
            (this.$refs.competitorsListRef as any).activate();
        } else {
            (this.$refs.competitorsListRef as any).deactivate();
        }
    }

    resetTables() {
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
    }

    resetActualProfitability() {
        this.actualProfitability = null;
    }

    resetActualProfitabilityForSetupMaster() {
        this.setupMasterActualProfitability = null;
    }

    resetRegularPricesProfitability() {
        this.regularPricesProfitability = null;
    }

    resetRegularPricesProfitabilityForSetupMaster() {
        this.regularPricesProfitabilityForSetupMaster = null;
    }

    resetData(type: TaskInfoFilterType) {
        this.skuListWithCalculating = false;
        switch (type) {
            case TaskInfoFilterType.group:
                this.$calc.categoryOfProduct = null;
                this.$calc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.formatSelected = null;
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.$calc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                this.taskInfo.subcategories = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                Promise.all([
                  this.getCategoryInfo(null),
                  this.loadProductsSubcategories(),
                  this.loadProductSegments(),
                  this.getFormatInfo(),
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ]);
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.category:
                this.$calc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.formatSelected = null;
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.$calc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.subcategories = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                Promise.all([
                  this.loadProductsSubcategories(),
                  this.loadProductSegments(),
                  this.getFormatInfo(),
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ])
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.subcategory:
                this.$calc.formatSelected = null;
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.$calc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                Promise.all([
                  this.loadProductSegments(),
                  this.getFormatInfo(),
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ])
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$calc.formatSelected = null;
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfo.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                Promise.all([
                  this.getFormatInfo(),
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ])
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.format:
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.taskInfo.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                Promise.all([
                  this.loadProductSegments(),
                  this.getRegionInfo(),
                  this.getClusterInfo()
                ])
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.region:
                this.$calc.clusterSelected = null;
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                Promise.all([
                  this.loadProductSegments(),
                  this.getClusterInfo()
                ])
                this.viewCompetitors = []
                this.competitors = []
                break;
        }
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.updateDataRange();
        this.hideSkuPanel();
        this.sortBySKU = -1;
        this.resetActualProfitability();
        this.resetRegularPricesProfitability();
        this.isFiltersChanged = 1;
        this.needLoadSkuList = false;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.needLoadNewProductList = false;
        this.taskId = 0;
        this.fileResult = '';
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.productCodesForAddCtmPurpose = [];
        this.productCodesForDeleteCtmPurpose = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.keyCharacteristicOneOptions = [];
        this.keyCharacteristicTwoOptions = [];
        this.keyCharacteristicThreeOptions = [];
        this.keyCharacteristicFourOptions = [];
        this.keyCharacteristicFiveOptions = [];
        this.recipeAttributesOptions = [];
        this.treatmentAttributesOptions = [];
        this.keyCharacteristicOneForNewProductOptions = [];
        this.keyCharacteristicTwoForNewProductOptions = [];
        this.keyCharacteristicThreeForNewProductOptions = [];
        this.keyCharacteristicFourForNewProductOptions = [];
        this.keyCharacteristicFiveForNewProductOptions = [];
        this.recipeAttributesForNewProductOptions = [];
        this.treatmentAttributesForNewProductOptions = [];
        this.newProductSegmentIdAndNameOptions = [];
        this.clearFiltersInNewProductsTable();
    }

    resetDataForSetupMaster(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$setupMasterCalc.categoryOfProduct = null;
                this.$setupMasterCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.formatSelected = null;
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.$setupMasterCalc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForSetupMaster.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                this.taskInfoForSetupMaster.subcategories = [];
                this.taskInfoForSetupMaster.psegemnts = [];
                this.taskInfoForSetupMaster.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.getCategoryInfoForSetupMaster(null);
                this.loadProductsSubcategoriesForSetupMaster();
                this.loadProductSegmentsForSetupMaster();
                this.getFormatInfoForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.category:
                this.$setupMasterCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.formatSelected = null;
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.$setupMasterCalc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForSetupMaster.subcategories = [];
                this.taskInfoForSetupMaster.psegemnts = [];
                this.taskInfoForSetupMaster.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductsSubcategoriesForSetupMaster();
                this.loadProductSegmentsForSetupMaster();
                this.getFormatInfoForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.subcategory:
                this.$setupMasterCalc.formatSelected = null;
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.$setupMasterCalc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForSetupMaster.psegemnts = [];
                this.taskInfoForSetupMaster.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegmentsForSetupMaster();
                this.getFormatInfoForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$setupMasterCalc.formatSelected = null;
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.taskInfoForSetupMaster.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.getFormatInfoForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.format:
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegmentsForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.region:
                this.$setupMasterCalc.clusterSelected = null;
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegmentsForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
        }
        this.updateDataRangeForSetupMaster();
        this.resetActualProfitabilityForSetupMaster();
        this.resetRegularPricesProfitabilityForSetupMaster();
    }

    resetDataForRoundingRules(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$roundingRules.categoryOfProduct = null;
                this.$roundingRules.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForRoundingRules.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                this.taskInfoForRoundingRules.subcategories = [];
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.getCategoryInfoForRoundingRules(null);
                this.loadProductsSubcategoriesForRoundingRules();
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.category:
                this.$roundingRules.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForRoundingRules.subcategories = [];
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductsSubcategoriesForRoundingRules();
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.subcategory:
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.format:
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.storeRegionOptions = [{value: 0, label: this.$t('regular.common.all') as string}];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegmentsForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.region:
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('regular.common.selectCluster') as string}];
                this.loadProductSegmentsForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
        }
    }

    onStepChange(current: number) {
        this.setupMasterStep = current;
    }

    setSetupMasterStepNext(stepNumber: number) {
        this.setupMasterStep = stepNumber + 1;
    }

    setSetupMasterStepPrevios(stepNumber: number) {
        this.setupMasterStep = stepNumber - 1;
    }

    updateProductGroup(groupOfProduct: number | null, key: string) {
        console.log("groupOfProduct", key)
        this.setItemsSuperset(groupOfProduct, key)
        if (groupOfProduct !== this.$calc.groupOfProduct) {
            this.resetPriceCorridor();
            this.resetDataRange();
            this.$calc.groupOfProduct = groupOfProduct;
            this.saveCalc();
            this.resetData(TaskInfoFilterType.group);
            this.updatePriceCorridorAndSkuList();
        }
    }

    updateProductGroupForRoundingRules(groupOfProduct: number | null) {
        if (groupOfProduct !== this.$roundingRules.groupOfProduct) {
            this.$roundingRules.groupOfProduct = groupOfProduct;

            this.resetDataForRoundingRules(TaskInfoFilterType.group)
            this.saveRoundingRules();
            // this.resetData(TaskInfoFilterType.group);
            // this.updatePriceCorridorAndSkuList();
        }
    }

    updateProductGroupForSetupMaster(groupOfProduct: number | null) {
        if (groupOfProduct !== this.$setupMasterCalc.groupOfProduct) {
            this.resetPriceCorridorForSetupMaster();
            this.resetDataRangeForSetupMaster();
            this.$setupMasterCalc.groupOfProduct = groupOfProduct;
            const group = this.taskInfoForSetupMaster.groupsOfProduct.find((item) => {
                return item.value === groupOfProduct
            });
            if (group !== undefined) {
                this.setupMasterGroupName = group.label
            }
            this.saveSetupMasterCalc();
            this.resetDataForSetupMaster(TaskInfoFilterType.group);
            this.updatePriceCorridorForSetupMaster();
        }
    }

    updateCluster(cluster: number | null, key: string) {
        this.setItemsSuperset(cluster, key)
        if (cluster !== this.$calc.clusterSelected) {
            this.resetPriceCorridor();
            this.$calc.clusterSelected = cluster;
            this.resetData(TaskInfoFilterType.cluster);
            this.saveCalc();
            this.updatePriceCorridorAndSkuList();
        }
    }

    updateClusterForSetupMaster(cluster: number | null) {
        if (cluster !== this.$setupMasterCalc.clusterSelected) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.clusterSelected = cluster;
            const obj = this.taskInfoForSetupMaster.clusterOptions.find((item) => {
                return item.value === cluster
            });
            if (obj !== undefined) {
                this.setupMasterClusterName = obj.label
            }
            this.resetDataForSetupMaster(TaskInfoFilterType.cluster);
            this.saveSetupMasterCalc();
            this.updatePriceCorridorForSetupMaster();
        }
    }

    updateClusterForRoundingRules(cluster: number | null) {
        if (cluster !== this.$roundingRules.clusterSelected) {
            this.$roundingRules.clusterSelected = cluster;
            this.resetDataForRoundingRules(TaskInfoFilterType.cluster);
            this.saveRoundingRules();
        }
    }

    updateProductCategory(category: number | null, key: string) {
        this.setItemsSuperset(category, key)
        if (category !== this.$calc.categoryOfProduct) {
            this.resetPriceCorridor();
            this.$calc.categoryOfProduct = category;
            this.updatePriceCorridorAndSkuList();
            this.resetIndividualConfigs();
            this.resetData(TaskInfoFilterType.category);
            this.saveCalc();
        }
    }

    updateProductCategoryForSetupMaster(category: number | null) {
        if (category !== this.$setupMasterCalc.categoryOfProduct) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.categoryOfProduct = category;
            const obj = this.taskInfoForSetupMaster.categoryOptions.find((item) => {
                return item.value === category
            });
            if (obj !== undefined) {
                this.setupMasterCategoryName = obj.label
            }
            this.updatePriceCorridorForSetupMaster();
            this.resetDataForSetupMaster(TaskInfoFilterType.category);
            this.saveSetupMasterCalc();
        }
    }

    updateProductCategoryForRoundingRules(category: number | null) {
        if (category !== this.$roundingRules.categoryOfProduct) {
            // this.resetPriceCorridorForSetupMaster();
            this.$roundingRules.categoryOfProduct = category;
            this.updatePriceCorridorForSetupMaster();
            this.resetDataForRoundingRules(TaskInfoFilterType.category);
            this.saveRoundingRules();
        }
    }

    updateFormat(format: number | null) {
        this.setItemsSuperset(format, 'FORMAT')
        if (format !== this.$calc.formatSelected) {
            this.resetPriceCorridor();
            this.$calc.formatSelected = format;
            this.updatePriceCorridorAndSkuList();
            this.resetData(TaskInfoFilterType.format);
            this.saveCalc();
        }
    }

    updateFormatForSetupMaster(format: number | null) {
        if (format !== this.$setupMasterCalc.formatSelected) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.formatSelected = format;
            const obj = this.taskInfoForSetupMaster.storeFormatOptions.find((item) => {
                return item.value === format
            });
            if (obj !== undefined) {
                this.setupMasterFormatName = obj.label
            }
            this.updatePriceCorridorForSetupMaster();
            this.resetDataForSetupMaster(TaskInfoFilterType.format);
            this.saveSetupMasterCalc();
        }
    }

    updateFormatForRoundingRules(format: number | null) {
        if (format !== this.$roundingRules.formatSelected) {
            this.$roundingRules.formatSelected = format;
            this.resetDataForRoundingRules(TaskInfoFilterType.format);
            this.saveRoundingRules();
        }
    }

    resetIndividualConfigs() {
        const individualCommonParams = Object.assign({}, this.$calc.individualCommonParams);

        Object.keys(individualCommonParams).forEach(internalCode => individualCommonParams[internalCode] = {});

        this.$calc.individualCommonParams = individualCommonParams;
    }

    updateRegions(list: number[]) {
        this.setItemsSuperset(list, 'REGION')
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.regionSelected)) {
            this.resetPriceCorridor();
            this.$calc.regionSelected = list;
            this.onDropdownClosed = () => {
                this.saveCalc();
                this.updatePriceCorridorAndSkuList();
                this.resetData(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$calc.regionSelected[0] === 0) {
            this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegionsForSetupMaster(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$setupMasterCalc.regionSelected)) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.regionSelected = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForSetupMaster.storeRegionOptions.filter((region) => list.includes(region.value!!))
                .forEach((region) => {
                    this.setupMasterRegionNames = region.label
                });
            this.onDropdownClosedForSetupMaster = () => {
                this.saveSetupMasterCalc();
                this.updatePriceCorridorForSetupMaster();
                this.resetDataForSetupMaster(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpenForSetupMaster) {
                this.onDropdownClosedForSetupMaster.apply(this.dropDownOpenForSetupMaster);
                this.onDropdownClosedForSetupMaster = null;
            }
        } else if (this.$setupMasterCalc.regionSelected[0] === 0) {
            this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegionsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.regionSelected)) {
            this.$roundingRules.regionSelected = list;
            this.onDropdownClosedForRoundingRules = () => {
                this.saveRoundingRules();
                this.resetDataForRoundingRules(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.regionSelected[0] === 0) {
            this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateBuyerSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.buyerSegmentsList)) {
            this.resetPriceCorridor();
            this.updatePriceCorridorAndSkuList();
            this.$calc.buyerSegmentsList = list;
            this.saveCalc();
        } else if (this.$calc.buyerSegmentsList[0] === 0) {
            this.$calc.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSubcategories(list: number[], key: string) {
        this.setItemsSuperset(list, key)
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.subcategories)) {
            this.resetPriceCorridor();
            this.$calc.subcategories = list;
            this.onDropdownClosed = () => {
                this.updatePriceCorridorAndSkuList();
                this.saveCalc();
                this.resetData(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$calc.subcategories[0] === 0) {
            this.$calc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }


    updateSubcategoriesForSetupMaster(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$setupMasterCalc.subcategories)) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.subcategories = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForSetupMaster.subcategories.filter((subcat) => list.includes(subcat.value!!))
                .forEach((subcat) => {
                    this.setupMasterSubcategoryNames = subcat.label
                });
            this.onDropdownClosedForSetupMaster = () => {
                this.updatePriceCorridorForSetupMaster();
                this.saveSetupMasterCalc();
                this.resetDataForSetupMaster(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpenForSetupMaster) {
                this.onDropdownClosedForSetupMaster.apply(this.dropDownOpenForSetupMaster);
                this.onDropdownClosedForSetupMaster = null;
            }
        } else if (this.$setupMasterCalc.subcategories[0] === 0) {
            this.$setupMasterCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSubcategoriesForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.subcategories)) {
            this.$roundingRules.subcategories = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForRoundingRules.subcategories.filter((subcat) => list.includes(subcat.value!!))
                .forEach((subcat) => {
                    this.setupMasterSubcategoryNames = subcat.label
                });
            this.onDropdownClosedForRoundingRules = () => {
                this.saveRoundingRules();
                this.resetDataForRoundingRules(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.subcategories[0] === 0) {
            this.$roundingRules.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }


    updateProductSegment(list: number[], key: string) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.productSegments)) {
            this.resetPriceCorridor();
            this.$calc.productSegments = list;
            this.onDropdownClosed = () => {
                this.updatePriceCorridorAndSkuList();
                this.saveCalc();
                this.resetData(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$calc.productSegments[0] === 0) {
            this.$calc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }


    updateProductSegmentsForSetupMaster(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$setupMasterCalc.productSegments)) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.productSegments = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForSetupMaster.psegemnts.filter((subcat) => list.includes(subcat.value!!))
                .forEach((subcat) => {
                    this.setupMasterSubcategoryNames = subcat.label
                });
            this.onDropdownClosedForSetupMaster = () => {
                this.updatePriceCorridorForSetupMaster();
                this.saveSetupMasterCalc();
                this.resetDataForSetupMaster(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpenForSetupMaster) {
                this.onDropdownClosedForSetupMaster.apply(this.dropDownOpenForSetupMaster);
                this.onDropdownClosedForSetupMaster = null;
            }
        } else if (this.$setupMasterCalc.productSegments[0] === 0) {
            this.$setupMasterCalc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductSegmentsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.productSegments)) {
            this.$roundingRules.productSegments = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForRoundingRules.psegemnts.filter((segmentProduct) => list.includes(segmentProduct.value!!))
                .forEach((segmentProduct) => {
                    this.setupMasterSubcategoryNames = segmentProduct.label
                });
            this.onDropdownClosedForRoundingRules = () => {
                this.saveRoundingRules();
                this.resetDataForRoundingRules(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.productSegments[0] === 0) {
            this.$roundingRules.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updatePriceSegments(list: Segment[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item.name === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item.name === 'All'
                });
                if (index2 !== -1) {
                    this.selectSegmentPrice = [];
                } else {
                    this.selectSegmentPrice = list;
                }
            } else {
                this.selectSegmentPrice = list;
            }
        }
    }

    updateKeyCharacteristicOne(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicOne = [];
                } else {
                    this.selectKeyCharacteristicOne = list;
                }
            } else {
                this.selectKeyCharacteristicOne = list;
            }
        }
    }

    updateNewProductKeyCharacteristicOne(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicOneForNewProduct = [];
                } else {
                    this.selectKeyCharacteristicOneForNewProduct = list;
                }
            } else {
                this.selectKeyCharacteristicOneForNewProduct = list;
            }
        }
    }

    updateKeyCharacteristicTwo(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicTwo = [];
                } else {
                    this.selectKeyCharacteristicTwo = list;
                }
            } else {
                this.selectKeyCharacteristicTwo = list;
            }
        }
    }

    updateNewProductKeyCharacteristicTwo(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicTwoForNewProduct = [];
                } else {
                    this.selectKeyCharacteristicTwoForNewProduct = list;
                }
            } else {
                this.selectKeyCharacteristicTwoForNewProduct = list;
            }
        }
    }

    updateRecipeAttributes(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectRecipeAttributes = [];
                } else {
                    this.selectRecipeAttributes = list;
                }
            } else {
                this.selectRecipeAttributes = list;
            }
        }
    }

    updateNewProductRecipeAttributes(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectRecipeAttributesForNewProduct = [];
                } else {
                    this.selectRecipeAttributesForNewProduct = list;
                }
            } else {
                this.selectRecipeAttributesForNewProduct = list;
            }
        }
    }

    updateTreatmentAttributes(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectTreatmentAttributes = [];
                } else {
                    this.selectTreatmentAttributes = list;
                }
            } else {
                this.selectTreatmentAttributes = list;
            }
        }
    }

    updateNewProductTreatmentAttributes(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectTreatmentAttributesForNewProduct = [];
                } else {
                    this.selectTreatmentAttributesForNewProduct = list;
                }
            } else {
                this.selectTreatmentAttributesForNewProduct = list;
            }
        }
    }

    updateProductSegmentIdAndName(list: ProductSegmentIdAndName[]) {
        // Костыль. Фильтрую потому что пришлось сделать :default_value="[{value: -1, label: 'Все'}]", т.к. класс Multiselect некорректно обрабатывает массив с 2-мя значениями
        // и вариант :default_value="[{value: {segmentId: -1, segmentName: 'All'}, label: 'Все'}]" не срабатывает
        list = list.filter((s) => {
            return typeof s.segmentName !== 'undefined' && typeof s.segmentId !== 'undefined'
        });
        if (list.length > 0) {
            console.log(list, "list")
            this.selectProductSegmentIdAndName = list;
        } else {
            this.selectProductSegmentIdAndName = [];
        }
    }

    updateSegmentIdAndNameForNewProducts(list: ProductSegmentIdAndName[]) {
        // Костыль. Фильтрую потому что пришлось сделать :default_value="[{value: -1, label: 'Все'}]", т.к. класс Multiselect некорректно обрабатывает массив с 2-мя значениями
        // и вариант :default_value="[{value: {segmentId: -1, segmentName: 'All'}, label: 'Все'}]" не срабатывает
        list = list.filter((s) => {
            return typeof s.segmentName !== 'undefined' && typeof s.segmentId !== 'undefined'
        });
        if (list.length > 0) {
            this.selectNewProductSegmentIdAndName = list;
        } else {
            this.selectNewProductSegmentIdAndName = [];
        }
    }

    updatePriceSegmentsForNewProducts(list: Segment[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item.name === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item.name === 'All'
                });
                if (index2 !== -1) {
                    this.selectSegmentPriceForNewProducts = [];
                } else {
                    this.selectSegmentPriceForNewProducts = list;
                }
            } else {
                this.selectSegmentPriceForNewProducts = list;
            }
        }
    }

    updateSeasons(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.seasonSelected)) {
            this.resetPriceCorridor();
            this.$calc.seasonSelected = list;
            this.onDropdownClosed = () => {
                this.priceCorridorInfo();
                this.saveCalc();
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$calc.seasonSelected[0] === 0) {
            this.$calc.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSeasonsForSetupMaster(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$setupMasterCalc.seasonSelected)) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.seasonSelected = list;
            this.onDropdownClosedForSetupMaster = () => {
                this.priceCorridorInfoForSetupMaster();
                this.saveSetupMasterCalc();
            };
            if (!this.dropDownOpenForSetupMaster) {
                this.onDropdownClosedForSetupMaster.apply(this.dropDownOpenForSetupMaster);
                this.onDropdownClosedForSetupMaster = null;
            }
        } else if (this.$setupMasterCalc.seasonSelected[0] === 0) {
            this.$setupMasterCalc.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSeasonsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.seasonSelected)) {
            // this.resetPriceCorridorForSetupMaster();
            this.$roundingRules.seasonSelected = list;
            this.onDropdownClosedForRoundingRules = () => {
                // this.priceCorridorInfoForSetupMaster();
                this.saveRoundingRules();
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.seasonSelected[0] === 0) {
            this.$roundingRules.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    resetPriceCorridor() {
        this.$calc.changePriceCorridor = false;
    }

    resetPriceCorridorForSetupMaster() {
        this.$setupMasterCalc.changePriceCorridor = false;
    }

    updateDataRange() {
        this.dataRangeInfo()
    }

    updateDataRangeForSetupMaster() {
        this.dataRangeInfoForSetupMaster()
    }

    resetDataRange() {
        this.firstDate = 0;
        this.lastDate = 0;
    }

    resetDataRangeForSetupMaster() {
        this.setupMasterFirstDate = 0;
        this.setupMasterLastDate = 0;
    }

    resetKVIparams() {
        this.useFindKviRecommendsParam = false;
        this.$calc.percentageOfRecommendsKviCount = 10;
        this.$calc.useSegmentsPriceInSearchKVIRecParam = false;
        this.$calc.saveKviSign = false;
    }

    updateSelectMarket(market: SelectMarket) {
        this.setItemsSuperset(market.tradingName, this.COMPANY);

        const getFilters = localStorage.getItem('FILTERS_SUPERSET');

        const filters = {
            GROUP: '',
            CATEGORY: '',
            SUB_CATEGORY: '',
            FORMAT: '',
            REGION: '',
            CLASTER: '',
            COMPANY: JSON.parse(getFilters === null ? '' : getFilters).COMPANY,
        };
        localStorage.setItem('FILTERS_SUPERSET', JSON.stringify(filters));

        this.refreshDetailTable()

        if (this.$calc.selectMarket == null || this.$calc.selectMarket.id !== market.id) {
            this.skuListWithCalculating = false;
            this.resetCalcData();
            this.$calc.selectMarket = market;
            this.skuList = [];
            this.newProductsList = [];
            this.initTask();
            this.saveCalc();
            this.tableKey = Math.random();
            this.competitorTableKey = Math.random();
            this.resetDataRange();
            this.hideSkuPanel();
            this.resetActualProfitability();
            this.resetRegularPricesProfitability();
            this.isFiltersChanged = 1;
            this.findAutomaticallyPriceSegments = false;
            this.needLoadSkuList = false;
            this.needCalculateSkuLastPricesOnly = false;
            this.needCalculateSkuActualProfitabilityOnly = false;
            this.calcSkuLastPricesButtonDisabled = false;
            this.calcSkuActualProfitButtonDisabled = false;
            this.needLoadNewProductList = false;
            this.resetKVIparams();
            this.taskId = 0;
            this.fileResult = '';
            this.productCodesForAddKvi = [];
            this.productCodesForDeleteKvi = [];
            this.productCodesForAddCtmPurpose = [];
            this.productCodesForDeleteCtmPurpose = [];
            this.segmentPriceOptions = [];
            this.productSegmentIdAndNameOptions = [];
            this.keyCharacteristicOneOptions = [];
            this.keyCharacteristicTwoOptions = [];
            this.keyCharacteristicThreeOptions = [];
            this.keyCharacteristicFourOptions = [];
            this.keyCharacteristicFiveOptions = [];
            this.recipeAttributesOptions = [];
            this.treatmentAttributesOptions = [];
            this.keyCharacteristicOneForNewProductOptions = [];
            this.keyCharacteristicTwoForNewProductOptions = [];
            this.keyCharacteristicThreeForNewProductOptions = [];
            this.keyCharacteristicFourForNewProductOptions = [];
            this.keyCharacteristicFiveForNewProductOptions = [];
            this.recipeAttributesForNewProductOptions = [];
            this.treatmentAttributesForNewProductOptions = [];
            this.newProductSegmentIdAndNameOptions = [];
            this.clearFiltersInNewProductsTable();
            this.paramsRulesKey += 1;
            this.$calc.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('regular.strategies.maxGrossMargin') as string}
        }
    }

    updateSelectMarketForSetupMaster(market: SelectMarket) {
        if (this.$setupMasterCalc.selectMarket == null || this.$setupMasterCalc.selectMarket.id !== market.id) {
            this.resetSetupMasterCalcData();
            this.$setupMasterCalc.selectMarket = market;
            this.initTaskForSetupMaster();
            this.saveSetupMasterCalc();
            this.resetDataRangeForSetupMaster();
            this.resetActualProfitabilityForSetupMaster();
            this.resetRegularPricesProfitabilityForSetupMaster();
            this.findAutomaticallyPriceSegmentsForSetupMaster = false;
        }
    }

    updateSelectMarketForRoundingRules(market: SelectMarket) {
        if (this.$roundingRules.selectMarket == null || this.$roundingRules.selectMarket.id !== market.id) {
            this.resetRoundingRulesData()
            this.$roundingRules.selectMarket = market;
            this.initTaskForRoundingRules()
            this.refreshRoundingRulesList()
            this.saveRoundingRules();
        }
    }

    hideTableau(): boolean {
        return this.$disallowedModules.includes('calc-tableau');
    }

    hideNewProductPricingPanel(): boolean {
        return this.$disallowedModules.includes('newProduct-pricing');
    }

    showRoundPricesWithEqualCompStrategy(): boolean {
        return this.$calc.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
    }

    showRoundPricesWithEqualCompStrategyForSetupMaster(): boolean {
        return this.$setupMasterCalc.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
    }

    updatedTableau() {
        const indexCategory = this.taskInfo.categoryOptions.findIndex((item) => {
            return item.value === this.$calc.categoryOfProduct
        });
        // const sheet = this.viz.getWorkbook().getActiveSheet() - не срабатывает на этой версии Табло, добавил getWorksheets();
        const sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets();

        if (this.$calc.selectMarket.id !== -1) {
            sheet[0].applyFilterAsync('Компания', this.$calc.selectMarket.tradingName, (window as any).tableau.FilterUpdateType.REPLACE);
        } else {
            sheet[0].clearFilterAsync('Компания')
        }
        if (indexCategory !== -1) {
            sheet[0].applyFilterAsync('Категория товаров', this.taskInfo.categoryOptions[indexCategory].label, (window as any).tableau.FilterUpdateType.REPLACE)
        } else {
            sheet[0].clearFilterAsync('Категория товаров')
        }
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
            || status === 'EmptyData'
            || status === 'ExecutionException'
            || status.includes('Error'));
    }

    clearFilterDisabled() {
        return !this.skuFilter;
    }

    clearCtmFilterDisabled() {
        return !this.ctmSkuFilter;
    }

    clearNewProductsFilterDisabled() {
        return !this.newProductsFilter;
    }

    clearFilter() {
        this.skuFilter = '';
        this.refreshSkuList()
    }

    clearFilterInUpperPanel() {
        this.skuFilter = '';
        this.refreshSkuTableInPanel()
    }

    clearNewProductsSearchFilter() {
        this.newProductsFilter = '';
        this.refreshNewProductsTable()
    }

    clearCtmProductsSearchFilter() {
        this.ctmSkuFilter = '';
        this.fetchCtmList(1);
    }

    selectData(): [number[], number[], number[], string | null, Segment[] | null] {
        const selectSeasons: number[] = (this.$calc.seasonSelected.length === 0 || (this.$calc.seasonSelected.length === 1 && this.$calc.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$calc.seasonSelected)!!;
        const selectRegions: number[] = (this.$calc.regionSelected.length === 0 || (this.$calc.regionSelected.length && this.$calc.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$calc.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$calc.buyerSegmentsList.length === 0 || (this.$calc.buyerSegmentsList.length && this.$calc.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$calc.buyerSegmentsList)!!;
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });

        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        return [selectSeasons, selectRegions, selectBuyerSegment, ctm, priceSegments];
    }

    selectDataForSetupMaster(): [number[], number[], number[], string | null, Segment[] | null] {
        const selectSeasons: number[] = (this.$setupMasterCalc.seasonSelected.length === 0 || (this.$setupMasterCalc.seasonSelected.length === 1 && this.$setupMasterCalc.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$setupMasterCalc.seasonSelected)!!;
        const selectRegions: number[] = (this.$setupMasterCalc.regionSelected.length === 0 || (this.$setupMasterCalc.regionSelected.length && this.$setupMasterCalc.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$setupMasterCalc.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$setupMasterCalc.buyerSegmentsList.length === 0 || (this.$setupMasterCalc.buyerSegmentsList.length && this.$setupMasterCalc.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$setupMasterCalc.buyerSegmentsList)!!;
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });

        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        return [selectSeasons, selectRegions, selectBuyerSegment, ctm, priceSegments];
    }

    selectDataForRoundingRulesSeasonsRegions(): [number[], number[], number[]] {
        const selectSeasons: number[] = (this.$roundingRules.seasonSelected.length === 0 || (this.$roundingRules.seasonSelected.length === 1 && this.$roundingRules.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.seasonSelected)!!;
        const selectRegions: number[] = (this.$roundingRules.regionSelected.length === 0 || (this.$roundingRules.regionSelected.length && this.$roundingRules.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$roundingRules.buyerSegmentsList.length === 0 || (this.$roundingRules.buyerSegmentsList.length === 1 && this.$roundingRules.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.buyerSegmentsList)!!;
        // const ctm: string | null = this.selectCTM.value === 'all' ? null : this.selectCTM.value;

        this.$log.log(selectRegions)
        return [selectSeasons, selectRegions, selectBuyerSegment];
    }

    priceCorridorInfo() {
        if (!this.$calc.changePriceCorridor) {
            this.hideSkuPanel();
            return;
        }
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        this.isPriceCorridorCalculated = true;

        const filters = this.getCalcFilter();
        this.httpPostPriceCorridor(filters)
            .then((r) => {
                    this.$calc.priceCorridor = r.data;
                    this.isPriceCorridorCalculated = false;
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadPriceCorridorFailed') as string);
                this.$log.error('Error occurred [load price corridor]', e);
                this.isPriceCorridorCalculated = false;
            });
    }

    priceCorridorInfoForSetupMaster() {
        if (!this.$setupMasterCalc.changePriceCorridor) {
            return;
        }
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null) {
            return;
        }
        this.isPriceCorridorCalculatedForSetupMaster = true;

        const filters = this.getCalcFilterForSetupMaster();
        this.httpPostPriceCorridor(filters)
            .then((r) => {
                    this.$setupMasterCalc.priceCorridor = r.data;
                    this.isPriceCorridorCalculatedForSetupMaster = false;
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadPriceCorridorFailed') as string);
                this.$log.error('Error occurred [load price corridor]', e);
                this.isPriceCorridorCalculatedForSetupMaster = false;
            });
    }

    dataRangeInfo() {
        if (!this.showDataRange) {
            return;
        }
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.firstDate = 0;
            this.lastDate = 0;
            return;
        }
        this.isDataRangeCalculated = true;

        const filters = this.getCalcFilter()
        this.httpPostDataRange(filters)
            .then((r) => {
                    if (r.data.firstDate == null && r.data.lastDate == null) {
                        this.firstDate = 0;
                        this.lastDate = 0;
                        this.showInfo(this.$t('regular.errors.getDateRangeNoData') as string);
                        this.isDataRangeCalculated = false;
                    } else {
                        this.firstDate = r.data.firstDate;
                        this.lastDate = r.data.lastDate;
                        this.isDataRangeCalculated = false;
                    }
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.getDateRangeFailed') as string);
                this.$log.error('Error occurred [load data range]', e);
                this.isDataRangeCalculated = false;
            });
    }

    dataRangeInfoForSetupMaster() {
        if (!this.showDataRangeForSetupMaster) {
            return;
        }
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null) {
            this.setupMasterFirstDate = 0;
            this.setupMasterLastDate = 0;
            return;
        }
        this.isDataRangeCalculatedForSetupMaster = true;

        const filters = this.getCalcFilterForSetupMaster()
        this.httpPostDataRange(filters)
            .then((r) => {
                    if (r.data.firstDate == null && r.data.lastDate == null) {
                        this.setupMasterFirstDate = 0;
                        this.setupMasterLastDate = 0;
                        this.showInfo(this.$t('regular.errors.getDateRangeNoData') as string);
                        this.isDataRangeCalculatedForSetupMaster = false;
                    } else {
                        this.setupMasterFirstDate = r.data.firstDate;
                        this.setupMasterLastDate = r.data.lastDate;
                        this.isDataRangeCalculatedForSetupMaster = false;
                    }
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.getDateRangeFailed') as string);
                this.$log.error('Error occurred [load data range]', e);
                this.isDataRangeCalculatedForSetupMaster = false;
            });
    }

    checkPriceCorridorMinVal() {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const filters: BaseFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: +this.$calc.calculationDepth,
            calculationDay: +this.$calc.calculationDay,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments)!!,
        };

        this.httpPostMinRetailPrice(filters)
            .then((r) => {
                    const data = r.data;
                    this.$log.debug('Min retail price', data);
                    if (data.minRetailPrice !== null && this.$calc.priceCorridor.min < data.minRetailPrice) {
                        this.showInfo(this.$t('regular.validation.lowerBoundBelowMinRetail') as string + data.minRetailPrice)
                    }
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadMinRetailPriceFailed') as string)
            });
    }

    tryAutomaticallyFindParams() {
        if (this.$calc.categoryStrategy.value !== CategoryStrategies.EMPTY) {
            this.tryFindParams()
        }
    }

    tryFindRulesParams() {
        this.serverConfigTimeout = null;
        const [selectSeasons, selectRegions] = this.selectDataForRoundingRulesSeasonsRegions();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.$roundingRules.selectMarket.id;
        findParams.groupOfProduct = this.$roundingRules.groupOfProduct;
        findParams.category = this.$roundingRules.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = LocalData.filterNumberArrays(this.$roundingRules.subcategories)!!;
        findParams.storeCluster = this.$roundingRules.clusterSelected == null ? null : this.$roundingRules.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$roundingRules.formatSelected;
        findParams.categoryStrategy = this.$roundingRules.categoryStrategy.value

        if (findParams.canLoadRoundingRules()) {
            this.loadingConfigs = true;
            this.httpFindRulesParams(findParams, 'BASE')
                .then((r) => {
                    const params = r.data;
                    this.$roundingRules.pennies = params.pennies
                    this.$roundingRules.allNewPricesWithoutPennies = params.allNewPricesWithoutPennies
                    this.$roundingRules.roundKviCompetitorPrice = params.roundKviCompetitorPrice
                    this.$roundingRules.roundPricesWithEqualCompStrategy = params.roundPricesWithEqualCompStrategy
                    this.$roundingRules.randomPennies = params.randomPennies
                    this.$roundingRules.bigDigit = params.bigDigit
                    this.$roundingRules.manualPennies = params.manualPennies

                    this.loadingConfigs = false
                })
                .catch((e) => {
                    this.loadingConfigs = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('regular.errors.loadParamsFailed') as string);
                })
        }
    }

    tryFindParams(dontRefreshSkus: boolean = false) {
        this.serverConfigTimeout = null;
        const [selectSeasons, selectRegions] = this.selectData();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.$calc.selectMarket.id;
        findParams.groupOfProduct = this.$calc.groupOfProduct;
        findParams.category = this.$calc.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = LocalData.filterNumberArrays(this.$calc.subcategories)!!;
        findParams.storeCluster = this.$calc.clusterSelected == null ? null : this.$calc.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$calc.formatSelected;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.productSegments = LocalData.filterNumberArrays(this.$calc.productSegments)!!
        findParams.categoryStrategy = this.$calc.categoryStrategy.value
        findParams.priceExperimentDiscountRangeFrom = this.$calc.priceExperimentDiscountRangeFrom;
        findParams.priceExperimentDiscountRangeTo = this.$calc.priceExperimentDiscountRangeTo;
        findParams.priceExperimentStep = this.$calc.priceExperimentStep;
        findParams.priceExperimentStartDate = this.$calc.priceExperimentStartDate;
        findParams.priceExperimentEndDate = this.$calc.priceExperimentEndDate;
        findParams.strategyValidityBeginDate = this.$calc.strategyValidityBeginDate
            ? moment(this.$calc.strategyValidityBeginDate, 'YYYY-MM-DD').utc().valueOf()
            : null;
        findParams.strategyValidityEndDate = this.$calc.strategyValidityEndDate
            ? moment(this.$calc.strategyValidityEndDate, 'YYYY-MM-DD').utc().valueOf()
            : null;
        if (findParams.canLoad()) {
            this.loadingConfigs = true;
            this.loadCommonParams(findParams)
                .then((r) => this.loadCommonIndividual(findParams))
                .finally(() => {
                    this.saveCalc();
                    this.loadingConfigs = false

                    if (!dontRefreshSkus) {
                        this.refreshSkuTableInPanel();
                    }
                })
                .catch((e) => {
                    this.loadingConfigs = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('regular.errors.loadCalcParamsFailed') as string);
                })
        }
    }

    tryFindParamsForSetupMaster() {
        const [selectSeasons, selectRegions] = this.selectDataForSetupMaster();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.$setupMasterCalc.selectMarket.id;
        findParams.groupOfProduct = this.$setupMasterCalc.groupOfProduct;
        findParams.category = this.$setupMasterCalc.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = LocalData.filterNumberArrays(this.$setupMasterCalc.subcategories)!!;
        findParams.storeCluster = this.$setupMasterCalc.clusterSelected == null ? null : this.$setupMasterCalc.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$setupMasterCalc.formatSelected;
        findParams.categoryStrategy = this.$setupMasterCalc.categoryStrategy.value
        // tslint:disable-next-line: no-non-null-assertion
        findParams.productSegments = LocalData.filterNumberArrays(this.$setupMasterCalc.productSegments)!!
        findParams.priceExperimentDiscountRangeFrom = this.$setupMasterCalc.priceExperimentDiscountRangeFrom;
        findParams.priceExperimentDiscountRangeTo = this.$setupMasterCalc.priceExperimentDiscountRangeTo;
        findParams.priceExperimentStep = this.$setupMasterCalc.priceExperimentStep;
        findParams.priceExperimentStartDate = this.$setupMasterCalc.priceExperimentStartDate;
        findParams.priceExperimentEndDate = this.$setupMasterCalc.priceExperimentEndDate;
        findParams.strategyValidityBeginDate = this.$setupMasterCalc.strategyValidityBeginDate
            ? moment(this.$setupMasterCalc.strategyValidityBeginDate, 'YYYY-MM-DD').utc().valueOf()
            : null;
        findParams.strategyValidityEndDate = this.$setupMasterCalc.strategyValidityEndDate
            ? moment(this.$setupMasterCalc.strategyValidityEndDate, 'YYYY-MM-DD').utc().valueOf()
            : null;
        if (findParams.canLoad()) {
            this.loadingConfigsForSetupMaster = true;
            this.loadCommonParamsForSetupMaster(findParams)
                .finally(() => {
                    this.saveSetupMasterCalc();
                    this.loadingConfigsForSetupMaster = false
                })
                .catch((e) => {
                    this.loadingConfigsForSetupMaster = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('regular.errors.loadCalcParamsFailed') as string);
                })
        }
    }

    getCalcIndividualFilters(): IndividualConfigCmd<CalcIndividualConfigMap> {
        const [selectSeasons, selectRegions] = this.selectData();
        const saveParams = new IndividualConfigCmd<CalcIndividualConfigMap>();
        saveParams.tradingId = this.$calc.selectMarket.id;
        saveParams.groupOfProduct = this.$calc.groupOfProduct;
        saveParams.category = this.$calc.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        saveParams.subcategories = LocalData.filterNumberArrays(this.$calc.subcategories)!!;
        saveParams.storeCluster = this.$calc.clusterSelected == null || this.$calc.clusterSelected === 0 ? null : this.$calc.clusterSelected;
        saveParams.seasonValues = selectSeasons;
        saveParams.storeRegionValues = selectRegions;
        saveParams.storeFormat = this.$calc.formatSelected;
        // tslint:disable-next-line: no-non-null-assertion
        saveParams.productSegments = LocalData.filterNumberArrays(this.$calc.productSegments)!!
        const individualConfigsObj = Object.create(null);
        // tslint:disable-next-line: forin
        for (const key in this.$calc.individualCommonParams) {
            const value = this.$calc.individualCommonParams[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }
        // Добавляем priceExperiment из tableDataSkuList для тех SKU, у которых он установлен
        // Это актуальное значение из UI, поэтому оно имеет приоритет
        if (Array.isArray(this.tableDataSkuList)) {
            this.tableDataSkuList.forEach((row: any) => {
                if (row.internalCode && row.priceExperiment !== undefined && row.priceExperiment !== null) {
                    const skuKey = row.internalCode;
                    if (!individualConfigsObj[skuKey]) {
                        individualConfigsObj[skuKey] = {};
                    }
                    // Всегда обновляем priceExpFlag из tableDataSkuList, так как это актуальное значение из UI
                    individualConfigsObj[skuKey].priceExpFlag = row.priceExperiment;
                }
            });
        }
        saveParams.individualConfigs = individualConfigsObj;
        saveParams.productRangesAndInternalCodes = this.productRangesArray;
        saveParams.categoryStrategy = this.$calc.categoryStrategy.value
        return saveParams
    }

    saveIndividualConfigs() {
        const saveParams = this.getCalcIndividualFilters()
        this.httpSaveBaseIndividualConfig(saveParams)
            .then((r) => {
                this.showInfo(this.$t('regular.notifications.individualSettingsSaved') as string);
                EventBus.$emit('onCalcParamsSaved')
                this.refreshSkuList();
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.saveIndivParamsFailed') as string);
            })
    }

    saveIndividualConfigsInSkuPanel() {
        const saveParams = this.getCalcIndividualFilters()
        this.httpSaveBaseIndividualConfig(saveParams)
            .then((r) => {
                this.showInfo(this.$t('regular.notifications.individualSettingsSaved') as string);
                EventBus.$emit('onCalcParamsSaved')
                this.refreshSkuTableInPanel();
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.saveIndivParamsFailed') as string);
            })
    }

    initTask() {
        if (this.$calc.selectMarket.id === -1) {
            return;
        }
        this.$refs.updateRegionsRef && (this.$refs.updateRegionsRef as any).toggleLoading(true);
        this.$refs.updateSeasonsRef && (this.$refs.updateSeasonsRef as any).toggleLoading(true);
        this.$refs.updateBuyerSegmentsRef && (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
        this.$refs.formatSelectedRef && (this.$refs.formatSelectedRef as any).toggleLoading(true);
        this.$refs.groupSelectedRef && (this.$refs.groupSelectedRef as any).toggleLoading(true);
        this.$refs.clasterSelectedRef && (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        this.$refs.groupOfProductRef && (this.$refs.groupOfProductRef as any).toggleLoading(true);
        this.$refs.subcategoriesRef && (this.$refs.subcategoriesRef as any).toggleLoading(true);
        this.$refs.productSegmentsRef && (this.$refs.productSegmentsRef as any).toggleLoading(true);

        this.$calc.categoryOfProduct = null;
        this.$calc.clusterSelected = null;
        this.$calc.formatSelected = null;
        this.$calc.groupOfProduct = null;
        this.$calc.subcategories = [];
        this.$calc.productSegments = [];
        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.buyerSegmentOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.clusterOptions = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
        this.getCategoryInfo()
            .then(() => Promise.all([
              this.loadProductsGroup(),
              this.getRegionInfo(),
              this.getFormatInfo(),
              this.getBuyerSegment(),
              this.getClusterInfo(),
              this.loadProductsSubcategories(),
              this.loadProductSegments()
            ]))
    }

    initTaskForSetupMaster() {
        if (this.$setupMasterCalc.selectMarket.id === -1) {
            return;
        }
        this.$refs.setupMasterUpdateRegionsRef && (this.$refs.setupMasterUpdateRegionsRef as any).toggleLoading(true);
        this.$refs.setupMasterUpdateSeasonsRef && (this.$refs.setupMasterUpdateSeasonsRef as any).toggleLoading(true);
        this.$refs.setupMasterFormatSelectedRef && (this.$refs.setupMasterFormatSelectedRef as any).toggleLoading(true);
        this.$refs.setupMasterGroupSelectedRef && (this.$refs.setupMasterGroupSelectedRef as any).toggleLoading(true);
        this.$refs.setupMasterClasterSelectedRef && (this.$refs.setupMasterClasterSelectedRef as any).toggleLoading(true);
        this.$refs.setupMasterGroupOfProductRef && (this.$refs.setupMasterGroupOfProductRef as any).toggleLoading(true);
        this.$refs.setupMasterSubcategoriesRef && (this.$refs.setupMasterSubcategoriesRef as any).toggleLoading(true);
        this.$refs.setupMasterProductSegmentsRef && (this.$refs.setupMasterProductSegmentsRef as any).toggleLoading(true);

        this.$setupMasterCalc.categoryOfProduct = null;
        this.$setupMasterCalc.clusterSelected = null;
        this.$setupMasterCalc.formatSelected = null;
        this.$setupMasterCalc.groupOfProduct = null;
        this.$setupMasterCalc.subcategories = [];
        this.taskInfoForSetupMaster.storeFormatOptions = [];
        this.taskInfoForSetupMaster.storeRegionOptions = [];
        this.taskInfoForSetupMaster.categoryOptions = [];
        this.taskInfoForSetupMaster.clusterOptions = [];
        this.taskInfoForSetupMaster.psegemnts = [];
        this.taskInfoForSetupMaster.subcategories = [];
        this.taskInfoForSetupMaster.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
        const self = this;
        this.getCategoryInfoForSetupMaster(() => {
            self.loadProductsGroupForSetupMaster();
            self.getRegionInfoForSetupMaster();
            self.getFormatInfoForSetupMaster();
            self.getClusterInfoForSetupMaster();
            self.loadProductsSubcategoriesForSetupMaster();
            self.loadProductSegmentsForSetupMaster();
        });
    }

    initTaskForRoundingRules() {
        if (this.$roundingRules.selectMarket.id === -1) {
            return;
        }
        this.$refs.roundingRulesUpdateRegionsRef && (this.$refs.roundingRulesUpdateRegionsRef as any).toggleLoading(true);
        this.$refs.roundingRulesUpdateSeasonsRef && (this.$refs.roundingRulesUpdateSeasonsRef as any).toggleLoading(true);
        this.$refs.roundingRulesFormatSelectedRef && (this.$refs.roundingRulesFormatSelectedRef as any).toggleLoading(true);
        this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesGroupSelectedRef as any).toggleLoading(true);
        this.$refs.roundingRulesClasterSelectedRef && (this.$refs.roundingRulesClasterSelectedRef as any).toggleLoading(true);
        this.$refs.roundingRulesGroupOfProductRef && (this.$refs.roundingRulesGroupOfProductRef as any).toggleLoading(true);
        this.$refs.roundingRulesSubcategoriesRef && (this.$refs.roundingRulesSubcategoriesRef as any).toggleLoading(true);

        this.$roundingRules.categoryOfProduct = null;
        this.$roundingRules.clusterSelected = null;
        this.$roundingRules.formatSelected = null;
        this.$roundingRules.groupOfProduct = null;
        this.$roundingRules.subcategories = [];
        this.taskInfoForRoundingRules.storeFormatOptions = [];
        this.taskInfoForRoundingRules.storeRegionOptions = [];
        this.taskInfoForRoundingRules.categoryOptions = [];
        this.taskInfoForRoundingRules.clusterOptions = [];
        this.taskInfoForRoundingRules.psegemnts = [];
        this.taskInfoForRoundingRules.subcategories = [];
        this.taskInfoForRoundingRules.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
        const self = this;
        this.getCategoryInfoForRoundingRules(() => {
            self.loadProductsGroupForRoundingRules();
            self.getRegionInfoForRoundingRules();
            self.getFormatInfoForRoundingRules();
            self.getClusterInfoForRoundingRules();
            self.loadProductsSubcategoriesForRoundingRules();
            self.loadProductSegmentsForRoundingRules();
        });
    }

    loadProductsGroup() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.groupOfProductRef && (this.$refs.groupOfProductRef as any).toggleLoading(false);
                }, 250);
                if (filterData.groups.length > 0) {
                    this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.groupsOfProduct.unshift({value: null, label: this.$t('regular.common.all') as string});
                } else {
                    this.$calc.groupOfProduct = null;
                    this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
                }
            })
            .catch((e) => {
            })
    }

    loadProductsGroupForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterGroupOfProductRef && (this.$refs.setupMasterGroupOfProductRef as any).toggleLoading(false);
                }, 250);
                if (filterData.groups.length > 0) {
                    this.taskInfoForSetupMaster.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForSetupMaster.groupsOfProduct.unshift({value: null, label: this.$t('regular.common.all') as string});
                } else {
                    this.$setupMasterCalc.groupOfProduct = null;
                    this.taskInfoForSetupMaster.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
                }
            })
            .catch((e) => {
            })
    }

    loadProductsGroupForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesGroupOfProductRef && (this.$refs.roundingRulesGroupOfProductRef as any).toggleLoading(false);
                }, 250);
                if (filterData.groups.length > 0) {
                    this.taskInfoForRoundingRules.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForRoundingRules.groupsOfProduct.unshift({value: null, label: this.$t('regular.common.all') as string});
                } else {
                    this.$roundingRules.groupOfProduct = null;
                    this.taskInfoForRoundingRules.groupsOfProduct = [{value: null, label: this.$t('regular.common.all') as string}];
                }
            })
            .catch((e) => {
            })
    }

    loadProductsSubcategories() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.subcategoriesRef && (this.$refs.subcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfo.subcategories.unshift({value: 0, label: this.$t('regular.common.all') as string})
            })
            .catch((e) => {
            })
    }

    loadProductsSubcategoriesForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterSubcategoriesRef && (this.$refs.setupMasterSubcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForSetupMaster.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfoForSetupMaster.subcategories.unshift({value: 0, label: this.$t('regular.common.all') as string})
            })
            .catch((e) => {
            })
    }

    loadProductsSubcategoriesForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesSubcategoriesRef && (this.$refs.roundingRulesSubcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForRoundingRules.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfoForRoundingRules.subcategories.unshift({value: 0, label: this.$t('regular.common.all') as string})
            })
            .catch((e) => {
            })
    }

    loadProductSegments() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.productSegmentsRef && (this.$refs.productSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.psegemnts = filterData.psegments.map((i) => {
                    return {
                        label: i.name,
                        value: i.id,
                    }
                });
                this.taskInfo.psegemnts.unshift({value: 0, label: this.$t('regular.common.all') as string})
            })
            .catch((e) => {
            });
    }

    loadProductSegmentsForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterProductSegmentsRef && (this.$refs.setupMasterProductSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForSetupMaster.psegemnts = filterData.psegments.map((i) => {
                    return {
                        label: i.name,
                        value: i.id,
                    }
                });
                this.taskInfoForSetupMaster.psegemnts.unshift({value: 0, label: this.$t('regular.common.all') as string})
            })
            .catch((e) => {
            });
    }

    loadProductSegmentsForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesProductSegmentsRef && (this.$refs.roundingRulesProductSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForRoundingRules.psegemnts = filterData.psegments.map((i) => {
                    return {
                        label: i.name,
                        value: i.id,
                    }
                });
                this.taskInfoForRoundingRules.psegemnts.unshift({value: 0, label: this.$t('regular.common.all') as string})
            })
            .catch((e) => {
            });
    }

    getCategoryInfo(cb: any = null) {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.groupSelectedRef && (this.$refs.groupSelectedRef as any).toggleLoading(false);
                    this.$refs.updateSeasonsRef && (this.$refs.updateSeasonsRef as any).toggleLoading(false);
                }, 250);
                if (filterData.categories.length > 0) {
                    this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.categoryOptions.unshift({value: null, label: this.$t('regular.common.selectCategory') as string});
                } else {
                    this.$calc.categoryOfProduct = null;
                    this.taskInfo.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                    this.resetData(TaskInfoFilterType.category);
                }
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch((e) => {
            })
    }

    getCategoryInfoForSetupMaster(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterGroupSelectedRef && (this.$refs.setupMasterGroupSelectedRef as any).toggleLoading(false);
                    this.$refs.setupMasterUpdateSeasonsRef && (this.$refs.setupMasterUpdateSeasonsRef as any).toggleLoading(false);
                }, 250);
                if (filterData.categories.length > 0) {
                    this.taskInfoForSetupMaster.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForSetupMaster.categoryOptions.unshift({value: null, label: this.$t('regular.common.selectCategory') as string});
                } else {
                    this.$calc.categoryOfProduct = null;
                    this.taskInfoForSetupMaster.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                    this.resetDataForSetupMaster(TaskInfoFilterType.category);
                }
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch((e) => {
            })
    }

    getCategoryInfoForRoundingRules(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesGroupSelectedRef as any).toggleLoading(false);
                    this.$refs.roundingRulesUpdateSeasonsRef && (this.$refs.roundingRulesUpdateSeasonsRef as any).toggleLoading(false);
                }, 250);
                if (filterData.categories.length > 0) {
                    this.taskInfoForRoundingRules.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForRoundingRules.categoryOptions.unshift({
                        value: null,
                        label: this.$t('regular.common.selectCategory') as string,
                    });
                } else {
                    this.$roundingRules.categoryOfProduct = null;
                    this.taskInfoForRoundingRules.categoryOptions = [{value: null, label: this.$t('regular.common.selectCategory') as string}];
                    this.resetDataForRoundingRules(TaskInfoFilterType.category);
                }
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch((e) => {
            })
    }

    getRegionInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.updateRegionsRef && (this.$refs.updateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });

                this.taskInfo.storeRegionOptions = [{
                    value: 0,
                    label: this.$t('regular.common.all') as string,
                }, ...this.taskInfo.storeRegionOptions];
            })
            .catch((e) => {
            });
    }

    getRegionInfoForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterUpdateRegionsRef && (this.$refs.setupMasterUpdateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfoForSetupMaster.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getRegionInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesUpdateRegionsRef && (this.$refs.roundingRulesUpdateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfoForRoundingRules.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForRoundingRules.storeRegionOptions = [{
                    value: 0,
                    label: this.$t('regular.common.all') as string,
                }, ...this.taskInfoForRoundingRules.storeRegionOptions];
            })
            .catch((e) => {
            });
    }

    getSegmentPriceInfo() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const filter = this.getSkuFilter()
        this.httpGetMinMaxPriceSegment(filter)
            .then((data) => {
                const filterData = data.data;
                this.segmentPriceOptions = filterData.map((i) => {
                    return {value: i, label: i.name}
                });
            })
            .catch((e) => {
            })
    }

    getProductSegmentIdAndName() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const filter = this.getSkuFilter()
        this.httpGetProductSegmentIdAndName(filter)
            .then((data) => {
                const filterData = data.data;
                this.productSegmentIdAndNameOptions = filterData.map((i) => {
                    return {value: i, label: i.segmentName}
                });
            })
            .catch((e) => {
            })
    }

    getSkuKeysAndAttributes() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const filter = this.getSkuFilter()
        this.httpGetSkuKeysAndAttributes(filter)
            .then((result) => {
                this.keyCharacteristicOneOptions = result.data.keyProducts1.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicTwoOptions = result.data.keyProducts2.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicThreeOptions = result.data.keyProducts3.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicFourOptions = result.data.keyProducts4.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicFiveOptions = result.data.keyProducts5.map((item) => {
                    return {value: item, label: item};
                });
                this.recipeAttributesOptions = result.data.recipeAttributes.map((item) => {
                    return {value: item, label: item};
                });
                this.treatmentAttributesOptions = result.data.treatmentAttributes.map((item) => {
                    return {value: item, label: item.toString()};
                });
            })
            .catch((e) => {
            })
    }

    getNewProductsSkuKeysAndAttributes() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const filter = this.getNewProductsSkuFilter()
        this.httpGetNewProductSkuKeysAndAttributes(filter)
            .then((result) => {
                this.keyCharacteristicOneForNewProductOptions = result.data.keyProducts1.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicTwoForNewProductOptions = result.data.keyProducts2.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicThreeForNewProductOptions = result.data.keyProducts3.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicFourForNewProductOptions = result.data.keyProducts4.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicFiveForNewProductOptions = result.data.keyProducts5.map((item) => {
                    return {value: item, label: item};
                });
                this.recipeAttributesForNewProductOptions = result.data.recipeAttributes.map((item) => {
                    return {value: item, label: item};
                });
                this.treatmentAttributesForNewProductOptions = result.data.treatmentAttributes.map((item) => {
                    return {value: item, label: item.toString()};
                });
            })
            .catch((e) => {
            })
    }

    getNewProductSegmentIdAndName() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const filter: SkuFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments),
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
        };
        this.httpGetNewProductSegmentIdAndName(filter)
            .then((data) => {
                const filterData = data.data;
                this.newProductSegmentIdAndNameOptions = filterData.map((i) => {
                    return {value: i, label: i.segmentName}
                });
            })
            .catch((e) => {
            })
    }

    getRoundingListFilter(): RoundingRulesFilter {
        const filter: RoundingRulesFilter = {tradingId: this.$roundingRules.selectMarket.id};

        filter.filterTypes = ['BASE', 'COMP_PRODUCT', 'KVI_PRODUCT']

        if (this.rulesDateRange.length > 0) {
            filter.dateBefore = this.rulesDateRange[0]
            filter.dateAfter = this.rulesDateRange[1]
        }

        const userValue = this.selectUserFio
        if (userValue !== 'All') {
            filter.userFio = userValue
        }

        const storeFormatValue = this.selectFormatFilter
        if (storeFormatValue !== -1) {
            filter.storeFormat = storeFormatValue
        }

        const categoryValue = this.selectCategoryFilter
        if (categoryValue !== -1) {
            filter.category = categoryValue
        }

        const subcategory = this.selectSubcategoryFilter
        if (subcategory !== -1) {
            filter.subcategories = subcategory
        }

        const group = this.selectGroupFilter
        if (group !== -1) {
            filter.group = group
        }

        const cluster = this.selectClusterFilter
        if (cluster !== -1) {
            filter.storeCluster = cluster
        }

        const region = this.selectRegionFilter
        if (region !== -1) {
            filter.storeRegions = region
        }

        return filter;
    }

    getSegmentPriceInfoForNewProducts() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const filter: SkuFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
        };
        this.httpGetMinMaxPriceSegmentForNewProducts(filter)
            .then((data) => {
                const filterData = data.data;
                this.segmentPriceOptionsForNewProducts = filterData.map((i) => {
                    return {value: i, label: i.name}
                });
            })
            .catch((e) => {
            })
    }

    getFormatInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.formatSelectedRef && (this.$refs.formatSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfo.storeFormatOptions = [{
                    value: null,
                    label: this.$t('regular.common.all') as string,
                }, ...this.taskInfo.storeFormatOptions];

            })
            .catch((e) => {
            });
    }

    getFormatInfoForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterFormatSelectedRef && (this.$refs.setupMasterFormatSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForSetupMaster.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForSetupMaster.storeFormatOptions = [{
                    value: null,
                    label: this.$t('regular.common.all') as string,
                }, ...this.taskInfoForSetupMaster.storeFormatOptions];

            })
            .catch((e) => {
            });
    }

    getFormatInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesFormatSelectedRef && (this.$refs.roundingRulesFormatSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForRoundingRules.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForRoundingRules.storeFormatOptions = [{
                    value: null,
                    label: this.$t('regular.common.all') as string,
                }, ...this.taskInfoForRoundingRules.storeFormatOptions];
            })
            .catch((e) => {
            });
    }

    getBuyerSegment() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.updateBuyerSegmentsRef && (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            })

    }

    getClusterInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.clasterSelectedRef && (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfo.clusterOptions = [{
                    value: null,
                    label: this.$t('regular.common.all') as string,
                }, ...this.taskInfo.clusterOptions];

            })
            .catch((e) => {
            });
    }

    getClusterInfoForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterClasterSelectedRef && (this.$refs.setupMasterClasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForSetupMaster.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForSetupMaster.clusterOptions = [{
                    value: null,
                    label: this.$t('regular.common.all') as string,
                }, ...this.taskInfoForSetupMaster.clusterOptions];

            })
            .catch((e) => {
            });
    }

    getClusterInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesClasterSelectedRef && (this.$refs.roundingRulesClasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForRoundingRules.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForRoundingRules.clusterOptions = [{
                    value: null,
                    label: this.$t('regular.common.all') as string,
                }, ...this.taskInfoForRoundingRules.clusterOptions];

            })
            .catch((e) => {
            });
    }

    prepareIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
        const prepared: CalcIndividualConfig = {};

        if ('kviStrategy' in config && typeof config.kviStrategy !== 'undefined' && config.kviStrategy !== null) {
            prepared.kviStrategy = config.kviStrategy.value
        }

        if ('marginalProfit' in config && typeof config.marginalProfit !== 'undefined' && config.marginalProfit !== null) {
            prepared.marginalProfit = config.marginalProfit;
        }

        if ('marginalProfitKvi' in config && typeof config.marginalProfitKvi !== 'undefined' && config.marginalProfitKvi !== null) {
            prepared.marginalProfitKvi = config.marginalProfitKvi;
        }

        if ('marginalProfitCompetitors' in config && typeof config.marginalProfitCompetitors !== 'undefined' && config.marginalProfitCompetitors !== null) {
            prepared.marginalProfitCompetitors = config.marginalProfitCompetitors;
        }

        if ('priceChangeLimit' in config && typeof config.priceChangeLimit !== 'undefined' && config.priceChangeLimit !== null) {
            prepared.priceChangeLimit = config.priceChangeLimit;
        }

        if ('selectCoefficent' in config && typeof config.selectCoefficent !== 'undefined' && config.selectCoefficent !== null) {
            const coef = config.selectCoefficent;
            prepared.coefficientK1 = coef.value.k1;
            prepared.coefficientK2 = coef.value.k2;
            prepared.priceOpt = coef.value.enum;
        }

        if ('priceIncreaseLimit' in config && typeof config.priceIncreaseLimit !== 'undefined' && config.priceIncreaseLimit !== null) {
            prepared.priceIncreaseLimit = config.priceIncreaseLimit;
        }

        if ('competitorsPricesParams' in config && typeof config.competitorsPricesParams !== 'undefined' && config.competitorsPricesParams !== null) {
            prepared.competitorsPricesParams = config.competitorsPricesParams;
        }

        if ('percentageOfCompetitorsPrice' in config) {
            prepared.percentageOfCompetitorsPrice = config.percentageOfCompetitorsPrice;
        }

        if ('periodPriceIncreaseLimit' in config && typeof config.periodPriceIncreaseLimit !== 'undefined' && config.periodPriceIncreaseLimit !== null) {
            prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
        }

        if ('period' in config && typeof config.period !== 'undefined' && config.period !== null) {
            prepared.period = config.period.value;
        }

        if ('newProductPriceStrategy' in config && typeof config.newProductPriceStrategy !== 'undefined' && config.newProductPriceStrategy !== null) {
            prepared.newProductPriceStrategy = config.newProductPriceStrategy.value;
        }

        if ('newProductLifespanInDays' in config && typeof config.newProductLifespanInDays !== 'undefined' && config.newProductLifespanInDays !== null) {
            prepared.newProductLifespanInDays = config.newProductLifespanInDays;
        }

        if ('priceGap' in config && typeof config.priceGap !== 'undefined' && config.priceGap !== null) {
            prepared.priceGap = config.priceGap;
        }

        if ('ctmBrandPurpose' in config && typeof config.ctmBrandPurpose !== 'undefined' && config.ctmBrandPurpose !== null) {
            prepared.ctmBrandPurpose = config.ctmBrandPurpose;
        }

        if ('ctmPriceGap' in config && typeof config.ctmPriceGap !== 'undefined' && config.ctmPriceGap !== null) {
            prepared.ctmPriceGap = config.ctmPriceGap;
        }

        if ('competitorNames' in config && typeof config.competitorNames !== 'undefined' && config.competitorNames !== null) {
            prepared.competitorNames = config.competitorNames;
        }

        if ('priceChangeLimit' in config && typeof config.priceChangeLimit !== 'undefined' && config.priceChangeLimit !== null) {
            prepared.priceChangeLimit = config.priceChangeLimit;
        }

        if ('priceChangeLimitKvi' in config && typeof config.priceChangeLimitKvi !== 'undefined' && config.priceChangeLimitKvi !== null) {
            prepared.priceChangeLimitKvi = config.priceChangeLimitKvi;
        }

        if ('priceChangeLimitComp' in config && typeof config.priceChangeLimitComp !== 'undefined' && config.priceChangeLimitComp !== null) {
            prepared.priceChangeLimitComp = config.priceChangeLimitComp;
        }

        if ('priceExperiment' in config && typeof config.priceExperiment !== 'undefined' && config.priceExperiment !== null) {
            prepared.priceExpFlag = config.priceExperiment;
        }

        if ('byPromoPrices' in config && typeof config.byPromoPrices !== 'undefined' && config.byPromoPrices !== null) {
            prepared.byPromoPrices = config.byPromoPrices;
        }

        return prepared;
    }

    async calc() {
        if (!this.isGroupSelected) {
            this.showError(this.$t('regular.packageCalc.groupNotSelected') as string);
            return;
        }
        if (this.$calc.categoryOfProduct === null) {
            this.showError(this.$t('regular.notifications.categoryNotSelected') as string);
            return;
        }
        if (this.$calc.kviStrategy.value === null) {
            this.showError(this.$t('regular.validation.kviStrategyNotSelected') as string);
            return;
        }
        if (this.$calc.depthToPurchasePrice <= 0) {
            this.showError(this.$t('regular.validation.purchasePriceDepthGtZero') as string);
            return;
        }

        if (this.useBrutForcingParams && this.optimizationDiff < 0.0) {
            this.showError(this.$t('regular.validation.growthPercentPositive') as string);
            return;
        }
        
        // Загружаем список товаров перед запуском расчета
        this.loadSkuWithoutCalc();
        await this.fetchSkuList(1);
        
        // Проверяем наличие товаров с признаком ЦЭ
        if (this.$calc.priceExperiment) {
            const hasPriceExperimentSku = Array.isArray(this.tableDataSkuList)
                && this.tableDataSkuList.some((row: any) => !!row.priceExperiment);

            if (!hasPriceExperimentSku) {
                this.showError(this.$t('regular.validation.noSkuForPriceExperiment') as string);
                return;
            }

            // Проверяем, входит ли сегодняшняя дата в период ЦЭ
            if (this.$calc.priceExperimentStartDate && this.$calc.priceExperimentEndDate) {
                const today = moment().format('YYYY-MM-DD');
                const startDate = moment(this.$calc.priceExperimentStartDate);
                const endDate = moment(this.$calc.priceExperimentEndDate);
                const todayMoment = moment(today);

                if (!todayMoment.isSameOrAfter(startDate, 'day') || !todayMoment.isSameOrBefore(endDate, 'day')) {
                    this.showError(this.$t('regular.validation.priceExperimentOutOfPeriod') as string);
                    return;
                }
            }
        }
        
        if (this.useBrutForcingParams) {
            this.showInfo(this.$t('regular.notifications.optimalParamsStarted') as string);
        } else {
            this.showInfo(this.$t('regular.notifications.calcStarted') as string);
        }
        // Подгружаем конкурентов перед расчетом, на случай если забыли подгрузить через открытие списка SKU
        if (this.$calc.competitorsCodes.length === 0 && this.$calc.useCompetitorsPrices) {
            const offset = 0;
            const competitorFilter = this.getCompetitorsFilter();
            await this.httpLoadCompetitorsPrice(competitorFilter, this.competitorsTablePagination.pageSize, offset)
                .then((data) => {
                    this.competitors = data.data.content.flatMap(this.toRow);
                    this.$calc.competitorsCodes = this.competitors.map((i) => {
                        return i.internalCode;
                    });
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadCompetitorPricesFailed') as string);
                });
        }
        const filters = this.getCalcFilter();
        this.saveCalc();
        this.httpPostAddTask(filters)
            .then((r) => {
                    this.$log.debug('Create task', r.data);
                    EventBus.$emit('onCalcParamsSaved')
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.startCalcFailed') as string);
                this.$log.error('Error occurred on creating calc', e)
            });
    }

    searchKviRecommends() {
        if (!this.isGroupSelected) {
            this.showError(this.$t('regular.packageCalc.groupNotSelected') as string);
            return;
        }
        if (this.$calc.categoryOfProduct === null) {
            this.showError(this.$t('regular.notifications.categoryNotSelected') as string);
            return;
        }
        const filters = this.getCalcFilter();
        filters.calcWithBatchNumber = false;
        this.saveCalc();
        this.httpPostSearchKviRecommends(filters)
            .then((r) => {
                    this.$log.debug('Create task', r.data);
                    this.showInfo(this.$t('regular.notifications.kviSearchStarted') as string);
                },
            )
            .catch((e) => {
                this.showError(this.$t('regular.errors.startKviSearchFailed') as string);
                this.$log.error('Error occurred on creating search kvi recommends', e)
            });
    }

    hideSkuPanel() {
        this.showSku = false;
        this.clearFilters(true);
    }

    downloadDefaultMasterSetupParams() {
        this.$setupMasterCalc.selectCoefficent = {value: {k1: 1, k2: 0}, label: this.$t('regular.strategies.maxGrossMargin') as string};
        this.$setupMasterCalc.marginalProfit = 5;
        this.$setupMasterCalc.priceDecreaseLimit = 15;
        this.$setupMasterCalc.priceIncreaseLimit = 15;
        this.$setupMasterCalc.priceChangeLimit = 1;
        this.$setupMasterCalc.priceChangeLimitKvi = 1;
        this.$setupMasterCalc.priceChangeLimitComp = 1;
        this.$setupMasterCalc.periodPriceIncreaseLimit = 100;
        this.$setupMasterCalc.period = {value: 7, label: this.$t('regular.common.week') as string};
        this.$setupMasterCalc.xyzChecked = true;
        this.$setupMasterCalc.competitorsPrices = 25;
        this.$setupMasterCalc.percentageOfCompetitorsPrice = '5';
        this.$setupMasterCalc.kviStrategy = kviStrategiesSet.EQUALS;
        this.$setupMasterCalc.minProfitKVI = 0;
        this.$setupMasterCalc.kviPriceDecreaseLimit = 15;
        this.$setupMasterCalc.useCompetitorsPrices = false;
        this.$setupMasterCalc.byPromoPrices = false;
        this.$setupMasterCalc.useCompElasticity = false;
        this.$setupMasterCalc.calculateCompAllowedDeviation = true;
        this.$setupMasterCalc.competitorPriceControlParameterPc = 25;
        this.$setupMasterCalc.competitorsPricePeriod = 28;
        this.$setupMasterCalc.competitorsInfluencesCoef = 1;
        this.$setupMasterCalc.percentileType = {value: PercentileTypes.Q5, label: '0-100'};
        this.$setupMasterCalc.competitorsPriceAdjustment = '10';
        this.$setupMasterCalc.competitorsControlParam = 10;
        this.$setupMasterCalc.competitorsPriceMethod = competitorsPriceMethodsSb.MIN_PRICE;
        this.$setupMasterCalc.competitorsMinimumProfit = 0;
        this.$setupMasterCalc.competitorsPriceStrategy = competitorsPriceStrategiesSb.EQUALS;
        this.$setupMasterCalc.compPriceDecreaseLimit = 15;
        this.$setupMasterCalc.calculationDepth = 4;
        this.$setupMasterCalc.calculationDay = 28;
        this.$setupMasterCalc.depthToPurchasePrice = 4;
        this.$setupMasterCalc.countAtMaxPurchasePrice = true;
        this.$setupMasterCalc.countAtFuturePurchasePrice = false;
        this.$setupMasterCalc.countPriceBySkuWithoutBatches = false;
        this.$setupMasterCalc.countByAvgPurchasePrice = false;
        this.$setupMasterCalc.calcPurchasePriceByClusters = false;
        this.$setupMasterCalc.useEmptyRemains = false;
        this.$setupMasterCalc.useArrivalDate = false;
        this.$setupMasterCalc.changePriceCorridor = false;
        this.$setupMasterCalc.priceCorridor = {
            min: 1.0,
            max: 100.0,
        };
        this.$setupMasterCalc.fixLowerBorder = false;
        this.$setupMasterCalc.priceFamilies = true;
        this.$setupMasterCalc.hardPriceFamilies = false;
        this.$setupMasterCalc.calculatePYR = false;
    }

    async save() {
        this.competitors = []
        this.viewCompetitors = []
        // Подгружаем конкурентов перед сохранением, на случай если забыли подгрузить через открытие списка SKU
        if (this.$calc.competitorsCodes.length === 0) {
            const offset = 0;
            const competitorFilter = this.getCompetitorsFilter();
            await this.httpLoadCompetitorsPrice(competitorFilter, this.competitorsTablePagination.pageSize, offset)
                .then((data) => {
                    this.competitors = data.data.content.map(this.toRow)
                    this.viewCompetitors = this.competitors;
                    this.$calc.competitorsCodes = this.competitors.map((i) => {
                        return i.internalCode;
                    });
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadCompetitorPricesFailed') as string);
                });
        }
        const filters = this.getCalcFilter();
        //SP-75149: сохранение падает с ошибкой "сликшом большой реквест"
        //из-за сохранения индивидуальных параметров
        filters.individualCommonParams = Object.create(null);
        this.httpSaveBaseFilter(filters)
            .then((r) => {
                this.$log.debug(this.$t('regular.notifications.paramsSaved') as string, r.data);
                this.showInfo(this.$t('regular.notifications.paramsSaved') as string);
                EventBus.$emit('onCalcParamsSaved')
            })
            .catch((e) => {
                if (e.response && e.response.status === 400 && e.response.data) {
                    if (typeof e.response.data === 'string') {
                        this.showError(e.response.data, 7);
                    } else {
                        this.showError(this.$t('regular.errors.saveCalcParamsFailed') as string);
                    }
                } else {
                    this.showError(this.$t('regular.errors.saveCalcParamsFailed') as string);
                }
            });
        localStorage.setItem('isSaveStateAvailable', 'false')
    }

    async saveRulesParams() {
        const filters = this.getRulesFilters();

        this.httpSaveRulesParams(filters)
            .then((r) => {
                this.$log.debug(this.$t('regular.notifications.paramsSaved') as string, r.data);
                this.showInfo(this.$t('regular.notifications.paramsSaved') as string);
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.saveCalcParamsFailed') as string + e);
            })
    }

    getRulesFilters(): BaseFilterRoundingRules {
        return {
            filterType: 'BASE',
            tradingId: this.$roundingRules.selectMarket.id,
            category: this.$roundingRules.categoryOfProduct,
            groupOfProduct: this.$roundingRules.groupOfProduct,
            seasonValues: this.$roundingRules.seasonSelected,
            buyerSegments: this.$roundingRules.buyerSegmentsList,
            storeRegionValues: this.$roundingRules.regionSelected,
            categoryStrategy: this.$roundingRules.categoryStrategy.value,
            storeFormat: this.$roundingRules.formatSelected,
            subcategories: this.$roundingRules.subcategories,
            productSegments: this.$roundingRules.productSegments,
            allNewPricesWithoutPennies: this.$roundingRules.allNewPricesWithoutPennies,
            storeCluster: this.$roundingRules.clusterSelected,
            pennies: this.$roundingRules.pennies,
            randomPennies: this.$roundingRules.randomPennies,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            bigDigit: this.$roundingRules.bigDigit,
            manualPennies: this.$roundingRules.manualPennies,
        }
    }

    saveSetupMasterParams() {
        const filters = this.getCalcFilterForSetupMaster();
        this.httpSaveBaseFilter(filters)
            .then((r) => {
                this.$log.debug(this.$t('regular.notifications.paramsSaved') as string, r.data);
                this.showInfo(this.$t('regular.notifications.paramsSaved') as string);
                EventBus.$emit('onCalcParamsSaved');
                this.moveToCalcParamsTab('innerRulesTab');
            })
            .catch((e) => {
                if (e.response && e.response.status === 400 && e.response.data) {
                    if (typeof e.response.data === 'string') {
                        this.showError(e.response.data, 7);
                    } else {
                        this.showError(this.$t('regular.errors.saveCalcParamsFailed') as string);
                    }
                } else {
                    this.showError(this.$t('regular.errors.saveCalcParamsFailed') as string);
                }
            });
    }

    updatePriceCorridorAndSkuList() {
        this.priceCorridorInfo();
        this.saveCalc();
    }

    updatePriceCorridorForSetupMaster() {
        this.priceCorridorInfoForSetupMaster();
        this.saveSetupMasterCalc();
    }

    checkSkuButtonWithCalc() {
        if (!this.skuListWithCalculating && this.isFiltersChanged === 0) {
            this.isFiltersChanged = 1;
        }
        this.skuListWithCalculating = true;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = true;
        this.calcSkuActualProfitButtonDisabled = true;
    }

    checkSkuButtonWithoutCalc() {
        if (this.skuListWithCalculating && this.isFiltersChanged === 0) {
            this.isFiltersChanged = 1;
        }
        this.skuListWithCalculating = false;
    }

    loadSkuWithoutCalc() {
        this.skuListWithCalculating = false;
        this.needLoadSkuList = true;
    }

    reloadSkuList() {
        this.isFiltersChanged = 1;
        this.needLoadSkuList = false;
    }

    loadSkuWithCalc() {
        this.skuListWithCalculating = true;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = true;
        this.calcSkuActualProfitButtonDisabled = true;
        this.refreshSkuTableInPanel();
    }

    loadNewProductsWithoutCalc() {
        this.newProductsWithCalculating = false;
        this.needLoadNewProductList = true;
    }

    loadNewProductsWithCalc() {
        this.newProductsWithCalculating = true;
        this.refreshNewProductsTable();
    }

    loadTask() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.taskData = null;
            return;
        }
        const data = this.getCalcFilter()
        // fixme: (╯°□°）╯︵ ┻━┻ wtf? Why do you use here full object?
        this.httpFindTaskByParams(data)
            .then((resp) => {
                if (resp.status === 200) {
                    this.$log.debug('Task was found', resp.data)
                    const task = resp.data;

                    let subCategories = ' - ';
                    if (task.subcategories.length > 0) {
                        subCategories = task.subcategories + ' / '
                    }

                    let formatName = ' - ';
                    if (task.format !== '') {
                        formatName = task.format + ' / '
                    }

                    let regionName = ' - ';
                    if (task.region !== '') {
                        regionName = task.region + ' / '
                    }

                    let clusterName = ' - ';
                    if (task.cluster !== '') {
                        clusterName = task.cluster + ' / '
                    }
                    const filterNames = task.group + ' / ' + task.category + ' / ' + subCategories + formatName + regionName + clusterName

                    this.taskData = {
                        id: task.id,
                        status: task.status,
                        type: task.typeMachine,
                        fileResult: task.fileResult,
                        editable: task.editable,
                        filterNames,
                    };
                } else {
                    this.$log.debug('Task was not found')
                    this.taskData = null;
                }
            });
    }

    loadMoreSku() {
        this.isFiltersChanged = 1

        this.fetchSkuList(++this.loadMorePage);
    }

    // loadMoreNewProducts() {
    //     this.newProductsListCurrentPage += 1;
    //     this.isFiltersChanged = 1

    //     this.fetchNewProductsList(this.newProductsListCurrentPage)
    // }

    loadMoreCtm() {
        this.ctmProductsTablePagination.current = 1;
        this.ctmProductsTablePagination.pageSize += 10;

        this.isFiltersChanged = 1;

        this.fetchCtmList(1)
    }

    fetchSkuList(currentPage: number = 1): Promise<void> {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null || this.$calc.formatSelected == null
            || !this.$calc.regionSelected[0] || (this.taskInfo.clusterOptions.length > 1 && this.$calc.clusterSelected == null)) {
            this.tableDataSkuList = []
            return Promise.resolve();
        }

        const filter = this.getSkuFilter()
        const offset = (currentPage - 1) * this.skuListLimit;
        this.isFetchSkuListDownload = true;

        return this.httpGetSkuList(filter, this.skuListLimit, offset)
            .then(async (r) => {
                    if (currentPage > 1) {
                        this.tableDataSkuList.push(
                            ...r.data.content.map((item: any) => {
                                const individualConfig = this.$calc.individualCommonParams[item.internalCode];
                                const priceExperimentFromConfig = individualConfig && individualConfig.priceExperiment !== undefined 
                                    ? individualConfig.priceExperiment 
                                    : null;
                                return {
                                    ...item,
                                    priceExperiment: item.priceExperiment !== undefined
                                        ? item.priceExperiment
                                        : (priceExperimentFromConfig !== null ? priceExperimentFromConfig : false),
                                    byPromoPrices: item.byPromoPrices !== undefined
                                        ? item.byPromoPrices
                                        : !!(individualConfig && individualConfig.byPromoPrices),
                                };
                            }),
                        );
                    } else {
                        this.tableDataSkuList = r.data.content.map((item: any) => {
                            const individualConfig = this.$calc.individualCommonParams[item.internalCode];
                            const priceExperimentFromConfig = individualConfig && individualConfig.priceExperiment !== undefined 
                                ? individualConfig.priceExperiment 
                                : null;
                            return {
                                ...item,
                                priceExperiment: item.priceExperiment !== undefined
                                    ? item.priceExperiment
                                    : (priceExperimentFromConfig !== null ? priceExperimentFromConfig : false),
                                byPromoPrices: item.byPromoPrices !== undefined
                                    ? item.byPromoPrices
                                    : !!(individualConfig && individualConfig.byPromoPrices),
                            };
                        });

                        this.loadMorePage = 1;
                    }

                    this.skuListTotalRows = r.data.totalElements;

                    this.isFetchSkuListDownload = false;
                    this.isFiltersChanged = 0;
                    this.lastPage = currentPage;

                    if (r.data.content[0]) {
                        this.competitorNames = !r.data.content[0].competitorNames ? [this.$t('regular.common.all') as string] : r.data.content[0].competitorNames;
                    }

                    await this.tryFindParams(true);
                },
            )
            .catch((e) => {
                this.tableDataSkuList = []
                this.isFetchSkuListDownload = false;
                this.isFiltersChanged = 0;
                this.lastPage = currentPage;
                throw e;
            });
        if (this.skuListWithCalculating && this.segmentPriceOptions.length === 0) {
            this.getSegmentPriceInfo();
        }
        if (this.productSegmentIdAndNameOptions.length === 0) {
            this.getProductSegmentIdAndName();
        }
        this.getSkuKeysAndAttributes();
        this.httpGetProductRangeListByFilters(filter)
            .then((r) => {
                    this.productLineOptions = r.data.map((i) => {
                        return {value: i, label: i}
                    });
                    this.productLineOptionsForFilter = r.data.map((i) => {
                        return {value: i, label: i}
                    });
                    this.productLineOptions.unshift({value: '', label: this.$t('regular.common.empty') as string});
                    this.productLineOptionsForFilter.unshift({value: 'all', label: this.$t('regular.common.all') as string}, {value: '', label: this.$t('regular.common.empty') as string});
                },
            );
    }

    fetchCtmList(currentPage: any = 1) {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.tableDataCtmList = []
            return;
        }

        if (currentPage) {
            this.ctmProductsTablePagination.current = currentPage;
        }

        const filter = this.getCtmSkuFilter();
        filter.ctm = '1';
        const offset = (this.ctmProductsTablePagination.current - 1) * this.ctmProductsTablePagination.pageSize;

        this.isCtmProductsTableLoading = true;

        this.httpGetSkuList(filter, this.ctmProductsTablePagination.pageSize, offset)
            .then((r) => {
                this.tableDataCtmList = r.data.content.map((item: any) => {
                    const individualConfig = this.$calc.individualCommonParams[item.internalCode];
                    return {
                        ...item,
                        byPromoPrices: item.byPromoPrices !== undefined
                            ? item.byPromoPrices
                            : !!(individualConfig && individualConfig.byPromoPrices),
                    };
                });

                this.ctmProductsTablePagination.total = r.data.totalElements;
             })
            .catch((e) => {
                this.tableDataCtmList = [];
            }).finally(() => {
                this.isCtmProductsTableLoading = false;
            });

        if (this.skuListWithCalculating && this.segmentPriceOptions.length === 0) {
            this.getSegmentPriceInfo();
        }
        if (this.productSegmentIdAndNameOptions.length === 0) {
            this.getProductSegmentIdAndName();
        }
        this.getSkuKeysAndAttributes();

        this.httpGetProductRangeListByFilters(filter)
            .then((r) => {
                    this.productLineOptions = r.data.map((i) => {
                        return {value: i, label: i}
                    });
                    this.productLineOptionsForFilter = r.data.map((i) => {
                        return {value: i, label: i}
                    });
                    this.productLineOptions.unshift({value: '', label: this.$t('regular.common.empty') as string});
                    this.productLineOptionsForFilter.unshift({value: 'all', label: this.$t('regular.common.all') as string}, {value: '', label: this.$t('regular.common.empty') as string});
                },
            );
    }

    fetchNewProductsList(currentPage: any = 1) {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.tableDataNewProductsList = []
            return;
        }
        const filter = this.getNewProductsSkuFilter();
        const limit = this.newProductListPerPage;
        const offset = limit * (currentPage - 1);
        this.isFetchNewProductsListDownload = true;
        this.httpGetNewProductsList(filter, limit, offset)
            .then((r) => {
                    this.newProductsList = r.data.content;
                    this.newProductsListTotalRows = r.data.totalElements;
                    this.tableDataNewProductsList = r.data.content.map((item: any) => {
                        const individualConfig = this.$calc.individualCommonParams[item.internalCode];
                        return {
                            ...item,
                            byPromoPrices: item.byPromoPrices !== undefined
                                ? item.byPromoPrices
                                : !!(individualConfig && individualConfig.byPromoPrices),
                        };
                    });

                    this.isFetchNewProductsListDownload = false;
                    this.newProductsLastPage = currentPage;
                },
            )
            .catch((e) => {
                this.tableDataNewProductsList = []
                this.isFetchNewProductsListDownload = false;
                this.newProductsLastPage = currentPage;
            });
        this.getSegmentPriceInfoForNewProducts();
        if (this.newProductSegmentIdAndNameOptions.length === 0) {
            this.getNewProductSegmentIdAndName();
        }
        this.getNewProductsSkuKeysAndAttributes();
    }

    async downloadAllSku() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }

        const filter = this.getSkuFilter()
        await this.httpGetAllSku(filter)
            .then((r) => {
                    this.skuListWithAllProducts = r.data;
                },
            )
            .catch((e) => {
            });
    }

    async downloadAllNewProducts() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }

        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const ctm: string | null = this.selectCTMForNewProducts === 'all' ? null : this.selectCTMForNewProducts;
        this.selectSegmentPriceForNewProducts = this.selectSegmentPriceForNewProducts.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPriceForNewProducts.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });

        const newProductSegments = this.selectNewProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];

        const filter: SkuFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            kvi: this.selectKVIForNewProducts,
            ctm,
            priceSegments,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.newProductsWithCalculating,
            productSegments: LocalData.filterNumberArrays(newProductSegments),
        };
        await this.httpGetAllNewProducts(filter)
            .then((r) => {
                    this.newProductsListWithAllProducts = r.data;
                },
            )
            .catch((e) => {
            });
    }

    async downloadAllCtmProducts() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }

        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const ctm: string | null = '1';
        this.selectSegmentPriceForNewProducts = this.selectSegmentPriceForNewProducts.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPriceForNewProducts.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });

        const newProductSegments = this.selectNewProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];

        const filter: SkuFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            kvi: this.selectKVIForNewProducts,
            ctm,
            priceSegments,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.newProductsWithCalculating,
            productSegments: LocalData.filterNumberArrays(newProductSegments),
        };
        await this.httpGetAllNewProducts(filter)
            .then((r) => {
                    this.newProductsListWithAllProducts = r.data;
                },
            )
            .catch((e) => {
            });
    }

    fetchCtmProductsList(currentPage: any) {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.tableDataCtmList = []
            return;
        }
        const filter = this.getNewProductsSkuFilter();
        const offset = (currentPage - 1) * this.newProductsListLimit;
        this.isFetchCtmProductsListDownload = true;
        this.httpGetNewProductsList(filter, this.newProductsListLimit, offset)
            .then((r) => {
                    this.newProductsList = r.data.content;
                    this.newProductsListTotalRows = r.data.totalElements;
                    this.tableDataCtmList = r.data.content.map((item: any) => {
                        const individualConfig = this.$calc.individualCommonParams[item.internalCode];
                        return {
                            ...item,
                            byPromoPrices: item.byPromoPrices !== undefined
                                ? item.byPromoPrices
                                : !!(individualConfig && individualConfig.byPromoPrices),
                        };
                    });
                    this.isFetchCtmProductsListDownload = false;
                    this.newProductsLastPage = currentPage;
                },
            )
            .catch((e) => {
                this.tableDataCtmList = []
                this.isFetchCtmProductsListDownload = false;
                this.newProductsLastPage = currentPage;
            });
        this.getSegmentPriceInfoForNewProducts();
        if (this.newProductSegmentIdAndNameOptions.length === 0) {
            this.getNewProductSegmentIdAndName();
        }
        this.getNewProductsSkuKeysAndAttributes();
    }

    sortSkuListBySKU() {
        if (this.sortBySKU === -1 || this.sortBySKU === 1) {
            this.sortBySKU = 0;
        } else {
            this.sortBySKU = 1;
        }
        this.refreshSkuList();
    }

    sortSkuListBySKUInTablePanel(callback: any) {
        if (this.sortBySKU === -1 || this.sortBySKU === 1) {
            this.sortBySKU = 0;
        } else {
            this.sortBySKU = 1;
        }
        this.refreshSkuTableInPanel();
        callback(1)
    }

    sortNewProductsBySKU(callback: any) {
        if (this.sortingNewProductsBySKU === -1 || this.sortingNewProductsBySKU === 1) {
            this.sortingNewProductsBySKU = 0;
        } else {
            this.sortingNewProductsBySKU = 1;
        }
        this.refreshNewProductsTable();
        callback(1)
    }

    isPriceCategoryRecommends(sku: Sku): boolean {
        return sku.priceCategoryRecommendation;
    }

    isCartGeneratorRecommends(sku: Sku): boolean {
        return sku.cartGeneratorRecommendation;
    }

    isSelectedKvi(sku: Sku): boolean {
        return sku.kvi === 1;
    }

    isSelectedCtmBrandPurpose(sku: Sku): boolean {
        return sku.ctmBrandPurpose === '1';
    }

    isActiveSaveKviButton(): boolean {
        return this.productCodesForAddKvi.length === 0 && this.productCodesForDeleteKvi.length === 0;
    }

    setSelectedKvi(sku: Sku, selected: boolean) {
        if (selected) {
            if (sku.kvi !== 1) {
                this.productCodesForAddKvi.push(sku.internalCode);
            }
            const index = this.productCodesForDeleteKvi.findIndex((item) => {
                return item === sku.internalCode
            });
            if (index !== -1) {
                this.productCodesForDeleteKvi.splice(index, 1);
            }
        } else {
            if (sku.kvi === 1) {
                this.productCodesForDeleteKvi.push(sku.internalCode);
            }
            const index = this.productCodesForAddKvi.findIndex((item) => {
                return item === sku.internalCode
            });
            if (index !== -1) {
                this.productCodesForAddKvi.splice(index, 1);
            }
        }
    }

    saveKviParams() {
        const filters = this.getCalcFilter();
        this.kviSaveProcess = true;
        this.httpSaveOrDeleteKviParam(filters)
            .then((r) => {
                this.kviSaveProcess = false;
                this.showInfo(this.$t('regular.notifications.kviAttributesSaved') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.productCodesForAddCtmPurpose = [];
                this.productCodesForDeleteCtmPurpose = [];
                this.refreshSkuList();
            })
            .catch((e) => {
                this.kviSaveProcess = false;
                this.showError(this.$t('regular.errors.saveKviFailed') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
            });
    }

    getProductRange(productLine: string): string {
        const index = this.productLineOptions.findIndex((item) => {
            return item.value === productLine
        });

        if (index !== -1) {
            return this.productLineOptions[index].value
        } else {
            return ""
        }
    }

    inputOrDeleteProductRange(row: Sku, value: SelectBox<string>) {
        const index = this.productRangesArray.findIndex((item) => {
            return item.internalCode === row.internalCode
        });

        const rangeAndCode: InternalCodeAndProductRange = {
            internalCode: row.internalCode,
            productRange: value.value,
        };

        if (index === -1) {
            this.productRangesArray.push(rangeAndCode)
        } else {
            this.productRangesArray.splice(index, 1)
            this.productRangesArray.push(rangeAndCode)
        }
    }

    saveKviParamsForSkuInPanel() {
        const filters = this.getCalcFilter();
        this.kviSaveProcess = true;
        this.httpSaveOrDeleteKviParam(filters)
            .then((r) => {
                this.kviSaveProcess = false;
                this.showInfo(this.$t('regular.notifications.kviAttributesSaved') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.refreshSkuTableInPanel();
            })
            .catch((e) => {
                this.kviSaveProcess = false;
                this.showError(this.$t('regular.errors.saveKviFailed') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
            });
    }

    saveKviParamsForNewProducts() {
        const filters = this.getCalcFilter();
        this.kviSaveProcess = true;
        this.httpSaveOrDeleteKviParamForNewProducts(filters)
            .then((r) => {
                this.kviSaveProcess = false;
                this.showInfo(this.$t('regular.notifications.kviAttributesSaved') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.refreshNewProductsTable();
            })
            .catch((e) => {
                this.kviSaveProcess = false;
                this.showError(this.$t('regular.errors.saveKviFailed') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
            });
    }

    clearFilters(dontRefreshList: boolean = false) {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = 'all';
        this.selectSegmentPrice = [];
        this.selectProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectKeyCharacteristicThree = [];
        this.selectKeyCharacteristicFour = [];
        this.selectKeyCharacteristicFive = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = 'all';
        this.internalCodeFilterText = '';

        if (!dontRefreshList) {
            this.refreshSkuList();
        }
    }

    clearCtmProductsFilters() {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = 'all';
        this.selectSegmentPrice = [];
        this.selectProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectKeyCharacteristicThree = [];
        this.selectKeyCharacteristicFour = [];
        this.selectKeyCharacteristicFive = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = 'all';
        this.internalCodeFilterText = '';

        this.fetchCtmList(1);
    }

    clearFiltersInNewProductsTable() {
        this.sortingNewProductsBySKU = -1;
        this.selectKVIForNewProducts = this.defaultFilterValue.value;
        this.selectCTMForNewProducts = 'all';
        this.selectSegmentPriceForNewProducts = [];
        this.segmentPriceOptionsForNewProducts = [];
        this.selectNewProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOneForNewProduct = [];
        this.selectKeyCharacteristicTwoForNewProduct = [];
        this.selectKeyCharacteristicThreeForNewProduct = [];
        this.selectKeyCharacteristicFourForNewProduct = [];
        this.selectKeyCharacteristicFiveForNewProduct = [];
        this.selectRecipeAttributesForNewProduct = [];
        this.selectTreatmentAttributesForNewProduct = [];
        this.refreshNewProductsTable()
    }

    selectOrClearAllCompetitors() {
        if (this.$calc.competitorsCodes.length !== 0) {
            this.$calc.competitorsCodes = []
        } else {
            this.$calc.competitorsCodes = this.competitors.map((i) => {
                return i.internalCode;
            });
        }
    }

    calcButtonState(): boolean {

        if (this.$calc.selectMarket != null) {
            const state = this.paramsSum && this.paramsSumXYZ && this.calculationDepthValidate
                && this.calculationDayValidate && this.priceIncreaseLimitValidate && this.competitorsPricesValidate
                && this.marginalPriceDifferenceValidate
                && this.marginalProfitabilityValidate && this.marginalProfitValidate && this.inputInterval && this.inputIntervalP
                && this.correlationCheck && this.highElasticityCheck && this.competitorPriceControlParameterPcValidate && this.marginalProfitDeclinePcValidate;

            return !state;

        }
        return true;
    }

    getCompetitorsTableFilterOptions() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }

        const competitorFilter = this.getCompetitorsFilter();

        this.httpLoadCompetitorsTableFilterOptions(competitorFilter)
            .then((response) => {
                this.competitorsTableFilterOptions = {
                    ...response.data,
                    kviOptions: this.kviOptions,
                    ctmOptions: this.ctmOptions,
                };
            })
            .catch((e) => {
                console.error(e)
                this.showError(this.$t('regular.errors.loadFilterOptionsFailed') as string);
            })
    }

    resetRadioButtons(filterModelKey: keyof ICompetitorsTableFilterValues) {
        if (filterModelKey === 'kviValue') {
            this.competitorsTableFilterValues.kviValue = -1;
        } else if (filterModelKey === 'ctmValue') {
            this.competitorsTableFilterValues.ctmValue = 'all';
        } else {
            this.competitorsTableFilterValues[filterModelKey] = [];
        }
    }

    listCompetitors(currentPage?: number) {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }

        if (currentPage) {
            this.competitorsTablePagination.current = currentPage;
        }

        const competitorFilter = this.getCompetitorsFilter(true);
        this.isLoadCompetitorPrices = true;

        this.httpLoadCompetitorsPrice(competitorFilter, this.competitorsTablePagination.pageSize, this.competitorsTablePagination.pageSize * (this.competitorsTablePagination.current - 1))
            .then((response) => {
                this.onLoadCompetitors(response.data.content);

                this.competitorsTablePagination.total = response.data.totalElements;
            })
            .catch((e) => {
                console.error(e)
                this.showError(this.$t('regular.errors.loadCompetitorPricesFailed') as string);
            }).finally(() => {
                this.isLoadCompetitorPrices = false;
            });

        if (this.needFetchCompetitorCodes) {
            this.httpLoadCompetitorsTableFilterOptions(competitorFilter)
                .then((response) => {
                    this.competitorsTableFilterOptions = {
                        ...this.competitorsTableFilterOptions,
                        optionCompetitorsCodes: response.data.optionCompetitorsCodes,
                    };
                })
                .catch((e) => {
                    console.error(e)
                    this.showError(this.$t('regular.errors.loadFilterOptionsFailed') as string);
                }).finally(() => {
                    this.needFetchCompetitorCodes = false;
            })
        }
    }

    filterByKvi(kvi: any): void {
        this.viewCompetitors = kvi === -1 ? this.competitors : this.viewCompetitors.filter((value) => kvi == value.kvi)
    }

    filterByCtm(cmts: { value: string }): void {
        this.viewCompetitors = cmts.value === 'all' ? this.competitors : this.viewCompetitors.filter((value) => cmts.value == value.ctm)
    }

    toRow(competitor: RegularCompetitorsPricesView): CompetitorsPriceRow {
        return {
            ...competitor,
            competitorDate: new Date(competitor.priceDate),
            ctm: competitor.ctm == null ? this.$t('regular.common.no') as string : competitor.ctm
        }
    }

    onLoadCompetitors(response: RegularCompetitorsPricesView[]): void {
        this.competitors = response.map(this.toRow)
        this.viewCompetitors = this.competitors;
        this.$calc.competitorsCodes = this.competitors.map((i) => {
            return i.internalCode;
        });
    }

    computedDelta = (item: { lastPrice: number, competitorPrice: number }): number => {
        return ((item.lastPrice / item.competitorPrice - 1) * 100);
    }

    getColor = (delta: number) => {
        if (delta > 0) {
            return 'green';
        } else if (delta < 0) {
            return 'red';
        }
        return 'black';
    }

    isSelectedCompetitorCode(internalCode: string) {
        const index = this.$calc.competitorsCodes.findIndex((item) => {
            return item === internalCode
        });
        return index !== -1;
    }

    setSelectedCompetitorCode(internalCode: string, selected: boolean) {
        const index = this.$calc.competitorsCodes.findIndex((item) => {
            return item === internalCode
        });
        if (selected) {
            if (index === -1) {
                this.$calc.competitorsCodes.push(internalCode);
            }
        } else {
            if (index !== -1) {
                this.$calc.competitorsCodes.splice(index, 1);
            }
        }
        this.saveCalc();
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null
            }
        }
    }

    onMultiSelectToggleForSetupMaster(open: boolean) {
        this.dropDownOpenForSetupMaster = open;
        if (!open) {
            if (this.onDropdownClosedForSetupMaster != null) {
                this.onDropdownClosedForSetupMaster.apply(open);
                this.onDropdownClosedForSetupMaster = null
            }
        }
    }

    refreshPriceSegments() {
        if (!this.findAutomaticallyPriceSegments) {
            this.countPriceSegments = 1;
        }
    }

    refreshPriceSegmentsForSetupMaster() {
        if (!this.findAutomaticallyPriceSegmentsForSetupMaster) {
            this.countPriceSegmentsForSetupMaster = 1;
        }
    }

    insertGlobalIndividualParamsForSkuPanel() {
        this.insertGlobalIndividualParams();
        this.refreshSkuTableInPanel();
    }

    insertGlobalIndividualParamsForSkuTable() {
        this.insertGlobalIndividualParams();
        this.refreshSkuList();
    }

    moveToCalcParamsTab(tabName: string) {
        this.setMasterSetupParamsToCalc();
        this.settingsMasterIsOpen = false
        this.currentMainTab = "mainParameters"
        // const secTab = this.$refs.paramsTabsInMainTabs as BTabs;
        // const row = secTab.tabs.find((myTab: BTab) => myTab.$el.id === tabName);
        // if (row !== undefined) {
        //     row.activate();
        // }
    }

    async insertGlobalIndividualParamsForNewProducts() {
        await this.downloadAllNewProducts();
        await this.newProductsListWithAllProducts.forEach((sku) => {
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'selectCoefficent', this.globalIndividualNewProductStrategyOpt!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'marginalProfit', this.globalIndividualNewProductMarginalProfitability!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'marginalProfitKvi', this.$calc.minProfitKVI)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'marginalProfitCompetitors', this.$calc.competitorsMinimumProfit)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'kviStrategy', this.globalIndividualNewProductKviStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'percentageOfCompetitorsPrice', this.globalIndividualNewProductPercentageOfCompetitorsPrice!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'newProductPriceStrategy', this.globalIndividualNewProductPriceStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'priceGap', this.globalIndividualNewProductPriceGap!!)
        });
        this.refreshNewProductsTable();
    }

    async insertGlobalIndividualParams() {
        await this.downloadAllSku();
        await this.skuListWithAllProducts.forEach((sku) => {
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'selectCoefficent', this.globalIndividualPriceStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'priceIncreaseLimit', this.globalIndividualPriceIncreaseLimit!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'periodPriceIncreaseLimit', this.globalIndividualPeriodPriceIncreaseLimit!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'period', this.globalIndividualPeriod!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'marginalProfit', this.globalIndividualMarginalProfitability!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'marginalProfitKvi', this.$calc.minProfitKVI)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'marginalProfitCompetitors', this.$calc.competitorsMinimumProfit)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'kviStrategy', this.globalIndividualKviStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'percentageOfCompetitorsPrice', this.globalIndividualPercentageOfCompetitorsPrice!!)
        });
    }

    isReactive(obj: any): boolean {
        return obj && obj.__ob__;
    }

    setCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig, value: number | string[] | SelectBox<any> | string | boolean) {
        const valueIsArray = Array.isArray(value);

        if (!(sku in config)) {
            if (valueIsArray) {
                this.$set(config, sku, {});
            } else {
                config[sku] = {};
            }
        } else {
            if (valueIsArray && !!config[sku] && !this.isReactive(config[sku])) {
                const skuConfig = Object.assign({}, config[sku]);

                delete config[sku];

                this.$set(config, sku, skuConfig);
            }
        }

        if (valueIsArray) {
            this.$set(config[sku], property, value);
        } else if (typeof value === 'number' && Number.isNaN(value)) {
            config[sku][property] = null;
        } else {
            config[sku][property] = value;
        }
    }

    getSelectIndividConfig(internalCode: any, key: any) {
       const value = this.getCalcIndividConfig(this.$calc.individualCommonParams, internalCode,key) as {label: string, value: any}
       if(value && value.value){
        return value.value.enum
       }
       return value
    }

    clearAllGlobalIndividualParams() {
        this.globalIndividualPriceStrategy = null;
        this.globalIndividualPriceIncreaseLimit = null;
        this.globalIndividualPeriodPriceIncreaseLimit = null;
        this.globalIndividualPeriod = null;
        this.globalIndividualMarginalProfitability = null;
        this.globalIndividualKviStrategy = null;
        this.globalIndividualPercentageOfCompetitorsPrice = null;
        this.globalIndividualNewProductLifespanInDays = null;
        this.globalIndividualMarginalBlockButton = false;
        this.globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
        this.globalIndividualPriceIncreaseLimitBlockButton = false;
        this.globalIndividualMarginalErrorText = '';
    }

    clearNewProductsGlobalIndividualParams() {
        this.globalIndividualNewProductStrategyOpt = null;
        this.globalIndividualNewProductMarginalProfitability = null;
        this.globalIndividualNewProductKviStrategy = null;
        this.globalIndividualNewProductPercentageOfCompetitorsPrice = null;
        this.globalIndividualNewProductPriceStrategy = null;
        this.globalIndividualNewProductPriceGap = null;
        this.globalNewProductIndividualMarginalBlockButton = false;
        this.globalNewProductIndividualMarginalErrorText = '';
    }

    calcRegularPricesProfitability() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null || this.regularPricesProfitability != null) {
            return;
        }
        this.isRegularPricesProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }
        const filter = this.getSkuFilter()
        this.httpGetRegularPricesProfitability(filter)
            .then((number) => {
                this.regularPricesProfitability = number.data;
                this.isRegularPricesProfitabilityCalculated = false;
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.calcRegularProfitFailed') as string);
                this.isRegularPricesProfitabilityCalculated = false;
            })
    }

    calcRegularPricesProfitabilityForSetupMaster() {
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null || this.regularPricesProfitabilityForSetupMaster != null) {
            return;
        }
        this.isRegularPricesProfitabilityCalculatedForSetupMaster = true;
        const filter = this.getSkuFilterForSetupMaster()
        this.httpGetRegularPricesProfitability(filter)
            .then((number) => {
                this.regularPricesProfitabilityForSetupMaster = number.data;
                this.isRegularPricesProfitabilityCalculatedForSetupMaster = false;
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.calcRegularProfitFailed') as string);
                this.isRegularPricesProfitabilityCalculatedForSetupMaster = false;
            })
    }

    calcActualProfitability() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null || this.actualProfitability != null) {
            return;
        }
        this.isActualProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }
        const filter = this.getSkuFilter()
        this.httpGetActualProfitability(filter)
            .then((number) => {
                this.actualProfitability = number.data;
                this.isActualProfitabilityCalculated = false;
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.calcActualProfitFailed') as string);
                this.isActualProfitabilityCalculated = false;
            })
    }

    calcActualProfitabilityForSetupMaster() {
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null || this.setupMasterActualProfitability != null) {
            return;
        }
        this.isActualProfitabilityCalculatedForSetupMaster = true;
        const filter = this.getSkuFilterForSetupMaster()
        this.httpGetActualProfitability(filter)
            .then((number) => {
                this.setupMasterActualProfitability = number.data;
                this.isActualProfitabilityCalculatedForSetupMaster = false;
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.calcActualProfitFailed') as string);
                this.isActualProfitabilityCalculatedForSetupMaster = false;
            })
    }

    calculateOnlyLastPricesInSku() {
        this.needCalculateSkuLastPricesOnly = true;
        this.refreshSkuList();
        this.calcSkuLastPricesButtonDisabled = true;
    }

    calculateOnlyLastPricesInSkuInPanel() {
        this.needCalculateSkuLastPricesOnly = true;
        this.refreshSkuTableInPanel();
        this.calcSkuLastPricesButtonDisabled = true;
    }

    calculateOnlyActualProfitInSku() {
        this.needCalculateSkuActualProfitabilityOnly = true;
        this.refreshSkuList();
        this.calcSkuActualProfitButtonDisabled = true;
    }

    calculateOnlyActualProfitInSkuInPanel() {
        this.needCalculateSkuActualProfitabilityOnly = true;
        this.refreshSkuTableInPanel();
        this.calcSkuActualProfitButtonDisabled = true;
    }

    onMainTabsClicked(key: string) {
        this.currentMainTab = key
        switch (key) {
            case "listOfProducts":
                // @ts-ignore
                this.loadSkuWithoutCalc();
                this.fetchSkuList(1)
                break;
            case "listOfCompetitors":
                // @ts-ignore
                this.listCompetitors();
                this.getCompetitorsTableFilterOptions();
                break;
            case "listOfResults":
                // @ts-ignore
                this.loadTask()
                break;
            case "keyMetrics":
                // @ts-ignore
                this.updatedTableau()
                break;
            default:
                return
        }
    }

    onMainTabsChanged(key: string) {
        if (key === 'listOfResults') {
            const rv = this.$refs.resultView as ResultView;
            if (rv.existsUnsavedPrices()) {
                this.$bvModal.msgBoxConfirm(this.$t('regular.confirm.resultsNotRecalculated') as string, {
                    headerBgVariant: 'warning',
                    title: this.$t('regular.common.attentionExcl') as string,
                    size: 'sm',
                    buttonSize: 'sm',
                    okTitle: this.$t('regular.common.yes') as string,
                    cancelTitle: this.$t('regular.common.no') as string,
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    noCloseOnEsc: true,
                    noCloseOnBackdrop: true,
                    centered: true,
                })
                    .then((value: any) => {
                        if (value) {
                            rv.saveCorrectedPrices();
                        } else {
                            rv.clearCalcAllData();
                            this.currentMainTab = key
                        }
                    })
                    .catch((err: any) => {
                    })

                // evt.preventDefault();
            }
        } else if (key === 'listOfProducts') {
            // Список товаров больше не загружается автоматически при открытии вкладки
        } else if (key === 'keyMetrics') {
            if (!this.hideTableau()) {
                const script = document.createElement('script');
                script.setAttribute('src', 'https://eu-west-1a.online.tableau.com/javascripts/api/tableau-2.3.0.min.js');
                document.head.appendChild(script);
                const component = this;
                script.addEventListener('load', () => {
                    const container = document.getElementById('tableauContainer');
                    const tableau = (window as any).tableau;
                    const marketName = this.$calc.selectMarket.tradingName
                    const marketId = this.$calc.selectMarket.id
                    const category = this.$calc.categoryOfProduct
                    const categoryOptions = this.taskInfo.categoryOptions
                    const indexCategory = this.taskInfo.categoryOptions.findIndex((item) => {
                        return item.value === category
                    });
                    const options = {
                        device: 'desktop',
                        hideTabs: true,
                        hideToolbar: true,
                        width: '1200px',
                        height: '827px',
                        onFirstInteractive: () => {
                            const sheet = component.viz.getWorkbook().getActiveSheet().getWorksheets();
                            if (marketId !== -1) {
                                sheet[0].applyFilterAsync('Компания', marketName, tableau.FilterUpdateType.REPLACE)
                            } else {
                                sheet[0].clearFilterAsync('Компания')
                            }
                            if (indexCategory !== -1) {
                                sheet[0].applyFilterAsync('Категория товаров', categoryOptions[indexCategory].label, tableau.FilterUpdateType.REPLACE)
                            } else {
                                sheet[0].clearFilterAsync('Категория товаров')
                            }
                        },
                    };
                    component.viz = new tableau.Viz(container, 'https://eu-west-1a.online.tableau.com/t/pbcmanagement/views/SmartPricingPublic/Smartpricing/ivan.snitsky@myretailstrategy.com/835dec7d-26a2-4db1-bdca-0338208a4e40', options);
                    (window as any).vizInstance = component.viz;
                });
            }
        }
    }

    onProductListClicked(key: string) {
        switch (key) {
            case "productsTabKey":
                this.clearFilters()
                break;
            case "newProductsTabKey":
                this.loadNewProductsWithoutCalc()
                this.fetchNewProductsList(1)

                this.isFiltersChanged = 1;
                break;
            case "ctmProductsTabKey":
                this.clearCtmProductsFilters();

                this.isFiltersChanged = 1;
                break;
            default:
                return;
        }
    }

    goToParams() {
        this.currentMainTab = "mainParameters"
    }

    goToSkuList(internalCode: string) {
        this.skuFilter = internalCode;
        this.loadSkuWithoutCalc();
        this.tableKey = Math.random();
        this.currentMainTab = "listOfProducts"
        this.refreshSkuTableInPanel();
    }

    getRoundingRulesFilter(): SmallEventFilterTree {
        return {
            tradingId: this.selectTradingFilter.value,
            categories: this.selectCategoryFilter,
            groupsOfProduct: this.selectGroupFilter,
            subcategories: this.selectSubcategoryFilter,
            storeFormat: this.selectFormatFilter,
            storeRegions: this.selectRegionFilter,
            storeCluster: this.selectClusterFilter,
            kviCartId: null,
        };
    }

    private initDefaultMarketForCalcAndRounding() {
      this.httpLoadTradingNetworks()
          .then((response) => {
            const markets: SelectMarket[] = response.data || [];
            if (!markets.length) {
              return;
            }

            const defaultMarket = markets.find((item) => item.isDefault);
            if (!defaultMarket) {
              return;
            }

            const hasMarket = (market?: SelectMarket | null): boolean => {
              if (!market) {
                return false;
              }
              return markets.some((item) => item.id === market.id);
            };

            if (!hasMarket(this.$calc.selectMarket) || this.$calc.selectMarket.id === -1) {
              this.$calc.selectMarket = defaultMarket;
              this.saveCalc();
            }

            if (!hasMarket(this.$roundingRules.selectMarket) || this.$roundingRules.selectMarket.id === -1) {
              this.$roundingRules.selectMarket = defaultMarket;
              this.saveRoundingRules();
            }
          })
          .catch((e) => {
            this.showError(this.$t('regular.errors.loadTradingCompaniesFailedDot') as string);
          });
    }

    private loadCommonParams(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindBaseParams, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const filter = resp.data.filters;
                            this.applyCalcFilters(this.$calc, filter);
                        }
                    }
                    resolve(!r.ignore);
                })
                .catch((e) => {
                    reject(e)
                })
        });
    }

    private setMasterSetupParamsToCalc() {
        this.updateSelectMarket(this.$setupMasterCalc.selectMarket);
        this.$calc = this.$setupMasterCalc;
    }

    private loadCommonParamsForSetupMaster(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindBaseParams, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const filter = resp.data.filters;
                            this.applyCalcFilters(this.$setupMasterCalc, filter);
                        }
                    }
                    resolve(!r.ignore);
                })
                .catch((e) => {
                    reject(e)
                })
        });
    }

    private loadCommonIndividual(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpLoadBaseIndividual, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const params = resp.data;
                            this.applyBaseIndividualConfig(this.$calc, params);
                        }
                    }
                    resolve(!r.ignore);
                })
                .catch((e) => reject(e))
        });
    }

    private refreshSkuList() {
        this.fetchSkuList(1);

        this.isFiltersChanged = 1;
    }

    private refreshSkuTableInPanel() {
        if (this.productsPageActiveTabKey === "productsTabKey") {
            const skuTableInPanel = this.$refs.skuTableInPanel as BTable;
            if (typeof skuTableInPanel !== 'undefined') {
                this.fetchSkuList();
                skuTableInPanel.$forceUpdate();
            }

            this.isFiltersChanged = 1;
        } else {
            this.fetchCtmList();
        }
    }

    private refreshNewProductsTable() {
        this.newProductsListCurrentPage = 1;
        const newProductsTableInPanel = this.$refs.newProductsTableRef as BTable;
        if (typeof newProductsTableInPanel !== 'undefined') {
            this.fetchNewProductsList()
            newProductsTableInPanel.$forceUpdate();
        }
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions] = this.selectData();
        return {
            type: taskType,
            tradingId: this.$calc.selectMarket.id,
            categories: this.$calc.categoryOfProduct == null || this.$calc.categoryOfProduct <= 0 ? null : [this.$calc.categoryOfProduct],
            groups: this.$calc.groupOfProduct == null || this.$calc.groupOfProduct <= 0 ? null : [this.$calc.groupOfProduct],
            subcategory: LocalData.filterNumberArrays(this.$calc.subcategories, true),
            segments: null,
            storeFormat: this.$calc.formatSelected == null || this.$calc.formatSelected <= 0 ? null : [this.$calc.formatSelected],
            storeCluster: this.$calc.clusterSelected == null || this.$calc.clusterSelected <= 0 ? null : [this.$calc.clusterSelected],
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getTaskInfoForSetupMaster(taskType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions] = this.selectDataForSetupMaster();
        return {
            type: taskType,
            tradingId: this.$setupMasterCalc.selectMarket.id,
            categories: this.$setupMasterCalc.categoryOfProduct == null || this.$setupMasterCalc.categoryOfProduct <= 0 ? null : [this.$setupMasterCalc.categoryOfProduct],
            groups: this.$setupMasterCalc.groupOfProduct == null || this.$setupMasterCalc.groupOfProduct <= 0 ? null : [this.$setupMasterCalc.groupOfProduct],
            subcategory: LocalData.filterNumberArrays(this.$setupMasterCalc.subcategories, true),
            segments: null,
            storeFormat: this.$setupMasterCalc.formatSelected == null || this.$setupMasterCalc.formatSelected <= 0 ? null : [this.$setupMasterCalc.formatSelected],
            storeCluster: this.$setupMasterCalc.clusterSelected == null || this.$setupMasterCalc.clusterSelected <= 0 ? null : [this.$setupMasterCalc.clusterSelected],
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getTaskInfoForRoundingRules(taskType: TaskInfoFilterType): GetTaskInfo {
        const selectRegions: number[] = (this.$roundingRules.regionSelected.length === 0 || (this.$roundingRules.regionSelected.length && this.$roundingRules.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.regionSelected)!!;
        return {
            type: taskType,
            tradingId: this.$roundingRules.selectMarket.id,
            categories: this.$roundingRules.categoryOfProduct == null || this.$roundingRules.categoryOfProduct <= 0 ? null : [this.$roundingRules.categoryOfProduct],
            groups: this.$roundingRules.groupOfProduct == null || this.$roundingRules.groupOfProduct <= 0 ? null : [this.$roundingRules.groupOfProduct],
            subcategory: LocalData.filterNumberArrays(this.$roundingRules.subcategories, true),
            segments: null,
            storeFormat: this.$roundingRules.formatSelected == null || this.$roundingRules.formatSelected <= 0 ? null : [this.$roundingRules.formatSelected],
            storeCluster: this.$roundingRules.clusterSelected == null || this.$roundingRules.clusterSelected <= 0 ? null : [this.$roundingRules.clusterSelected],
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getCalcFilter(): CalcFilters {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const allCheck = this.$calc.allCheck;
        const discountPrice = this.$calc.discountPrice;
        // const pennies = this.$calc.pennies;
        const countAtMaxPurchasePrice = this.$calc.countAtMaxPurchasePrice;
        const countAtFuturePurchasePrice = this.$calc.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = this.$calc.allNewPricesWithoutPennies;
        const allClaster = this.$calc.allClaster;
        const xyzChecked = this.$calc.xyzChecked;
        const uvwChecked = this.$calc.uvwChecked;
        const individualConfigsObj = Object.create(null);
        // tslint:disable-next-line: forin
        for (const key in this.$calc.individualCommonParams) {
            const value = this.$calc.individualCommonParams[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }
        return {
            allCheck,
            discountPrise: discountPrice,
            countAtLastPurchasePrice: false,
            countAtFuturePurchasePrice,
            xyzChecked,
            uvwChecked,
            allClaster,
            coefficientK1: this.$calc.selectCoefficent.value.k1,
            coefficientK2: this.$calc.selectCoefficent.value.k2,
            category: this.$calc.categoryOfProduct,
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments)!!,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: this.$calc.uvwParams,
            spreadXYZParams: this.$calc.xyzParams,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: +this.$calc.calculationDepth,
            correlation: this.$calc.correlation ? this.$calc.correlation : 0.7,
            highElasticity: this.$calc.highElasticity ? this.$calc.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.$calc.intervalOfUltimateElasticity,
            competitorsPricesParams: this.$calc.competitorsPrices,
            kviStrategy: this.$calc.kviStrategy.value,
            percentageOfCompetitorsPrice: this.$calc.percentageOfCompetitorsPrice,
            marginalProfitability: this.$calc.marginalProfitability,
            marginalProfit: this.$calc.marginalProfit,
            marginalProfitKvi: this.$calc.minProfitKVI,
            marginalProfitCompetitors: this.$calc.competitorsMinimumProfit,
            maxMarginalProfit: this.$calc.maxMarginalProfit != null ? this.$calc.maxMarginalProfit : 100,
            marginalPriceDifference: this.$calc.marginalPriceDifference,
            newProductLifespanInDays: this.$calc.newProductLifespanInDays,
            calculationDay: +this.$calc.calculationDay,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            priceIncreaseLimit: this.$calc.priceIncreaseLimit,
            fixLowerBorder: this.$calc.fixLowerBorder,
            individualCommonParams: individualConfigsObj,
            depthToPurchasePrice: this.$calc.depthToPurchasePrice,
            priceFamilies: this.$calc.priceFamilies,
            hardPriceFamilies: this.$calc.hardPriceFamilies,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$calc.selectCoefficent.value.enum!,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            useCompetitorsPrices: this.$calc.useCompetitorsPrices,
            byPromoPrices: this.$calc.byPromoPrices,
            competitorsPricePeriod: this.$calc.competitorsPricePeriod,
            competitorsCodes: this.$calc.competitorsCodes,
            competitorsPriceMethod: this.$calc.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$calc.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$calc.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$calc.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$calc.competitorsMaximumProfit != null ? this.$calc.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$calc.competitorsControlParam,
            competitorsPriceStrategy: this.$calc.competitorsPriceStrategy.value,
            calculateByRegression: !this.$calc.calculateByElasticity,
            recalculateCtm: this.$calc.recalculateCtm,
            priceChangeLimit: this.$calc.priceChangeLimit,
            priceChangeLimitKvi: this.$calc.priceChangeLimitKvi,
            priceChangeLimitComp: this.$calc.priceChangeLimitComp,
            useBrutForcingParams: this.useBrutForcingParams,
            saveAfterOptimize: this.saveAfterOptimize,
            optimizationDiff: this.optimizationDiff,
            calculatePYR: this.$calc.calculatePYR,
            periodPriceIncreaseLimit: this.$calc.periodPriceIncreaseLimit,
            period: this.$calc.period.value,
            decreaseSalesCount: this.$calc.decreaseSalesCount,
            newProductPriceStrategy: this.$calc.newProductPriceStrategy.value,
            priceGap: this.$calc.priceGap,
            priceGapCtmPc: this.$calc.priceGapCtmPc,
            findAutomaticallyPriceSegments: this.findAutomaticallyPriceSegments,
            countPriceSegments: this.countPriceSegments,
            promoCalc: false,
            percentageOfRecommendsKviCount: this.$calc.percentageOfRecommendsKviCount,
            saveKviSign: this.$calc.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.$calc.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.$calc.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.$calc.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$calc.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForDeleteCtmPurpose,
            calculateCompAllowedDeviation: this.$calc.calculateCompAllowedDeviation,
            useCompElasticity: this.$calc.useCompElasticity,
            minProfitKVI: this.$calc.minProfitKVI,
            maxProfitKVI: this.$calc.maxProfitKVI != null ? this.$calc.maxProfitKVI : 100,
            productRangesAndInternalCodes: this.productRangesArray,
            forecastAccuracy: this.$calc.forecastAccuracy,
            countAtMaxPurchasePrice,
            percentileType: this.$calc.percentileType.value,
            useAllProductBatchNumbers: this.$calc.useAllProductBatchNumbers,
            calcWithBatchNumber: true,
            competitorPriceControlParameterPc: this.$calc.competitorPriceControlParameterPc,
            countPriceBySkuWithoutBatches: this.$calc.countPriceBySkuWithoutBatches,
            countByAvgPurchasePrice: this.$calc.countByAvgPurchasePrice,
            calcPurchasePriceByClusters: this.$calc.calcPurchasePriceByClusters,
            useEmptyRemains: this.$calc.useEmptyRemains,
            useArrivalDate: this.$calc.useArrivalDate,
            thompsonSampling: this.$calc.thompsonSampling,
            priceDecreaseLimit: this.$calc.priceDecreaseLimit,
            kviPriceDecreaseLimit: this.$calc.kviPriceDecreaseLimit,
            compPriceDecreaseLimit: this.$calc.compPriceDecreaseLimit,
            backBasketPart: this.$calc.backBasketPart,
            revaluationCalculateParams: this.$calc.revaluationCalculateParams,
            checkMarginDeclineProfit: this.$calc.checkMarginDeclineProfit,
            declineProfitabilityPc: this.$calc.declineProfitabilityPc,
            searchPreviousPricesDepth: this.$calc.searchPreviousPricesDepth,
            compensateLowerTargets: this.$calc.compensateLowerTargets,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            inflation: this.$calc.inflation,
            calculateBySpeedSale: this.$calc.calculateBySpeedSale,
            applyOmnichannel: this.$calc.applyOmnichannel,
            purchasePriceSuppliers: this.$calc.purchasePriceSuppliers,
            categoryOfSuppliers: this.$calc.categoryOfSuppliers!!.value,
            purchasePriceSuppliersMinProfit: this.$calc.purchasePriceSuppliersMinProfit,
            purchasePriceSuppliersMinProfitForKVI: this.$calc.purchasePriceSuppliersMinProfitForKVI,
            purchasePriceSuppliersMinProfitForCompetitors: this.$calc.purchasePriceSuppliersMinProfitForCompetitors,
            sendGeneratedReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
            isFixPricePromo: this.$calc.isFixPricePromo,
            spreadByPriceSegments: this.$calc.spreadByPriceSegments,
            autoApprovalParams: this.$calc.autoApprovalParams,
            priceExperiment: this.$calc.priceExperiment,
            priceExperimentSampleSize: this.$calc.priceExperimentSampleSize,
            priceExperimentDiscountRangeFrom: this.$calc.priceExperimentDiscountRangeFrom,
            priceExperimentDiscountRangeTo: this.$calc.priceExperimentDiscountRangeTo,
            priceExperimentStep: this.$calc.priceExperimentStep,
            priceExperimentStartDate: this.$calc.priceExperimentStartDate,
            priceExperimentEndDate: this.$calc.priceExperimentEndDate,
            daysToPriceChangeStart: this.$calc.daysToPriceChangeStart && this.$calc.daysToPriceChangeStart > 0 
                ? this.$calc.daysToPriceChangeStart 
                : null,
            daysToPriceChangeFinish: this.$calc.daysToPriceChangeFinish && this.$calc.daysToPriceChangeFinish > 0 
                ? this.$calc.daysToPriceChangeFinish 
                : null,
            ...(this.$calc.categoryStrategy && this.$calc.categoryStrategy.value !== CategoryStrategies.EMPTY
                ? {
                    strategyValidityBeginDate: this.$calc.strategyValidityBeginDate
                        ? moment(this.$calc.strategyValidityBeginDate, 'YYYY-MM-DD').utc().valueOf()
                        : null,
                    strategyValidityEndDate: this.$calc.strategyValidityEndDate
                        ? moment(this.$calc.strategyValidityEndDate, 'YYYY-MM-DD').utc().valueOf()
                        : null,
                }
                : {}
            ),
        };
    }

    private getCalcFilterForSetupMaster(): CalcFilters {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectDataForSetupMaster();
        const allCheck = this.$setupMasterCalc.allCheck;
        const discountPrice = this.$setupMasterCalc.discountPrice;
        // const pennies = this.$setupMasterCalc.pennies;
        const countAtMaxPurchasePrice = this.$setupMasterCalc.countAtMaxPurchasePrice;
        const countAtFuturePurchasePrice = this.$setupMasterCalc.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = this.$setupMasterCalc.allNewPricesWithoutPennies;
        const allClaster = this.$setupMasterCalc.allClaster;
        const xyzChecked = this.$setupMasterCalc.xyzChecked;
        const uvwChecked = this.$setupMasterCalc.uvwChecked;
        const individualConfigsObj = Object.create(null);
        return {
            allCheck,
            discountPrise: discountPrice,
            // pennies,
            countAtLastPurchasePrice: false,
            countAtFuturePurchasePrice,
            // allNewPricesWithoutPennies,
            xyzChecked,
            uvwChecked,
            allClaster,
            coefficientK1: this.$setupMasterCalc.selectCoefficent.value.k1,
            coefficientK2: this.$setupMasterCalc.selectCoefficent.value.k2,
            category: this.$setupMasterCalc.categoryOfProduct,
            storeCluster: this.$setupMasterCalc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: this.$setupMasterCalc.uvwParams,
            spreadXYZParams: this.$setupMasterCalc.xyzParams,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$setupMasterCalc.formatSelected,
            tradingId: this.$setupMasterCalc.selectMarket.id,
            calculationDepth: +this.$setupMasterCalc.calculationDepth,
            correlation: this.$setupMasterCalc.correlation ? this.$setupMasterCalc.correlation : 0.7,
            highElasticity: this.$setupMasterCalc.highElasticity ? this.$setupMasterCalc.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.$setupMasterCalc.intervalOfUltimateElasticity,
            competitorsPricesParams: this.$setupMasterCalc.competitorsPrices,
            kviStrategy: this.$setupMasterCalc.kviStrategy.value,
            percentageOfCompetitorsPrice: this.$setupMasterCalc.percentageOfCompetitorsPrice,
            marginalProfitability: this.$setupMasterCalc.marginalProfitability,
            marginalProfit: this.$setupMasterCalc.marginalProfit,
            maxMarginalProfit: this.$setupMasterCalc.maxMarginalProfit != null ? this.$setupMasterCalc.maxMarginalProfit : 100,
            marginalPriceDifference: this.$setupMasterCalc.marginalPriceDifference,
            newProductLifespanInDays: this.$setupMasterCalc.newProductLifespanInDays,
            calculationDay: +this.$setupMasterCalc.calculationDay,
            priceCorridor: this.$setupMasterCalc.priceCorridor,
            changePriceCorridor: this.$setupMasterCalc.changePriceCorridor,
            priceIncreaseLimit: this.$setupMasterCalc.priceIncreaseLimit,
            fixLowerBorder: this.$setupMasterCalc.fixLowerBorder,
            individualCommonParams: individualConfigsObj,
            depthToPurchasePrice: this.$setupMasterCalc.depthToPurchasePrice,
            priceFamilies: this.$setupMasterCalc.priceFamilies,
            hardPriceFamilies: this.$setupMasterCalc.hardPriceFamilies,
            groupOfProduct: this.$setupMasterCalc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$setupMasterCalc.selectCoefficent.value.enum!,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$setupMasterCalc.subcategories)!!,

            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$setupMasterCalc.productSegments)!!,
            useCompetitorsPrices: this.$setupMasterCalc.useCompetitorsPrices,
            byPromoPrices: this.$setupMasterCalc.byPromoPrices,
            competitorsPricePeriod: this.$setupMasterCalc.competitorsPricePeriod,
            competitorsCodes: this.$setupMasterCalc.competitorsCodes,
            competitorsPriceMethod: this.$setupMasterCalc.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$setupMasterCalc.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$setupMasterCalc.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$setupMasterCalc.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$setupMasterCalc.competitorsMaximumProfit != null ? this.$setupMasterCalc.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$setupMasterCalc.competitorsControlParam,
            competitorsPriceStrategy: this.$setupMasterCalc.competitorsPriceStrategy.value,
            daysToPriceChangeStart: this.$setupMasterCalc.daysToPriceChangeStart && this.$setupMasterCalc.daysToPriceChangeStart > 0 
                ? this.$setupMasterCalc.daysToPriceChangeStart 
                : null,
            daysToPriceChangeFinish: this.$setupMasterCalc.daysToPriceChangeFinish && this.$setupMasterCalc.daysToPriceChangeFinish > 0 
                ? this.$setupMasterCalc.daysToPriceChangeFinish 
                : null,
            calculateByRegression: !this.$setupMasterCalc.calculateByElasticity,
            recalculateCtm: this.$setupMasterCalc.recalculateCtm,
            priceChangeLimit: this.$setupMasterCalc.priceChangeLimit,
            priceChangeLimitKvi: this.$setupMasterCalc.priceChangeLimitKvi,
            priceChangeLimitComp: this.$setupMasterCalc.priceChangeLimitComp,
            useBrutForcingParams: false,
            saveAfterOptimize: this.saveAfterOptimizeForSetupMaster,
            optimizationDiff: this.optimizationDiffForSetupMaster,
            calculatePYR: this.$setupMasterCalc.calculatePYR,
            periodPriceIncreaseLimit: this.$setupMasterCalc.periodPriceIncreaseLimit,
            period: this.$setupMasterCalc.period.value,
            decreaseSalesCount: this.$setupMasterCalc.decreaseSalesCount,
            newProductPriceStrategy: this.$setupMasterCalc.newProductPriceStrategy.value,
            priceGap: this.$setupMasterCalc.priceGap,
            priceGapCtmPc: this.$setupMasterCalc.priceGapCtmPc,
            findAutomaticallyPriceSegments: this.findAutomaticallyPriceSegmentsForSetupMaster,
            countPriceSegments: this.countPriceSegmentsForSetupMaster,
            promoCalc: false,
            percentageOfRecommendsKviCount: this.$setupMasterCalc.percentageOfRecommendsKviCount,
            saveKviSign: this.$setupMasterCalc.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.$setupMasterCalc.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.$setupMasterCalc.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.$setupMasterCalc.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$setupMasterCalc.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForDeleteCtmPurpose,
            // roundPricesWithEqualCompStrategy: this.$setupMasterCalc.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: this.$setupMasterCalc.calculateCompAllowedDeviation,
            useCompElasticity: this.$setupMasterCalc.useCompElasticity,
            minProfitKVI: this.$setupMasterCalc.minProfitKVI,
            maxProfitKVI: this.$setupMasterCalc.maxProfitKVI != null ? this.$setupMasterCalc.maxProfitKVI : 100,
            productRangesAndInternalCodes: this.productRangesArray,
            forecastAccuracy: this.$setupMasterCalc.forecastAccuracy,
            countAtMaxPurchasePrice,
            percentileType: this.$setupMasterCalc.percentileType.value,
            useAllProductBatchNumbers: this.$setupMasterCalc.useAllProductBatchNumbers,
            calcWithBatchNumber: true,
            competitorPriceControlParameterPc: this.$setupMasterCalc.competitorPriceControlParameterPc,
            countPriceBySkuWithoutBatches: this.$setupMasterCalc.countPriceBySkuWithoutBatches,
            countByAvgPurchasePrice: this.$setupMasterCalc.countByAvgPurchasePrice,
            calcPurchasePriceByClusters: this.$setupMasterCalc.calcPurchasePriceByClusters,
            useEmptyRemains: this.$setupMasterCalc.useEmptyRemains,
            useArrivalDate: this.$setupMasterCalc.useArrivalDate,
            thompsonSampling: this.$setupMasterCalc.thompsonSampling,
            priceDecreaseLimit: this.$setupMasterCalc.priceDecreaseLimit,
            kviPriceDecreaseLimit: this.$setupMasterCalc.kviPriceDecreaseLimit,
            compPriceDecreaseLimit: this.$setupMasterCalc.compPriceDecreaseLimit,
            backBasketPart: this.$setupMasterCalc.backBasketPart,
            revaluationCalculateParams: this.$setupMasterCalc.revaluationCalculateParams,
            checkMarginDeclineProfit: this.$setupMasterCalc.checkMarginDeclineProfit,
            declineProfitabilityPc: this.$setupMasterCalc.declineProfitabilityPc,
            searchPreviousPricesDepth: this.$setupMasterCalc.searchPreviousPricesDepth,
            compensateLowerTargets: this.$setupMasterCalc.compensateLowerTargets,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            isFixPricePromo: this.$setupMasterCalc.isFixPricePromo,
            spreadByPriceSegments: this.$setupMasterCalc.spreadByPriceSegments,
            priceExperiment: this.$setupMasterCalc.priceExperiment,
            priceExperimentSampleSize: this.$setupMasterCalc.priceExperimentSampleSize,
            priceExperimentDiscountRangeFrom: this.$setupMasterCalc.priceExperimentDiscountRangeFrom,
            priceExperimentDiscountRangeTo: this.$setupMasterCalc.priceExperimentDiscountRangeTo,
            priceExperimentStep: this.$setupMasterCalc.priceExperimentStep,
            priceExperimentStartDate: this.$setupMasterCalc.priceExperimentStartDate,
            priceExperimentEndDate: this.$setupMasterCalc.priceExperimentEndDate,
            ...(this.$setupMasterCalc.categoryStrategy && this.$setupMasterCalc.categoryStrategy.value !== CategoryStrategies.EMPTY
                ? {
                    strategyValidityBeginDate: this.$setupMasterCalc.strategyValidityBeginDate
                        ? moment(this.$setupMasterCalc.strategyValidityBeginDate, 'YYYY-MM-DD').utc().valueOf()
                        : null,
                    strategyValidityEndDate: this.$setupMasterCalc.strategyValidityEndDate
                        ? moment(this.$setupMasterCalc.strategyValidityEndDate, 'YYYY-MM-DD').utc().valueOf()
                        : null,
                }
                : {}
            ),
        };
    }

    private getSkuFilter(): SkuFilter {
        const productSegments = this.selectProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];
        const [selectSeasons, selectRegions, selectBuyerSegment, ctm, priceSegments] = this.selectData();
        return {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.skuFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortBySKU,
            kvi: this.selectKVI,
            ctm,
            priceSegments,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.skuListWithCalculating,
            needCalculateSkuLastPricesOnly: this.needCalculateSkuLastPricesOnly,
            needCalculateSkuActualProfitabilityOnly: this.needCalculateSkuActualProfitabilityOnly,
            kviRecommendation: this.selectKVIRecommends,
            productSegments: LocalData.filterNumberArrays(productSegments),
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOne,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwo,
            keyCharacteristicOfTheProductIsThree: this.selectKeyCharacteristicThree,
            keyCharacteristicOfTheProductIsFour: this.selectKeyCharacteristicFour,
            keyCharacteristicOfTheProductIsFive: this.selectKeyCharacteristicFive,
            recipeAttributes: this.selectRecipeAttributes,
            treatmentAttributes: this.selectTreatmentAttributes,
            alwaysCalculateProductSegments: true,
            countAtLastPurchasePrice: this.$calc.countAtLastPurchasePrice,
            productRangeFilter: this.selectProductLine,
            internalCodeFilterText: this.internalCodeFilterText,
            countAtMaxPurchasePrice: this.$calc.countAtMaxPurchasePrice,
        };
    }

    private getCtmSkuFilter(): SkuFilter {
        const productSegments = this.selectProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];
        const [selectSeasons, selectRegions, selectBuyerSegment, ctm, priceSegments] = this.selectData();
        return {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.ctmSkuFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortBySKU,
            kvi: this.selectKVI,
            ctm,
            priceSegments,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.skuListWithCalculating,
            needCalculateSkuLastPricesOnly: this.needCalculateSkuLastPricesOnly,
            needCalculateSkuActualProfitabilityOnly: this.needCalculateSkuActualProfitabilityOnly,
            kviRecommendation: this.selectKVIRecommends,
            productSegments: LocalData.filterNumberArrays(productSegments),
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOne,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwo,
            keyCharacteristicOfTheProductIsThree: this.selectKeyCharacteristicThree,
            keyCharacteristicOfTheProductIsFour: this.selectKeyCharacteristicFour,
            keyCharacteristicOfTheProductIsFive: this.selectKeyCharacteristicFive,
            recipeAttributes: this.selectRecipeAttributes,
            treatmentAttributes: this.selectTreatmentAttributes,
            alwaysCalculateProductSegments: true,
            countAtLastPurchasePrice: this.$calc.countAtLastPurchasePrice,
            productRangeFilter: this.selectProductLine,
            internalCodeFilterText: this.internalCodeFilterText,
            countAtMaxPurchasePrice: this.$calc.countAtMaxPurchasePrice,
        };
    }

    private getSkuFilterForSetupMaster(): SkuFilter {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectDataForSetupMaster();
        return {
            category: this.$setupMasterCalc.categoryOfProduct,
            storeCluster: this.$setupMasterCalc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$setupMasterCalc.formatSelected,
            tradingId: this.$setupMasterCalc.selectMarket.id,
            calculationDepth: this.$setupMasterCalc.calculationDepth,
            calculationDay: this.$setupMasterCalc.calculationDay,
            skuFilter: '',
            groupOfProduct: this.$setupMasterCalc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$setupMasterCalc.subcategories)!!,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$setupMasterCalc.productSegments)!!,
            discountPrise: false,
            promo: false,
            priceCorridor: this.$setupMasterCalc.priceCorridor,
            changePriceCorridor: this.$setupMasterCalc.changePriceCorridor,
            alwaysCalculateProductSegments: true,
            countAtLastPurchasePrice: this.$setupMasterCalc.countAtLastPurchasePrice,
            countAtMaxPurchasePrice: this.$setupMasterCalc.countAtMaxPurchasePrice,
        };
    }

    private getNewProductsSkuFilter(): SkuFilter {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const ctm: string | null = this.selectCTMForNewProducts === 'all' ? null : this.selectCTMForNewProducts;
        this.selectSegmentPriceForNewProducts = this.selectSegmentPriceForNewProducts.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPriceForNewProducts.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });

        const newProductSegments = this.selectNewProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];

        return {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            kvi: this.selectKVIForNewProducts,
            ctm,
            priceSegments,
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOneForNewProduct,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwoForNewProduct,
            keyCharacteristicOfTheProductIsThree: this.selectKeyCharacteristicThreeForNewProduct,
            keyCharacteristicOfTheProductIsFour: this.selectKeyCharacteristicFourForNewProduct,
            keyCharacteristicOfTheProductIsFive: this.selectKeyCharacteristicFiveForNewProduct,
            recipeAttributes: this.selectRecipeAttributesForNewProduct,
            treatmentAttributes: this.selectTreatmentAttributesForNewProduct,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.newProductsWithCalculating,
            productSegments: LocalData.filterNumberArrays(newProductSegments),
            alwaysCalculateProductSegments: true,
        };
    }

    private getCompetitorsFilter(kviAndCtmFromCompetitorsTable: boolean = false): CompetitorsPriceFilter {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const ctm: string | null = this.selectedCtmFilter === 'all' ? null : this.selectedCtmFilter;
        return {
            discountPrise: this.$calc.discountPrice,
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: +this.$calc.calculationDepth,
            calculationDay: +this.$calc.calculationDay,
            skuFilter: this.skuFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments)!!,
            competitorsPricePeriod: this.$calc.competitorsPricePeriod,
            promo: false,
            sortBySKU: this.sortCompetitorsBySKU,
            kvi: kviAndCtmFromCompetitorsTable ? this.competitorsTableFilterValues['kviValue'] : this.selectedKviFilter,
            ctm: kviAndCtmFromCompetitorsTable ? (this.competitorsTableFilterValues['ctmValue']  === 'all' ? null : this.competitorsTableFilterValues['ctmValue']) : ctm,
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOneForCompetitors,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwoForCompetitors,
            needCalculateSku: this.competitorsWithCalculating,
            sortingField: this.sortingField,
            isKviCartCompetitorsGrid: false,
            skuNames: this.competitorsTableFilterValues['skuNames'],
            competitors: this.competitorsTableFilterValues['competitors'],
            competitorCodes: this.competitorsTableFilterValues['competitorCodes'],
            competitorPriorities: this.competitorsTableFilterValues['competitorPriorities'],
            lastPrices: this.competitorsTableFilterValues['lastPrices'],
            promoPrices: this.competitorsTableFilterValues['promoPrices'],
            competitorPrices: this.competitorsTableFilterValues['competitorPrices'],
            keyCharacteristicsOfTheProductIsOnes: this.competitorsTableFilterValues['keyCharacteristicsOfTheProductIsOnes'],
            keyCharacteristicsOfTheProductIsTwos: this.competitorsTableFilterValues['keyCharacteristicsOfTheProductIsTwos'],
            priceDates: this.competitorsTableFilterValues['priceDates'],
            deltas: this.competitorsTableFilterValues['deltas'],
            internalCodes: this.competitorsTableFilterValues['internalCodes'],
        };
    }

    private refreshDetailTable() {
        const oldRefreshId = this.refreshCodeOKRBTableId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshCodeOKRBTableId === timeoutId) {
                const detailTable = this.$refs.codeOKRBTable as any;
                if (typeof detailTable !== 'undefined') {
                    this.loadCodesOKRB()
                    detailTable.refresh();
                }
                this.refreshCodeOKRBTableId = -1;
            }
        }, 250);
        this.refreshCodeOKRBTableId = timeoutId;
    }

    private getObjectValueOrDefault(item: any, key: string = 'value', defaultValue: any = null, returnStrong: boolean = false) {
        if (typeof item === 'object' && item !== null) {
            if (item[key] || returnStrong) {
                return item[key];
            } else {
                return defaultValue;
            }
        } else {
            return returnStrong ? item : item || defaultValue;
        }
    }

    getCheckboxGroupOptions(filterOptionsKey: keyof ICompetitorPricesFilterOptions) {
        return (this.competitorsTableFilterOptions[filterOptionsKey] as (string | number)[]).map((el: string | number) => ({
            label: filterOptionsKey !== 'optionPriceDates'
                ? String(el)
                : new Date(el).toLocaleDateString(),
            value: el,
        }));
    }

    handleModelChanged(filterModelKey: string) {
        if (filterModelKey === 'competitors') {
            this.needFetchCompetitorCodes = true;
        }
    }
}
